<template>
  <div v-if="stageContenttData.postData.showBlock" class="flex mb-2">
    <div class="w-3/4 flex-1 bg-white rounded-xl space-y-6 p-6" style="position:relative">
      <loading :active="!MaterialShowMaterialMyside"
              :can-cancel="true"
              :on-cancel="onCancel"
              :is-full-page="false"
              :color="'#fff'"
              :background-color="'#000'"
              :opacity="'0.8'"
              :loader=" dots">
      </loading>
      <div class="bg-gray-100 rounded-lg p-2">
        <span v-if="goalsObjectiveData == 'MESSAGES'" class="text-red-500 text-sm">*</span>
        <span v-if="goalsObjectiveData != 'MESSAGES'" class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['Material']['title']}}</span>
        <span v-if="goalsObjectiveData == 'MESSAGES'" class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['Material']['message_title']}}</span>
        <button
          v-if="!editPageType"
          id="material"
          class="hover:bg-gray-200 focus:outline-none rounded-xl px-2 py-0.5 ml-2 mx-auto text-gray-400 transition duration-500 ease-in-out border-2 text-xs"
          @click="teachVideo()"
        >
          {{lang['components']['Event']['Material']['video_teaching']}}
        </button>
        <!-- <i
          v-if="goalsObjectiveData == 'MESSAGES'"
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2 leading-relaxed"
          v-tooltip="`${lang['components']['Event']['Material']['message_title_info']}`"
        ></i> -->
        <div v-show="stageIndex != 0 && _useStatus == true" class="float-right">
          <i
            class="pi pi-exclamation-circle align-middle text-gray-300 mr-2 leading-relaxed "
            v-tooltip.left="'開啟套用前階段設定，會將所有互動數據累積至同一個素材下，需與前階段設定相同目標，才可套用'"
          ></i>
          <span class="text-sm mr-2">套用前階段設定</span>
          <InputSwitch v-model="stageContenttData.postData.ditto_creative" class="-my-1" :disabled="editPageType" />
        </div>
      </div>
      <div v-show="stageMaterialStatus == 'true' && stageContenttData.method != 'META_TEST'" class="grid grid-cols-2 gap-8">
        <div class="space-y-2 border p-2 rounded-md" :class="{ 'ring-4 border-blue-400': guideStep === 11001 }">
          <div>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Material']['optimize_title']}}</span>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2 leading-relaxed"
              v-tooltip="`${lang['components']['Event']['Material']['optimize_info']}`"
            ></i>
            <div class="text-grap-700 text-sm ml-2 mt-1 float-right">
              <InputSwitch v-model="stageContenttData.postData.creative_optimize" :disabled="stageContenttData.postData.disabled_creative_optimize" class="-my-1" />
            </div>
          </div>
        </div>
      </div>

      <div v-show="stageMaterialStatus == 'true'" class="flex-1 space-y-4">
        <div class="space-y-2 pb-8">
          <div>
            <span v-if="goalsObjectiveData != 'MESSAGES'" class="text-red-500 text-sm">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['Material']['ad_content_title']}}</span>
            <i
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip="`${lang['components']['Event']['Material']['title_info']}`"
            ></i>
          </div>
          <div v-if="this.goalsObjectiveData != 'PRODUCT_CATALOG_SALES'">
            <span v-if="!editPageType">
              <button
                v-if="goalsObjectiveData != 'MESSAGES'"
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                @click="add_test()"
              >
                <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                {{lang['components']['Event']['Material']['add_ad_text']}}
              </button>
              <!-- 新手教學 -->
              <button
                v-if="goalsObjectiveData == 'MESSAGES'"
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                @click="scroll_messages()"
              >
                {{lang['components']['Event']['Material']['add_ad_text']}}
              </button>
              <button
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
                :class="{ 'ring-4 border-blue-400': guideStep === 52 }"
                @click="posts_data()"
              >
                {{lang['components']['Event']['Material']['posts_data_text']}}
              </button>
              <button
                class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
                @click="creatives_data()"
              >
                {{lang['components']['Event']['Material']['creatives_data']}}
              </button>
            </span>
          </div>
          <div v-if="this.goalsObjectiveData == 'PRODUCT_CATALOG_SALES'">
            <button
              class="text-sm border border-blue-700 text-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
              :class="{ 'ring-4 border-blue-400': guideStep === 501 }"
              @click="adset_ads_data()"
            >
              {{lang['components']['Event']['Material']['adset_ads']}}
            </button>
          </div>
          <!-- 新手教學 -->
          <div class="flex flex-col space-y-2 h-96 overflow-y-auto" :class="{ 'ring-4 border-blue-400': guideStep === 57 }">
            <!-- <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-blue-400"
              :class="{ 'border-blue-400': item.checked }"
              v-for="(item, index) in items"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_focus(item.content)"
            > -->
            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.select_article"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5 }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_focus(item.content)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">FaceBook Post</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">FaceBook Post</span> -->
                    </div>
                  </div>
                </div>
                1
                <i
                  v-if="item.tagType != 5 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_list(index)"
                ></i>
              </div>
            </div>

            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.delete_article"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5 }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_focus(item.content)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">FaceBook Post</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">FaceBook Post</span> -->
                    </div>
                  </div>
                </div>
                2
                <i
                  v-if="item.tagType == 1 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_item(index)"
                ></i>
              </div>
            </div>

            <!-- <div
              v-for="(item, index) in viewDatalistData.select_creatives"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-blue-400"
              :class="{'status-n': item.status == 'N'}"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            > -->
            <div
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.select_creatives"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                3
                <i
                  v-if="item.status == 'N'"
                  class="absolute top-2 right-8 pi pi-pencil cursor-pointer"
                  @click="edit_creatives_list(index)"
                ></i>
                <i
                  v-if="item.tagType != 5 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_creatives_list(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.delete_creatives"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                4
                <i
                  v-if="item.tagType == 1 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_creatives_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_creatives_item(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.select_creatives_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                5
                <i
                  v-if="item.tagType != 5 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_creatives_message_list(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.delete_creatives_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_creatives_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['creatives_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                6
                <i
                  v-if="item.tagType == 1 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_creatives_message_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_creatives_message_item(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.select_creatives_adset_ads_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告</span> -->
                    </div>
                  </div>
                </div>
                7
                <i
                  v-if="item.tagType != 5 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_adset_ads_message_list(index)"
                ></i>
              </div>
            </div>

            <div
              v-if="goalsObjectiveData == 'MESSAGES'"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.delete_adset_ads_message"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_message_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告</span> -->
                    </div>
                  </div>
                </div>
                8
                <i
                  v-if="item.tagType == 1 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_adset_ads_message_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_adset_ads_message_item(index)"
                ></i>
              </div>
            </div>

            <!-- <div
              v-for="(item, index) in viewDatalistData.select_creatives_adset_ads"
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-blue-400"
              :class="{'status-n': item.status == 'N'}"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            > -->
            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.select_creatives_adset_ads"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                9
                <i
                  v-if="item.tagType != 5 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_adset_ads_list(index)"
                ></i>
              </div>
            </div>

            <div
              class="bg-white rounded-xl border-2 p-1 w-full cursor-pointer hover:border-yellow-300 group"
              v-for="(item, index) in stageContenttData.postData.delete_creatives_adset_ads"
              :class="{ 'border-blue-400': item.tagType == 3, 'border-green-400': item.tagType == 4, 'border-red-400': item.tagType == 5, 'status-n': item.status == 'N' }"
              :key="index"
              @click="item.checked = !item.checked"
              @mouseover="prview_adset_ads_focus(item.item_id)"
              v-tooltip.top="`${item.message}`"
            >
              <div
                v-if="item.tagType == 1"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_create']}}
              </div>
              <div
                v-if="item.tagType == 2"
                class="text-center text-xs bg-gray-200 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg group-hover:bg-yellow-300 "
              >
                {{lang['components']['Event']['Material']['tag_status_delete']}}
              </div>
              <div
                v-if="item.tagType == 3"
                class="text-center text-xs bg-blue-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_test']}}
              </div>
              <div
                v-if="item.tagType == 4"
                class="text-center text-xs bg-green-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_good']}}
              </div>
              <div
                v-if="item.tagType == 5"
                class="text-center text-xs bg-red-400 -ml-1 -mt-1 -mr-1 mb-1  rounded-t-lg text-white group-hover:bg-yellow-300  group-hover:text-black"
              >
                {{lang['components']['Event']['Material']['tag_status_bad']}}
              </div>
              <div class="relative flex justify-between p-1">
                <div class="md:flex-shrink-0">
                  <img
                    class="h-24 w-24 rounded-xl object-cover"
                    :src="item.imgSrc"
                  />
                </div>
                <div class="relative flex-grow flex flex-col px-2">
                  <p class="flex-none flex text-lg overflow-hidden">
                    <span style="width:70%;">{{ item.title }}</span>
                    <span class="w-1/3 mr-4">{{lang['components']['Event']['Material']['adset_ads_type']}}</span>
                  </p>
                  <p class="flex-grow text-gray-500 overflow-hidden">
                    {{ item.content }}
                  </p>
                  <div class="flex-none flex">
                    <img src="../../assets/great.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.great }}</span>
                    <img src="../../assets/heart.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.heart }}</span>
                    <img src="../../assets/smile.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.smile }}</span>
                    <img src="../../assets/cry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.cry }}</span>
                    <img src="../../assets/shock.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.shock }}</span>
                    <img src="../../assets/angry.svg" class="w-6 h-6" />
                    <span class="pl-1 pr-4">{{ item.angry }}</span>

                    <div class="flex-grow text-right text-gray-500">
                      <span>{{ item.date }}</span>
                      <!-- <span class="ml-2">廣告貼文</span> -->
                    </div>
                  </div>
                </div>
                10
                <i
                  v-if="item.tagType == 1 && !editPageType"
                  class="absolute top-2 right-2 pi pi-times cursor-pointer"
                  @click="remove_delete_adset_ads_list(index)"
                ></i>
                <i
                  v-if="item.tagType == 2"
                  class="absolute top-2 right-2 pi pi-undo cursor-pointer"
                  @click="back_adset_ads_item(index)"
                ></i>
              </div>
            </div>



          </div>
        </div>
      </div>

      <!-- 自訂素材-->

      <!-- <div v-show="stageAdvertisingMaterial == 'true'" class="bg-gray-100 rounded-lg p-2">
        <span v-if="goalsObjectiveData != 'MESSAGES'" class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMaterial']['title']}}</span>
        <span v-if="goalsObjectiveData == 'MESSAGES'" class="font-bold text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMaterial']['message_title']}}</span>
        <i
          v-if="goalsObjectiveData == 'MESSAGES'"
          class="pi pi-exclamation-circle align-middle text-gray-300 ml-2 leading-relaxed"
          v-tooltip="`${lang['components']['Event']['Material']['message_title_info']}`"
        ></i>
      </div> -->
      <div v-show="stageAdvertisingMaterial == 'true'" class="flex-1 space-y-4 tab overflow-hidden">
        <div v-if="goalsObjectiveData != 'MESSAGES'" class="space-y-2" :class="{ 'border-4 border-blue-300': guideStep === 5801 }">
          <div class="flex">
            <div class="leading-relaxed">
              <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['optimize_title']}}</span>
            </div>
            <div class="text-grap-700 text-sm ml-2 mt-1">
              <InputSwitch v-model="stageContenttData.adMaterialData.creative_optimize" :disabled="stageContenttData.adMaterialData.disabled_creative_optimize" class="-my-1" />
              <span class="mx-1">{{lang['components']['Event']['AdvertisingMaterial']['optimize_switch']}}</span>
            </div>
            <i
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2 leading-relaxed"
              v-tooltip="`${lang['components']['Event']['AdvertisingMaterial']['optimize_info']}`"
            ></i>
          </div>
        </div>
        <div class="space-y-2 pb-8">
          <div>
            <span v-if="goalsObjectiveData != 'MESSAGES'" class="text-red-500 text-sm">*</span>
            <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['ad_content_title']}}</span>
            <i
              v-if="goalsObjectiveData != 'MESSAGES'"
              class="pi pi-exclamation-circle align-middle text-gray-300 ml-2"
              v-tooltip="`${lang['components']['Event']['AdvertisingMaterial']['title_info']}`"
            ></i>
          </div>
          <!-- 新手教學 -->
          <div class="flex scrollbar-x" :class="{ 'ring-4 border-blue-400': guideStep === 59 }">
            <div
              v-for="(item, index) in viewAdMaterialDatalistData.creative_array"
              :key="index"
              @click="adContent(index)"
            >
              <div v-if="editPageType" class="bg-white -mb-1.5 text-left">
                <span v-if="item.tagType == 0" class="block bg-white rounded-t-md font-bold" style="height:24px;"></span>
                <span
                  v-if="item.tagType == 3"
                  class="text-center text-xs pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-blue-400'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_test']}}</span>
                <span
                  v-if="item.tagType == 4"
                  class="text-center text-xs pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-green-400'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_good']}}</span>
                <span
                  v-if="item.tagType == 5"
                  class="text-center text-xs bg-red-400 pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-red-400'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_bad']}}</span>
                <span
                  v-if="item.tagType == 1"
                  class="text-center text-xs bg-gray-100 pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-gray-100'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_create']}}</span>
                <span
                  v-if="item.tagType == 2"
                  class="text-center text-xs bg-gray-100 pl-1.5 pt-1 pr-1.5 pb-0.5 rounded-t-md font-bold"
                  :class="[
                    currentTab === index? 'bg-yellow-300 text-blue-700' : 'bg-gray-100'
                  ]"
                >{{lang['components']['Event']['AdvertisingMaterial']['tag_status_delete']}}</span>
              </div>

              <div
                class="flex px-4 py-2 cursor-pointer bg-gray-100 whitespace-nowrap"
                :class="[
                  currentTab === index? 'bg-yellow-300 text-blue-700' :
                  item.tagType == 3? 'bg-blue-400':
                  item.tagType == 4? 'bg-green-400':
                  item.tagType == 5? 'bg-red-400': 'bg-gray-100'
                ]"
              >
                <p v-if="!item.isEdit" class="flex-none truncate w-24">
                  {{ item.title ? item.title : lang['components']['Event']['AdvertisingMaterial']['ad_name'] }}
                </p>

                <!-- <input
                  v-if="item.isEdit"
                  :disabled="editPageType && returnCampaignObjectiveData != 'LEAD_GENERATION'"
                  v-model="item.title"
                  class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                  type="text"
                  placeholder="請填寫廣告名稱"
                  v-on:keyup="isChangeData()"
                /> -->
                <input
                  v-if="item.isEdit"
                  v-model="item.title"
                  class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                  type="text"
                  :placeholder="lang['components']['Event']['AdvertisingMaterial']['ad_name_info']"
                  v-on:keyup="isChangeData()"
                />
                <!-- 新手教學 -->
                <i
                  v-if="currentTab === index"
                  @click="item.isEdit = !item.isEdit"
                  class="pi pi-pencil mt-2 ml-2"
                  :class="{ 'ring-4 border-blue-400': guideStep === 59 }"
                  style="fontSize: 0.8rem"
                ></i>
              </div>
            </div>
            <div class="px-4 py-2 cursor-pointer" :class="{'mt-5' : editPageType}" @click="addItem()">
              <!-- 新手教學 -->
              <i class="pi pi-plus" style="fontSize: 0.8rem" :class="{ 'ring-4 border-blue-400': guideStep === 61 }"></i>
            </div>
          </div>
          <!-- <div class="flex text-gray-500">
            <div
              class="px-4 py-2 cursor-pointer bg-gray-100"
              :class="{
                'bg-yellow-300': currentTab === index
              }"
              v-for="(item, index) in items"
              :key="index"
              @click="adContent(index)"
            >
              <span v-if="!item.isEdit">{{ item.title }}</span>

              <input
                v-if="item.isEdit"
                v-model="item.title"
                class="p-inputtext p-component py-0 w-40 underline-box border-show bg-transparent"
                type="text"
                placeholder="廣告"
              />
              <i
                v-if="currentTab === index"
                @click="item.isEdit = !item.isEdit"
                class="pi pi-pencil ml-2"
                style="fontSize: 0.8rem"
              ></i>
            </div>
            <div class="px-4 py-2 cursor-pointer" @click="addItem()">
              <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
            </div>
          </div> -->
          <TabView v-model:activeIndex="currentTab">
            <template v-for="(item, index) in viewAdMaterialDatalistData.creative_array" :key="index">
              <TabPanel>
                <template #hearder>
                  <div></div>
                </template>
                <div class="space-y-2 pb-8 my-4">
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['format_info']}}</span>
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <div>
                    <!-- 新手教學 -->
                    <button
                      class="text-sm border border-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1"
                      :class="[
                        item.type == 1 ? 'bg-blue-700' : 'bg-white',
                        item.type == 1 ? 'text-white' : 'text-blue-700',
                        guideStep === 63 ? 'ring-4 border-blue-400' : null
                      ]"
                      @click="changeType(index, 1)"
                    >
                      <i class="pi pi-image mr-3" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AdvertisingMaterial']['single_material']}}
                    </button>
                    <!-- 新手教學 -->
                    <button
                      class="text-sm border border-blue-700 hover:bg-blue-700 hover:text-white rounded-md px-4 py-1 ml-4"
                      :class="[
                        item.type == 2 ? 'bg-blue-700' : 'bg-white',
                        item.type == 2 ? 'text-white' : 'text-blue-700',
                        guideStep === 63 ? 'ring-4 border-blue-400' : null
                      ]"
                      @click="changeType(index, 2)"
                    >
                      <i class="pi pi-images" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AdvertisingMaterial']['carousel_material']}}
                    </button>
                    <!-- 新手教學 -->
                    <button
                      v-if="item.tagType != 5 && item.tagType != 2"
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 ml-4 float-right"
                      :class="{ 'ring-4 border-blue-400': guideStep === 62 }"
                      @click="removeAd(index)"
                    >
                      {{lang['components']['Event']['AdvertisingMaterial']['delete_material']}}
                    </button>
                    <button
                      v-if="item.tagType == 2"
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 ml-4 float-right"
                      :class="{ 'ring-4 border-blue-400': guideStep === 62 }"
                      @click="backAd(index)"
                    >
                      {{lang['components']['Event']['AdvertisingMaterial']['regain_material']}}
                    </button>
                  </div>
                  <hr />
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 1" style="position:relative">
                  <loading :active="!showMaterialSingle"
                          :can-cancel="true"
                          :on-cancel="onCancel"
                          :is-full-page="false"
                          :color="'#fff'"
                          :background-color="'#000'"
                          :opacity="'0.8'"
                          :loader=" dots">
                  </loading>
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_setting']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <!-- 新手教學 -->
                  <div :class="{ 'ring-4 border-blue-400': guideStep === 64 }">
                    <button
                      v-on:click="getImageVideoList(item.type, 0)"
                      class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                      v-if="item.materialSingle.length == 0"
                    >
                      <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                      {{lang['components']['Event']['AdvertisingMaterial']['add_material']}}
                    </button>
                    <div
                      v-for="(itemSingle, i) in item.materialSingle"
                      :key="i"
                      class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                    >
                      <div class="flex p-1">
                        <div class="md:flex-shrink-0">
                          <img
                            class="h-24 w-24 rounded-xl object-cover"
                            :src="itemSingle.imgSrc"
                          />
                        </div>
                        <div class="mx-8">
                          <p class="text-gray-800 text-sm">
                            {{ itemSingle.fileName ? itemSingle.fileName : "" }}
                            <template v-for="(_tmp_object_spec, obj_index) in itemSingle.object_spec">
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'image'">
                                {{lang['components']['Event']['AdvertisingMaterial']['material_type_image']}}
                              </template>
                              <template v-if="obj_index == 'type' && _tmp_object_spec == 'video'">
                                {{lang['components']['Event']['AdvertisingMaterial']['material_type_video']}}
                              </template>
                            </template>
                          </p>
                          <p class="text-gray-500 text-sm">{{ itemSingle.size }}</p>
                          <button
                            class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                            v-on:click="getImageVideoList(item.type, 0)"
                          >
                            {{lang['components']['Event']['AdvertisingMaterial']['change_material']}}
                          </button>
                          <button
                            class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4 ml-4"
                            v-on:click="editAiPicture"
                          >
                            AI圖片生成
                          </button>
                        </div>
                      </div>
                      <!-- <i class="pi pi-times cursor-pointer text-right m-2"></i> -->
                    </div>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4" v-if="item.type == 2">
                  <div>
                    <!-- <span class="text-red-500">*</span> -->
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['carousel_card']}}</span
                    >
                    <!-- <i class="pi pi-exclamation-circle align-middle text-gray-300 ml-2" v-tooltip.top="'格式'"></i> -->
                  </div>
                  <!-- 新手教學 -->
                  <div :class="{ 'ring-4 border-blue-400': guideStep === 68 }">
                    <draggable
                      v-if="item.materials.length"
                      v-model="item.materials"
                      :disabled="isEdit"
                      @start="drag = true"
                      @end="drag = false"
                      item-key="id"
                    >
                      <template #item="{ element }" >
                        <div
                          class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                        >
                          <div class="flex justify-between ">
                            <div class="flex p-1">
                              <!-- 新手教學 -->
                              <div class="my-auto -ml-2" :class="{ 'ring-4 border-blue-400': guideStep === 69 }">
                                <i
                                  class="pi pi-ellipsis-v"
                                  style="fontSize: 1.3rem"
                                ></i>
                                <i
                                  class="pi pi-ellipsis-v -ml-2"
                                  style="fontSize: 1.3rem"
                                ></i>
                              </div>
                              <div class="md:flex-shrink-0">
                                <img
                                  class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                                  v-if="element.imgSrc"
                                  :src="element.imgSrc"
                                  @click="element.isEdit = !element.isEdit"
                                />
                                <div
                                  v-else
                                  class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                                  @click="element.isEdit = !element.isEdit"
                                >
                                  <i
                                    class="pi pi-plus my-7"
                                    style="fontSize: 2rem"
                                  ></i>
                                </div>
                              </div>
                              <div class="mx-8 my-auto">
                                <p class="text-gray-800 text-sm">
                                  <template v-if="element.object_spec.title != ''">
                                    {{element.object_spec.title}}
                                  </template>
                                  <template v-if="element.object_spec.name != ''">
                                    {{element.object_spec.name}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'image'">
                                    {{lang['components']['Event']['AdvertisingMaterial']['material_type_image']}}
                                  </template>
                                  <template v-if="element.object_spec.type == 'video'">
                                    {{lang['components']['Event']['AdvertisingMaterial']['material_type_video']}}
                                  </template>
                                </p>
                                <p class="text-gray-500 text-sm">
                                  <span v-if="element.title != ''" class="truncate w-20">
                                    {{ element.title }}
                                  </span>
                                  <span v-if="element.title == ''" class="w-20">
                                    {{lang['components']['Event']['AdvertisingMaterial']['not_title']}}
                                  </span>
                                   -
                                   <span v-if="element.description != ''" class="truncate w-20">
                                    {{ element.description }}
                                  </span>
                                  <span v-if="element.description == ''" class="w-20">
                                    {{lang['components']['Event']['AdvertisingMaterial']['not_description']}}
                                  </span>
                                  <!--  -
                                   <span v-if="element.website != ''" class="truncate w-20">
                                    {{ element.website }}
                                  </span>
                                  <span v-if="element.website == ''" class="w-20">
                                    無網址
                                  </span> -->
                                </p>
                              </div>
                            </div>
                            <!-- 新手教學 -->
                            <div class="flex flex-col">
                              <i
                                v-if="item.materials.length > 2"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                              <i
                                class="pi cursor-pointer my-auto text-right mx-2 text-blue-400"
                                :class="[element.isEdit ? 'pi-angle-up' : 'pi-pencil', guideStep === 70 ? 'ring-4 border-blue-400' : null ]"
                                style="fontSize: 1.2rem"
                                @click="element.isEdit = !element.isEdit"
                              ></i>
                            </div>
                          </div>
                          <div
                            class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                            v-show="element.isEdit"
                            style="position:relative"
                          >
                          <loading :active="!showMaterial"
                                  :can-cancel="true"
                                  :on-cancel="onCancel"
                                  :is-full-page="false"
                                  :color="'#fff'"
                                  :background-color="'#000'"
                                  :opacity="'0.8'"
                                  :loader=" dots">
                          </loading>
                            <div
                              class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                              v-if="element.imgSrc"
                            >
                              <div class="flex p-1">
                                <div class="md:flex-shrink-0">
                                  <img
                                    class="h-24 w-24 rounded-xl object-cover"
                                    :src="element.imgSrc"
                                  />
                                </div>
                                <div class="mx-8">
                                  <p class="text-gray-800 text-sm">
                                    <template v-if="element.object_spec.title != ''">
                                      {{element.object_spec.title}}
                                    </template>
                                    <template v-if="element.object_spec.name != ''">
                                      {{element.object_spec.name}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'image'">
                                      {{lang['components']['Event']['AdvertisingMaterial']['material_type_image']}}
                                    </template>
                                    <template v-if="element.object_spec.type == 'video'">
                                      {{lang['components']['Event']['AdvertisingMaterial']['material_type_video']}}
                                    </template>
                                  </p>
                                  <p class="text-gray-500 text-sm">{{element.object_spec.width}}*{{element.object_spec.height}}</p>
                                  <button
                                    class="text-sm border border-blue-400 bg-blue-400 text-white rounded-md px-4 py-1 mt-4"
                                    v-on:click="getImageVideoList(item.type, element.index)"
                                  >
                                    {{lang['components']['Event']['AdvertisingMaterial']['change_material']}}
                                  </button>
                                  <button
                                    class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4 ml-4"
                                    v-on:click="editAiPicture"
                                  >
                                    AI圖片生成
                                  </button>
                                </div>
                              </div>
                              <i
                                v-if="false"
                                class="pi pi-times cursor-pointer text-right m-2"
                                @click="removeItem(currentTab, element.index)"
                              ></i>
                            </div>
                            <!-- 新手教學 -->
                            <div v-else>
                              <button
                                v-on:click="getImageVideoList(item.type, element.index)"
                                class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                                :class="{ 'ring-4 border-blue-400': guideStep === 71 }"
                              >
                                <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                                {{lang['components']['Event']['AdvertisingMaterial']['add_material']}}
                              </button>
                              <button
                                class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4 ml-4"
                                v-on:click="editAiPicture"
                              >
                                AI圖片生成
                              </button>
                            </div>
                            <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['AdvertisingMaterial']['material_title']}}</span
                              >
                              <button
                                class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                                @click="useAi($event, 'carousel_title', index, element.index)"
                              >
                                AI生成
                              </button><br/>
                              <input
                                class="px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                style="width: 480px;"
                                :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_title_placeholder']"
                                v-model="element.title"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >{{lang['components']['Event']['AdvertisingMaterial']['material_description']}}</span
                              >
                              <button
                                class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                                @click="useAi($event, 'carousel_description', index, element.index)"
                              >
                                AI生成
                              </button><br/>
                              <input
                                class="px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                style="width: 480px;"
                                :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_description_placeholder']"
                                v-model="element.description"
                                v-on:keyup="isChangeData()"
                                v-on:focus="lock()"
                                v-on:blur="unlock()"
                              />
                            </div>
                            <!-- <div>
                              <span class="text-grap-700 align-middle text-sm"
                                >網站網址</span
                              >
                              <input
                                class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                                type="text"
                                placeholder="請輸入網站網址"
                                :disabled="editPageType"
                                v-model="element.website"
                                v-on:keyup="isChangeData()"
                              />
                            </div> -->
                          </div>
                        </div>
                      </template>
                    </draggable>

                    <!-- <div
                      class="bg-white bg-blue-100 rounded-xl border overflow-hidden p-4 w-full hover:border-grap-400 mt-4 space-y-2"
                      v-for="(material, materIndex) in item.materials"
                      :key="materIndex"
                    >
                      <div class="flex justify-between ">
                        <div class="flex p-1">
                          <div class="my-auto -ml-2">
                            <i
                              class="pi pi-ellipsis-v"
                              style="fontSize: 1.3rem"
                            ></i>
                            <i
                              class="pi pi-ellipsis-v -ml-2"
                              style="fontSize: 1.3rem"
                            ></i>
                          </div>
                          <div class="md:flex-shrink-0">
                            <img
                              class="h-24 w-24 rounded-xl object-cover cursor-pointer"
                              v-if="material.imgSrc"
                              :src="material.imgSrc"
                            />
                            <div
                              v-else
                              class="h-24 w-24 rounded-xl border cursor-pointer border-gray-400 text-center"
                            >
                              <i
                                class="pi pi-plus my-7"
                                style="fontSize: 2rem"
                              ></i>
                            </div>
                          </div>
                          <div class="mx-8 my-auto">
                            <p class="text-gray-800 text-sm">Untitled</p>
                            <p class="text-gray-500 text-sm">
                              標題：{{ material.title }}
                            </p>
                          </div>
                        </div>
                        <i
                          class="pi cursor-pointer my-auto text-right mx-2"
                          :class="[material.isEdit ? 'pi-angle-up' : 'pi-pencil']"
                          style="fontSize: 1.2rem"
                          @click="material.isEdit = !material.isEdit"
                        ></i>
                      </div>
                      <div
                        class="w-full flex-1 bg-white rounded-xl space-y-6 p-6 transition duration-500"
                        v-show="material.isEdit"
                      >
                        <div
                          class="flex justify-between bg-gray-100 rounded-xl border overflow-hidden p-1 w-full hover:border-grap-400 mt-4"
                          v-if="material.imgSrc"
                        >
                          <div class="flex p-1">
                            <div class="md:flex-shrink-0">
                              <img
                                class="h-24 w-24 rounded-xl object-cover"
                                :src="material.imgSrc"
                              />
                            </div>
                            <div class="mx-8">
                              <p class="text-gray-800 text-sm">Untitled</p>
                              <p class="text-gray-500 text-sm">800*800</p>
                              <button
                                class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1 mt-4"
                                v-on:click="getImageVideoList(item.type, materIndex)"
                              >
                                更換素材
                              </button>
                            </div>
                          </div>
                          <i
                            class="pi pi-times cursor-pointer text-right m-2"
                          ></i>
                        </div>
                        <button
                          v-on:click="getImageVideoList(item.type, materIndex)"
                          class="text-sm border border-blue-700 bg-blue-700 text-white rounded-md px-4 py-1"
                          v-else
                        >
                          <i class="pi pi-plus" style="fontSize: 0.8rem"></i>
                          新增影音素材
                        </button>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >標題</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入標題"
                            v-model="material.title"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >說明</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入說明"
                            v-model="material.description"
                          />
                        </div>
                        <div>
                          <span class="text-grap-700 align-middle text-sm"
                            >網站網址</span
                          >
                          <input
                            class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                            type="text"
                            placeholder="請輸入網站網址"
                            v-model="material.website"
                          />
                        </div>
                      </div>
                    </div> -->
                    <!-- 新手教學 -->
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-4 py-1 mt-4"
                      :class="{ 'ring-4 border-blue-400': guideStep === 67 }"
                      @click="addMaterials(index)"
                    >
                      {{lang['components']['Event']['AdvertisingMaterial']['add_carousel_card']}}
                    </button>
                    <!-- 新手教學 -->
                    <label class="inline-flex items-center mt-3 w-full" v-if="item.type == 2" :class="{ 'ring-4 border-blue-400': guideStep === 73 }">
                      <input type="checkbox" v-model="item.multi_share_optimized" v-on:change="isChangeData()"/>
                      <span class="ml-2 text-gray-700 text-sm"
                        >{{lang['components']['Event']['AdvertisingMaterial']['multi_share_optimized_text']}}</span
                      >
                    </label>
                  </div>
                </div>
                <div class="space-y-2 pb-8 my-4">
                  <div>
                    <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 1"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_message_type_1']}}</span
                    >
                    <span class="text-grap-700 align-middle text-sm"
                      v-if="item.type == 2"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_message_type_2']}}</span
                    >
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                      @click="useAi($event, 'single_message', index, '')"
                    >
                      AI生成
                    </button>
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_message_placeholder']"
                      v-model="item.message"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div>
                  <div v-if="item.type == 1">
                    <span class="text-grap-700 align-middle text-sm">{{lang['components']['Event']['AdvertisingMaterial']['material_single_title']}}</span>
                    <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                      @click="useAi($event, 'single_title', index, '')"
                    >
                      AI生成
                    </button>
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_single_title_placeholder']"
                      v-model="item.materialSingle[0].title"
                      v-on:keyup="isChangeData()"
                    />
                  </div>
                  <div v-if="item.type == 1">
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['material_single_description']}}</span
                    >
                    <!-- <button
                      class="text-sm border border-blue-400 text-blue-400 rounded-md px-2 ml-2"
                      @click="useAi($event, 'single_description', index, '')"
                    >
                      AI生成
                    </button> -->
                    <textarea
                      class="w-full h-24 px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['material_single_description_placeholder']"
                      v-model="item.materialSingle[0].description"
                      v-on:keyup="isChangeData()"
                    ></textarea>
                  </div>
                  <!-- <div v-if="item.type == 1">
                    <span class="text-grap-700 align-middle text-sm"
                      >網站網址</span
                    >
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      placeholder="請輸入點擊後要導向的網址"
                      :disabled="editPageType"
                      v-model="item.line"
                      v-on:keyup="isChangeData()"
                    >
                  </div> -->
                  <div v-if="item.type == 1">
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['item_caption']}}</span
                    >
                    <input
                      class="w-full px-3 py-2 text-sm leading-tight text-gray-500 border rounded-md appearance-none focus:outline-none focus:shadow-outline"
                      type="text"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['item_caption_placeholder']"
                      v-model="item.caption"
                      v-on:keyup="isChangeData()"
                    >
                  </div>
                </div>
                <!-- <div
                  class="text-sm text-blue-300 underline cursor-pointer"
                  @click="moreInput = !moreInput"
                >
                  {{ moreWording }}更多選項
                  <i
                    class="pi"
                    :class="[moreInput ? 'pi-caret-up' : 'pi-caret-down']"
                    style="fontSize: 0.8rem"
                  ></i>
                </div> -->
                <!-- <div class="space-y-2 pb-8 my-4" v-show="moreInput"> -->
                <div class="space-y-2 pb-8 my-4">
                  <!-- 新手教學 -->
                  <div class="flex flex-col" :class="{ 'ring-4 border-blue-400': guideStep === 65 || guideStep === 74 }">
                    <span class="text-grap-700 align-middle text-sm"
                      >{{lang['components']['Event']['AdvertisingMaterial']['call_active_text']}}</span
                    >
                    <Dropdown
                      v-model="item.callActive"
                      optionLabel="name"
                      optionValue="code"
                      :options="callActiveList"
                      :placeholder="lang['components']['Event']['AdvertisingMaterial']['call_active_placeholder']"
                      v-on:change="isChangeData()"
                      class="w-1/3 rounded-md"
                    />
                  </div>
                </div>
              </TabPanel>
            </template>
          </TabView>
        </div>
      </div>

      <!-- 即時表單-->

      <div v-show="stageForm == 'true'" class="bg-gray-100 rounded-lg p-2">
        <span class="font-bold text-grap-700 align-middle">{{lang['views']['Form']['title']}}</span>
        <span class="ml-1.5 text-gray text-sm">{{lang['views']['Form']['title_info']}}</span>
      </div>

      <div v-show="stageForm == 'true'">
        <button
          @click="newForm()"
          class="relative mr-2 button bg-blue"
          :class="{ 'ring-4 border-blue-400': guideStep === 76 }"
        >
          <img
            class="mr-2 inline-block align-baseline"
            src="../../assets/add.svg"
          />

          {{lang['views']['Form']['add_button_text']}}
        </button>
        <!-- 新手教學 -->
        <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 1" @click="activeImmediate(selectedItem, editType)">{{lang['views']['Form']['edit_button_text']}}</button>
        <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 2" @click="activeImmediate(selectedItem, editType)">{{lang['views']['Form']['copy_button_text']}}</button>
      </div>

      <div v-show="stageForm == 'true'" class="px-4 py-2 mt-2 border-2 border-gray-ligth rounded-lg h-80">
        <div class="w-full h-full scrollbar-y">
          <div class="base-table">
            <template v-for="(item, value) in immediateList" :key="value.id">
              <div class="table-body">
                <div class="max-w-10">
                  <RadioButton name="immediate" :value="item.id" v-model="selectedItem" @click="changeSelectFormItem(item.id)" />
                </div>
                <div class="w-80">{{ item.title }}</div>
                <!-- 新手教學 -->
                <div class="max-w-28" :class="{ 'ring-4 border-blue-400': guideStep === 78 }"><span :class="[item.status]" style="white-space:nowrap;"></span></div>
                <div class="max-w-40">{{ item.date }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- 訊息範本-->

      <div v-show="stageMsg == 'true'" class="bg-gray-100 rounded-lg p-2">
        <span class="font-bold text-grap-700 align-middle">{{lang['views']['Msg']['title']}}</span>
        <span class="ml-1.5 text-gray text-sm">{{lang['views']['Msg']['title_info']}}</span>
      </div>

      <div v-show="stageMsg == 'true'">
        <button @click="openModal" class="relative mr-2 button bg-blue" :class="{ 'ring-4 border-blue-400': guideStep === 76 }">
          <img
            class="mr-2 inline-block align-baseline"
            src="../../assets/add.svg"
          />

          {{lang['views']['Msg']['add_button_text']}}
        </button>
        <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 1" @click="activeMsgImmediate(selectedItem, 'edit')">{{lang['views']['Msg']['edit_button_text']}}</button>
        <button class="mr-2 button border-blue" :class="{ 'ring-4 border-blue-400': guideStep === 77 }" :disabled="editType == 2" @click="activeMsgImmediate(selectedItem, 'copy')">{{lang['views']['Msg']['copy_button_text']}}</button>
      </div>

      <div v-show="stageMsg == 'true'" class="px-4 py-2 mt-2 border-2 border-gray-ligth rounded-lg h-80">
        <div class="w-full h-full scrollbar-y">
          <div class="base-table">
            <template v-for="(item, value) in messageList" :key="value.id">
              <div class="table-body">
                <div class="max-w-10">
                  <!-- <Checkbox v-model="item.checked" :binary="true" /> -->
                  <RadioButton name="message" :value="item.id" v-model="selectedItem" @click="changeSelectMsgItem(item.id)" />
                </div>
                <div class="w-80">{{ item.title }}</div>
                <!-- 新手教學 -->
                <div class="max-w-28" :class="{ 'ring-4 border-blue-400': guideStep === 78 }"><span :class="[item.status]" style="white-space:nowrap;"></span></div>
                <div class="max-w-40">{{ item.date }}</div>
              </div>
            </template>
          </div>
        </div>
      </div>

      <!-- <SelectPostDialog v-bind:viewDatalist="postsData" v-model:show="showModal" ref="selected_items" /> -->
      <AddMaterial v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-bind:showTargetCR="showTargetCR" v-bind:showOtherTargetCR="showOtherTargetCR" v-bind:formActive="formActive" v-model:showAdd="showAddModal" v-model:campaignId="this.campaignIdData" v-model:creativesDatalist="creativesItems" v-model:prviewCreativesDatalist="prview_creatives" @childAddMaterial="materialCreativesGetData" @childCreativesId="creativesId" />
      <EditMaterial v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-bind:showTargetCR="showTargetCR" v-bind:showOtherTargetCR="showOtherTargetCR" v-model:showAdd="showEditModal" v-bind:creativeDataId="editCreativeId" v-model:creativesDatalist="creativesItems" v-model:prviewCreativesDatalist="prview_creatives" @childAddMaterial="materialCreativesGetData" />
      <SelectPostDialog :guideStep="guideStep" v-bind:viewDatalist="postsData" v-bind:pageId="this.pageIdData" v-bind:lang="lang" v-bind:specialAdCategory="this.stageContenttData.postData.special_ad_category" v-bind:selectStatus="selectStatus" v-model:itemsDatalist="items" v-model:prviewDatalist="prview" v-model:show="showPostModal" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-model:adsetAdsDatalist="adsetAdsItems" v-model:prviewAdsetAdsDatalist="prview_adset_ads" v-model:adsetAdsMessageDatalist="creativesAdsetAdsMessageItems" v-model:prviewAdsetAdsMessageDatalist="prview_adset_ads_message" v-model:showList="showList" @childMaterialGetData="materialGetData" @childEmptyStep="emptyStep" />
      <SelectCreativeDialog :guideStep="guideStep" v-bind:viewDatalist="creativesData" v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-bind:specialAdCategory="this.stageContenttData.postData.special_ad_category" v-model:creativesDatalist="creativesItems" v-model:prviewCreativesDatalist="prview_creatives" v-model:creativesMessageDatalist="creativesMessageItems" v-model:prviewCreativesMessageDatalist="prview_creatives_message" v-model:showCreative="showCreativeModal" v-model:showCreativeDialogMyside="showCreativeDialogMyside" @childCreativesMaterialGetData="materialCreativesGetData" />
      <SelectAdsetAdsDialog :guideStep="guideStep" v-bind:viewDatalist="adaccountCampaignsData" v-bind:pageId="this.pageIdData" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-bind:lang="lang" v-bind:specialAdCategory="this.stageContenttData.postData.special_ad_category" v-model:adsetAdsDatalist="adsetAdsItems" v-model:prviewAdsetAdsDatalist="prview_adset_ads" v-model:showAdsetAds="showAdsetAdsModal" @childAdsetAdsMaterialGetData="materialAdsetAdsGetData" />
      <AiPictureMaterialDialog :guideStep="guideStep" v-bind:viewDatalist="postsData" v-bind:pageId="this.pageIdData" v-bind:lang="lang" v-bind:specialAdCategory="this.stageContenttData.postData.special_ad_category" v-bind:selectStatus="selectStatus" v-model:itemsDatalist="items" v-model:prviewDatalist="prview" v-model:show="showAiPictureModal" v-bind:goalsObjectiveData="this.goalsObjectiveData" v-model:adsetAdsDatalist="adsetAdsItems" v-model:prviewAdsetAdsDatalist="prview_adset_ads" v-model:adsetAdsMessageDatalist="creativesAdsetAdsMessageItems" v-model:prviewAdsetAdsMessageDatalist="prview_adset_ads_message" v-model:showList="showList" @childMaterialGetData="materialGetData" @childEmptyStep="emptyStep" />
    </div>

    <div v-show="stageMaterialStatus == 'true'" class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;">
      <div class="flex flex-col bg-white rounded-xl space-y-2 p-4" style="height:552px;">
        <div v-html="prview_now" v-if="prview_now"></div>
        <div v-html="prview_creatives_now" v-if="prview_creatives_now"></div>
        <div v-html="prview_creatives_message_now" v-if="prview_creatives_message_now"></div>
        <div v-html="prview_adset_ads_message_now" v-if="prview_adset_ads_message_now"></div>
        <div v-html="prview_adset_ads_now" v-if="prview_adset_ads_now"></div>
      </div>

      <div v-show="stageAdvertisingMaterial == 'true' && stageMaterialStatus == 'true'" class="flex flex-col bg-white rounded-xl space-y-2 p-4" style="margin-top:8.5rem; height:552px;">
        <div v-html="ad_prview_now" v-if="ad_prview_now"></div>
        <div v-html="ad_prview_single" v-if="ad_prview_single"></div>
      </div>
    </div>

    <div v-show="stageAdvertisingMaterial == 'true' && stageMaterialStatus == 'false'" class="w-1/4 rounded-xl space-y-2 px-4" style="width:425px;">
      <div class="flex flex-col bg-white rounded-xl space-y-2 p-4" style="height:552px;">
        <div v-html="ad_prview_now" v-if="ad_prview_now"></div>
        <div v-html="ad_prview_single" v-if="ad_prview_single"></div>
      </div>
    </div>
  </div>
  <div v-if="view_youtube">
    <Vue3DraggableResizable
      :initW="360"
      :initH="250"
      v-model:x="x"
      v-model:y="y"
      v-model:w="w"
      v-model:h="h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-xl cursor-move"
      style="background-color: #fff; border:1px #000 solid; z-index:2000;"
    >
      <i class="pi pi-times-circle text-gray-500 cursor-pointer" style="position: absolute; right:5px; top: 5px;" @click="view_youtube = !view_youtube"></i>
      <div style="position: absolute; top: 50%; left: 50%; transform: translate(-50%, -50%);">
        <YouTube
          :src="src"
          width="320"
          height="200"
          @ready="onReady"
          @state-change="onStateChange"
          ref="youtube"
          :vars="vars"
        />
      </div>
    </Vue3DraggableResizable>
  </div>
  <div v-if="view_ai">
    <Vue3DraggableResizable
      :initW="400"
      :initH="auto"
      v-model:x="ai_x"
      v-model:y="ai_y"
      v-model:w="ai_w"
      v-model:h="ai_h"
      v-model:active="active"
      :draggable="true"
      :resizable="false"
      @activated="print('activated')"
      @deactivated="print('deactivated')"
      @drag-start="print('drag-start')"
      @resize-start="print('resize-start')"
      @dragging="doDragging()"
      @resizing="print('resizing')"
      @drag-end="print('drag-end')"
      @resize-end="print('resize-end')"
      class="rounded-md cursor-move"
      style="background-color: #fff; border:1px #D1D5DB solid; z-index:2000;"
    >
      <div class="text-white p-2 rounded-t-md" style="background-color:#1D619F;">
        生成文案
        <i v-if="aiContentProcessing == false" class="pi pi-times text-white cursor-pointer float-right" style="position: absolute; right:10px; top: 10px;" @click="view_ai = !view_ai"></i>
      </div>
      <div :class="[aiContentReturn.length > 0 ? null : 'rounded-b-md pb-3']" style="background-color:#CBD4DD;">
        <div v-if="formTarget != '' && formTarget != null" class="text-sm px-3 pt-3">
          {{formTarget}}
        </div>
        <div class="ml-3 mt-3 mr-3 text-right bg-white rounded-md" :class="[aiContentReturn.length > 0 ? 'pb-3' : null]">
          <textarea
            class="w-full h-32 p-3 text-sm leading-tight text-gray-500 rounded-md appearance-none focus:outline-none focus:shadow-outline"
            type="text"
            placeholder="請輸入要產生的文案大綱"
            style="resize: none;"
            v-model="aiWord"
          ></textarea>
          <button class="text-white px-3 py-1 mx-3 rounded-md" :class="[aiContentReturn.length > 0 ? null : 'mb-3']" style="background-color:#1D619F;" @click="generateCopy">
            {{processText}}
          </button>
        </div>
      </div>
      <div v-if="aiContentReturn.length > 0" class="p-3" style="background-color:#CBD4DD;">
        <div class="p-2 rounded-md overflow-y-auto" style="background-color:#E2EBF2; max-height:200px;">
          <template v-for="(item, index) in aiContentReturn" :key="item.index">
            <label class="block grid grid-cols-12 mb-3" :for="'radio-' + index">
              <input
                type="radio"
                :id="'radio-' + index"
                class="form-radio h-5 w-5 text-blue-600"
                :disabled="editPageType"
                :value="index"
                v-model="itemCheckedIndex"
                @click="itemCheckedIndex = index"
              />
              <span class="break-all col-span-11">{{item.content}}</span>
            </label>
          </template>
        </div>
      </div>
      <div v-if="aiContentReturn.length > 0" class="text-right h-10 rounded-b-md px-3" style="background-color:#CBD4DD;">
        <div class="float-left text-sm leading-8">
          選擇滿意的文案，即可加入欄位
        </div>
        <button v-if="aiContentProcessing != true" class="text-gray-500 px-3 py-1 rounded-md" style="background-color:#F2F2F2;" @click="view_ai = !view_ai">
          取消
        </button>
        <button v-if="itemCheckedIndex != null" class="text-white px-3 py-1 ml-3 rounded-md" style="background-color:#1D619F;" @click="setAiContent">
          確定
        </button>
      </div>
    </Vue3DraggableResizable>
  </div>
  <ModifyWindows v-model:show="showVideoWindows">
    <template v-slot:header>
      <span class="mr-2 text-2xl font-semibold align-sub">{{lang['components']['Event']['AdvertisingMaterial']['material_block_title']}}</span>
      <button @click="materialUpdate()" class="button border-blue">
        {{lang['components']['Event']['AdvertisingMaterial']['material_block_update']}}
      </button>
      <button v-if="false" @click="$refs.videoUpload.click()" class="button border-blue">
        <img
          class="mr-2 inline-block align-baseline"
          src="../../assets/upload.svg"
        />{{lang['components']['Event']['AdvertisingMaterial']['material_block_upload']}}
      </button>
      <!-- <input ref="videoUpload" type="file" class="hidden" />
      {{lang['components']['Event']['AdvertisingMaterial']['material_block_title_info']}} -->
      <input type="file" ref="imageUpload" class="hidden" @change="onImageUpload"/>
      <button @click="showUploadWindows = true" class="ml-2 button border-blue">
        <!-- <img
          class="mr-2 inline-block align-baseline"
          src="../../assets/upload.svg"
        /> -->
        上傳圖片至廣告帳戶
      </button>
    </template>

    <template v-slot:content>
      <div class="flex flex-wrap w-full h-full">
        <loading :active="!showVideoLoading"
                :can-cancel="true"
                :is-full-page="false"
                :color="'#fff'"
                :background-color="'#000'"
                :opacity="'0.8'">
        </loading>
        <div class="flex flex-wrap p-2 w-full h-full scrollbar-y" style="position:relative">
          <div class="w-full">
             <span class="text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMaterial']['material_block_image']}}</span>
          </div>
          <div
            v-for="(item, i) in image.imageList"
            :key="i"
          >
            <img
              @click="changeSelectedForm(i, 'image')"
              :class="{ 'border-blue-light': image.active == i }"
              :src="image.imageList[i]"
              class="
                flex-none
                m-2
                mb-4
                w-24
                h-24
                border-4 border-transparent
                object-cover
                rounded-xl
                cursor-pointer
              "
              :title="image.imageListTitle[i]"
            />
            <div
              class="text-center -mt-2 w-28"
            >
              {{image.imageListName[i]}}
            </div>
          </div>
          <div v-if="imageAfter != ''" class="w-full mt-4 text-center">
            <button
              class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
              @click="moreImage()"
            >{{lang['components']['Event']['AdvertisingMaterial']['more_image']}}</button>
          </div>
          <div class="w-full border-t-2 mt-20">
             <span class="text-grap-700 align-middle">{{lang['components']['Event']['AdvertisingMaterial']['material_block_video']}}</span>
          </div>
          <div
            v-for="(item, i) in video.videoList"
            :key="i"
          >
            <img
              @click="changeSelectedForm(i, 'video')"
              :class="{ 'border-blue-light': video.active == i }"
              :src="video.videoList[i]"
              class="
                flex-none
                m-2
                mb-4
                w-24
                h-24
                border-4 border-transparent
                object-cover
                rounded-xl
                cursor-pointer
              "
              :title="video.videoListTitle[i]"
            />
            <div
              class="text-center -mt-2 w-28"
            >
              {{video.videoListName[i]}}
            </div>
          </div>
          <div v-if="videoAfter != ''" class="w-full mt-4 text-center">
            <button
              class="hover:bg-blue-100 focus:outline-none rounded-xl px-4 py-1 text-blue-400 transition duration-500 ease-in-out border-blue-400 border-2"
              @click="moreVideo()"
            >{{lang['components']['Event']['AdvertisingMaterial']['more_video']}}</button>
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-right">
        <button @click="setMaterial(currentTab)" class="button bg-yellow" style="margin-right:48px;">{{lang['components']['Event']['AdvertisingMaterial']['set_material']}}</button>
      </div>
    </template>
  </ModifyWindows>

  <ModifyWindows v-model:show="showUploadWindows" size="md">
    <template v-slot:header>
      上傳圖片至廣告帳戶
    </template>
    <template v-slot:content>
      <div class="upload-multiple-container">
        <div class="actions">
          <button v-show="isUploading == false" class="custom-upload-btn" @click="triggerFileInput">選擇圖片</button>
          <button
             v-show="selectedFiles.length > 0"
            @click="uploadImages"
            :disabled="isUploading || selectedFiles.length === 0"
            class="upload-btn"
          >
            {{ isUploading ? "上傳中..." : "上傳圖片" }}
          </button>
        </div>
        <input
          type="file"
          multiple
          @change="onFilesSelected"
          ref="fileInput"
          class="hidden"
          accept="image/*"
        />

        <div v-if="selectedFiles.length > 0" class="preview-list">
          <h3 class="subtitle font-bold text-blue-600">準備上傳的圖片</h3>
          <ul>
            <li v-for="(file, index) in selectedFiles" :key="file.name" class="file-item">
              <img
                :src="file.previewUrl"
                alt="預覽"
                class="preview-image"
              />
              <div class="file-info">
                <span class="file-name">{{ file.name }}</span>
                <button v-show="isUploading == false" @click="removeFile(index)" class="remove-btn">移除</button>
              </div>
            </li>
          </ul>
        </div>

        <div v-if="uploadResults.length > 0" class="upload-results">
          <h3 class="subtitle font-bold text-green-600">上傳结果</h3>
          <ul>
            <li v-for="(result, index) in uploadResults" :key="index">
              <img
                :src="result.previewUrl"
                alt="預覽"
                class="preview-image"
              />
              <span>{{ result.fileName }} - </span>
              <span :style="{ color: result.success ? 'green' : 'red' }">
                {{ result.success ? "上傳成功" : "上傳失敗" }}
              </span>
            </li>
          </ul>
        </div>
      </div>
    </template>
  </ModifyWindows>

  <ModifyWindows v-model:show="showFormModal">
      <template v-slot:header>
        <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Form']['Dialog']['title']}}</span>
        <!-- 新手教學 -->
        <span class="p-input-icon-right" :class="{ 'ring-4 border-blue-400': formGuideStep === 801 }">
          <input
            ref="titleText"
            class="p-inputtext p-component w-auto underline-box"
            type="text" v-model="formName"
            :placeholder="lang['views']['Form']['title_placeholder']"
          />
          <i
            @click="$refs.titleText.focus()"
            class="pi pi-pencil cursor-pointer"
          ></i>
        </span>
      </template>

      <template v-slot:content>
        <div class="relative flex h-full">
          <div class="flex-grow">
            <!-- 新手教學 -->
            <ShadowBox class="mx-auto h-full" :class="{ 'ring-4 border-blue-400': formGuideStep === 802 }">
              <!-- 新手教學 -->
              <div class="menu relative pr-2 scrollbar-y w-full h-full" ref="introContent">
                <ul>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 804 }">
                    <!-- <div
                      @click="menuActive = 1"
                      class="py-2 pl-4 text-xl font-semibold complete"
                    > -->
                    <div
                      @click="menuActive = 1"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 1 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_1']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 1 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_1']['title_info']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form1.type"
                              value="0"
                              class="mt-6"
                            />
                            {{lang['views']['Form']['Dialog']['block_1']['radio_1']}}
                          </label>
                          <br />
                          <p class="ml-6 mb-6 text-gray">{{lang['views']['Form']['Dialog']['block_1']['radio_1_info']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form1.type"
                              value="1"
                            />
                            {{lang['views']['Form']['Dialog']['block_1']['radio_2']}}
                          </label>
                          <br />
                          <p class="ml-6 text-gray">{{lang['views']['Form']['Dialog']['block_1']['radio_2_info']}}</p>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 805 }">
                    <div
                      @click="menuActive = 2"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 2 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_2']['title']}}
                    </div>
                    <!-- 新手教學 -->
                    <ul :class="{ active: menuActive == 2 }" class="sub" >
                      <li>
                        <div>
                          <div class="flex">
                            <p class="flex-grow">
                              {{lang['views']['Form']['Dialog']['block_2']['title_info']}}
                            </p>
                            <div class="flex-none font-semibold">
                              <InputSwitch
                                v-model="formData.form2.isOpen"
                                class="mr-2"
                              />
                              <span class="align-text-bottom">{{lang['views']['Form']['Dialog']['block_2']['switch_text']}}</span>
                            </div>
                          </div>

                          <div v-show="formData.form2.isOpen">
                            <!-- <FormInput
                              v-model="formData.form2.title"
                              :isError="true"
                              title="標題"
                              formClass="mt-6"
                              placeholder="請輸入標題"
                              error="Title is required."
                            /> -->
                            <FormInput
                              v-model="formData.form2.title"
                              :title="lang['views']['Form']['Dialog']['block_2']['title_text']"
                              formClass="mt-6"
                              :placeholder="lang['views']['Form']['Dialog']['block_2']['title_placeholder']"
                            />

                            <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_2']['use_image']}}</p>
                            <p>
                              {{lang['views']['Form']['Dialog']['block_2']['use_image_info']}}
                            </p>

                            <p v-show="false" class="mt-6 font-semibold">說明</p>
                            <p v-show="false">
                              使用廣告中的圖像(你廣告的圖像會和說明卡一起顯示)
                            </p>

                            <p class="mt-6">
                              <!-- 新手教學 -->
                              <label class="mr-4" :class="{ 'ring-4 border-blue-400': formGuideStep === 806 }">
                                <RadioButton
                                  v-model="formData.form2.introductionType"
                                  value="0"
                                />
                                {{lang['views']['Form']['Dialog']['block_2']['radio_1']}}
                              </label>

                              <!-- 新手教學 -->
                              <label :class="{ 'ring-4 border-blue-400': formGuideStep === 807 }">
                                <RadioButton
                                  v-model="formData.form2.introductionType"
                                  value="1"
                                />
                                {{lang['views']['Form']['Dialog']['block_2']['radio_2']}}
                              </label>
                            </p>

                            <template
                              v-if="formData.form2.introductionType === '0'"
                            >
                              <!-- <FormTextarea
                                v-model="formData.form2.introduction"
                                :isError="true"
                                formClass="mt-2"
                                placeholder="輸入文字，向用戶介紹你的商品或服務"
                                rows="5"
                                error="Introduction is required."
                              /> -->
                              <FormTextarea
                                v-model="formData.form2.introduction"
                                formClass="mt-2"
                                :placeholder="lang['views']['Form']['Dialog']['block_2']['radio_1_placeholder']"
                                rows="5"
                              />
                            </template>
                            <template v-else>
                              <template
                                v-for="(item, i) in formData.form2
                                  .introductionItem"
                                :key="i"
                              >
                                <FormInput
                                  v-model="formData.form2.introductionItem[i]"
                                  formClass="mt-2"
                                  :placeholder="lang['views']['Form']['Dialog']['block_2']['radio_2_placeholder']"
                                />
                              </template>
                            </template>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 808 }">
                    <div
                      @click="menuActive = 3"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 3 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_3']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 3 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_3']['title_info']}}</p>

                          <draggable
                            v-show="formData.form3.single?.length"
                            v-model="formData.form3.single"
                            @start="drag = true"
                            @end="drag = false"
                          >
                            <template #item="{ element }">
                              <div class="flex mt-1">
                                <div
                                  class="flex-grow mr-2 border border-gray-300 rounded-md"
                                >
                                  <div class="flex h-10">
                                    <!-- 新手教學 -->
                                    <img
                                      :class="{ 'ring-4 border-blue-400': formGuideStep === 814 }"
                                      class="flex-none m-3 h-4 cursor-move"
                                      src="../../assets/move.svg"
                                    />
                                    <div class="flex-grow p-2">
                                      <p v-show="element.isOpen" class="pb-2">
                                        {{lang['views']['Form']['Dialog']['block_3']['single_question']}}
                                      </p>
                                      <!-- 新手教學 -->
                                      <input
                                        v-model="element.text"
                                        :class="{
                                          'px-4 py-2 h-10 border border-gray-400':
                                            element.isOpen,
                                          'ring-4 border-blue-400': formGuideStep === 810
                                        }"
                                        class="rounded-md w-full"
                                        type="text"
                                        :placeholder="lang['views']['Form']['Dialog']['block_3']['single_question_placeholder']"
                                      />
                                    </div>

                                    <div
                                      v-if="!element.isOpen"
                                      @click="element.isOpen = !element.isOpen"
                                      class="
                                        flex-none
                                        p-1
                                        m-1
                                        mr-2
                                        rounded-md
                                        text-gray-400
                                        border border-gray-400
                                        cursor-pointer
                                      "
                                    >
                                      {{ element.type.name }}
                                    </div>
                                    <template v-else>
                                      <div
                                        @click="element.isOpen = !element.isOpen"
                                        class="p-2 text-blue-light cursor-pointer"
                                      >
                                        {{lang['views']['Form']['Dialog']['block_3']['toggle_button_text']}}
                                        <i class="pi pi-caret-up"></i>
                                      </div>
                                    </template>
                                  </div>

                                  <!-- 新手教學 -->
                                  <div v-show="element.isOpen" class="mt-16" :class="{ 'ring-4 border-blue-400': formGuideStep === 811 }">
                                    <p class="ml-8">{{lang['views']['Form']['Dialog']['block_3']['single_question_answer']}}</p>
                                    <!-- <draggable
                                      v-show="element.answer.length"
                                      v-model="element.answer"
                                      @start="drag = true"
                                      @end="drag = false"
                                      item-key="i"
                                    >
                                      <template #item="{ subElement, i }">
                                        <div
                                          class="flex mt-2 ml-8 mr-3 h-10 bg-gray-200 rounded-md"
                                        >
                                          <img
                                            class="flex-none m-3 h-4 cursor-move"
                                            src="../../assets/move.svg"
                                          />
                                          <p class="flex-grow py-2">
                                            {{ subElement.text }}
                                          </p>
                                          <span
                                            @click="element.answer.splice(i, 1)"
                                            class="flex-none p-2 pt-3 pi pi-times cursor-pointer"
                                          ></span>
                                        </div>
                                      </template>
                                    </draggable> -->

                                    <!-- <div
                                      v-for="(item, i) in element.answer"
                                      :key="i"
                                      class="flex mt-2 ml-8 mr-3 h-10 bg-gray-200 rounded-md"
                                    >
                                      <img
                                        class="flex-none m-3 h-4 cursor-move"
                                        src="../../assets/move.svg"
                                      />
                                      <p class="flex-grow py-2">
                                        {{ item.text }}
                                      </p>
                                      <span
                                        @click="element.answer.splice(i, 1)"
                                        class="flex-none p-2 pt-3 pi pi-times cursor-pointer"
                                      ></span>
                                    </div> -->

                                    <draggable
                                      v-show="element.answer?.length"
                                      v-model="element.answer"
                                      @start="drag = true"
                                      @end="drag = false"
                                      item-key="i"
                                    >
                                      <template #item="{ element, index }">
                                        <!-- 新手教學 -->
                                        <div
                                          class="flex mt-2 ml-8 mr-3 h-10 bg-gray-200 rounded-md"
                                          :class="{ 'ring-4 border-blue-400': formGuideStep === 812 }"
                                        >
                                          <img
                                            class="flex-none m-3 h-4 cursor-move"
                                            src="../../assets/move.svg"
                                          />
                                          <p class="flex-grow py-2">
                                            {{ element.text }}
                                          </p>
                                          <span
                                            @click="
                                              removeForm3SingleAnswer(
                                                element.parentId,
                                                index
                                              )
                                            "
                                            class="flex-none p-2 pt-3 pi pi-times cursor-pointer"
                                          ></span>
                                        </div>
                                      </template>
                                    </draggable>

                                    <div class="flex my-2">
                                      <div class="flex-grow pl-8">
                                        <input
                                          v-model="element.answerText"
                                          class="flex-grow px-4 py-2 w-full border border-gray-400 rounded-md"
                                          type="text"
                                          :placeholder="lang['views']['Form']['Dialog']['block_3']['single_question_answer_placeholder']"
                                        />
                                      </div>
                                      <div class="flex-none">
                                        <button
                                          @click="setForm3Answer(element)"
                                          class="mx-2 button bg-blue"
                                        >
                                          <img
                                            class="mr-2 inline-block align-baseline"
                                            src="../../assets/add.svg"
                                          />
                                          {{lang['views']['Form']['Dialog']['block_3']['add_ingle_question_item']}}
                                        </button>
                                      </div>
                                    </div>
                                  </div>
                                </div>
                                <div class="flex-none">
                                  <!-- 新手教學 -->
                                  <div
                                    @click="removeForm3Single(element.id)"
                                    class="
                                      p-2
                                      mt-1
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                    :class="{ 'ring-4 border-blue-400': formGuideStep === 813 }"
                                  >
                                    <img src="../../assets/clear.svg" />
                                  </div>
                                </div>
                              </div>
                            </template>
                          </draggable>

                          <p class="mt-6">{{lang['views']['Form']['Dialog']['block_3']['other_question']}}</p>
                          <draggable
                            v-show="formData.form3.other?.length"
                            v-model="formData.form3.other"
                            @start="drag = true"
                            @end="drag = false"
                            item-key="id"
                          >
                            <template #item="{ element }">
                              <div class="flex mt-1">
                                <div
                                  :class="{
                                    'h-24':
                                      element.isOpen &&
                                      element.type.name == lang['views']['Form']['Dialog']['block_3']['if_short_answer_questions']
                                  }"
                                  class="flex-grow mr-2 border border-gray-300 rounded-md"
                                >
                                  <div class="flex h-10">
                                    <img
                                      class="flex-none m-3 h-4 cursor-move"
                                      src="../../assets/move.svg"
                                    />

                                    <div class="flex-grow p-2">
                                      <p v-show="element.isOpen" class="pb-2">
                                        {{
                                          element.type.name == lang['views']['Form']['Dialog']['block_3']['if_short_answer_questions']
                                            ? lang['views']['Form']['Dialog']['block_3']['short_answer_questions']
                                            : lang['views']['Form']['Dialog']['block_3']['reserve_questions']
                                        }}
                                      </p>
                                      <input
                                        v-model="element.text"
                                        :class="{
                                          'px-4 py-2 h-10 border border-gray-400':
                                            element.isOpen
                                        }"
                                        class="rounded-md w-full"
                                        type="text"
                                        :placeholder="lang['views']['Form']['Dialog']['block_3']['short_answer_questions_placeholder']"
                                      />
                                    </div>

                                    <div
                                      v-if="!element.isOpen"
                                      @click="element.isOpen = !element.isOpen"
                                      class="
                                        flex-none
                                        p-1
                                        m-1
                                        mr-2
                                        rounded-md
                                        text-gray-400
                                        border border-gray-400
                                        cursor-pointer
                                      "
                                    >
                                      {{ element.type.name }}
                                    </div>
                                    <template v-else>
                                      <div
                                        @click="element.isOpen = !element.isOpen"
                                        class="p-2 text-blue-light cursor-pointer"
                                      >
                                        {{lang['views']['Form']['Dialog']['block_3']['toggle_button_text']}}
                                        <i class="pi pi-caret-up"></i>
                                      </div>
                                    </template>
                                  </div>

                                  <div
                                    v-show="
                                      element.isOpen &&
                                        element.type.name != lang['views']['Form']['Dialog']['block_3']['if_short_answer_questions']
                                    "
                                    class="p-8 pr-20 mt-8"
                                  >
                                    <p class="ml-1">{{lang['views']['Form']['Dialog']['block_3']['reserve_questions_placeholder']}}</p>

                                    <input
                                      v-model="element.confirm"
                                      class="flex-grow px-4 py-2 m-1 w-full border border-gray-400 rounded-md"
                                      type="text"
                                      :placeholder="lang['views']['Form']['Dialog']['block_3']['reserve_questions_placeholder']"
                                    />

                                    <p class="m-1 mt-4">{{lang['views']['Form']['Dialog']['block_3']['reserve_questions_info_1']}}</p>
                                    <p class="m-1 text-sm text-gray-400">
                                      {{lang['views']['Form']['Dialog']['block_3']['reserve_questions_info_2']}}
                                    </p>
                                  </div>
                                </div>
                                <div class="flex-none">
                                  <div
                                    @click="removeForm3Other(element.id)"
                                    class="
                                      p-2
                                      mt-1
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                  >
                                    <img src="../../assets/clear.svg" />
                                  </div>
                                </div>
                              </div>
                            </template>
                          </draggable>

                          <!-- 新手教學 -->
                          <Dropdown
                            :class="{ 'ring-4 border-blue-400': formGuideStep === 809 || formGuideStep === 815 }"
                            v-model="formData.form3.type"
                            @change="form3TypeChange"
                            :options="form3Options"
                            optionLabel="name"
                            class="mt-2"
                          >
                            <template #value="">
                              <div class="country-item">
                                <i class="pi pi-plus mr-2"></i>
                                <span>{{lang['views']['Form']['Dialog']['block_3']['setting_questions']}}</span>
                              </div>
                            </template></Dropdown
                          >
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 816 }">
                    <div
                      @click="menuActive = 4"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 4 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_4']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 4 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_4']['title_info']}}</p>

                          <FormInput
                            v-model="formData.form4.instruction"
                            :title="lang['views']['Form']['Dialog']['block_4']['input_title']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_4']['input_title_placeholder']"
                            error="Title is required."
                          />

                          <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_4']['add_info_title_text']}}</p>

                          <draggable
                            v-show="formData.form4.dataType?.length"
                            v-model="formData.form4.dataType"
                            @start="drag = true"
                            @end="drag = false"
                            item-key="code"
                          >
                            <template #item="{ element }">
                              <div class="flex mt-1">
                                <div class="flex-grow">
                                  <div
                                    class="
                                      flex
                                      mr-2
                                      h-10
                                      border border-gray-300
                                      rounded-md
                                    "
                                  >
                                    <img
                                      class="flex-none m-3 h-4 cursor-move"
                                      src="../../assets/move.svg"
                                    />
                                    <input
                                      v-model="element.text"
                                      class="flex-grow"
                                      type="text"
                                      :placeholder="lang['views']['Form']['Dialog']['block_4']['add_info_title_text_placeholder']"
                                    />
                                    <div
                                      class="
                                        flex-none
                                        p-1
                                        m-1
                                        mr-2
                                        rounded-md
                                        text-gray-400
                                        border border-gray-400
                                      "
                                    >
                                      {{ element.type.typeName }}
                                    </div>
                                  </div>
                                </div>
                                <div class="flex-none">
                                  <div
                                    @click="
                                      removeForm4Datatype(element.type.code)
                                    "
                                    class="
                                      p-2
                                      mt-1
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                  >
                                    <img src="../../assets/clear.svg" />
                                  </div>
                                </div>
                              </div>
                            </template>
                          </draggable>

                          <div class="mt-2">
                            <!-- 新手教學 -->
                            <CascadeSelect
                              :class="{ 'ring-4 border-blue-400': formGuideStep === 817 || formGuideStep === 818 }"
                              v-model="formData.form4.type"
                              @change="form4TypeChange"
                              :options="formData.form4.countries"
                              optionLabel="name"
                              optionGroupLabel="name"
                              :optionGroupChildren="['sub']"
                              style="minwidth: 14rem"
                              :placeholder="lang['views']['Form']['Dialog']['block_4']['cascade_select_placeholder']"
                            >
                              <template #value="">
                                <div class="country-item">
                                  <i class="pi pi-plus mr-2"></i>
                                  <span>{{lang['views']['Form']['Dialog']['block_4']['cascade_select_placeholder']}}</span>
                                </div>
                              </template>

                              <template #option="slotProps">
                                <div
                                  :class="{
                                    'absolute top-0 left-0 bg-gray-100 w-full h-full cursor-not-allowed':
                                      formData.form4.isCountries.indexOf(
                                        slotProps.option.code
                                      ) > -1
                                  }"
                                ></div>
                                <span
                                  :class="{
                                    'cursor-not-allowed':
                                      formData.form4.isCountries.indexOf(
                                        slotProps.option.code
                                      ) > -1
                                  }"
                                  class="z-10"
                                  >{{ slotProps.option.name }}</span
                                >
                              </template>
                            </CascadeSelect>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 819 }">
                    <div
                      @click="menuActive = 5"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 5 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_5']['title']}}
                    </div>
                    <ul
                      :class="{
                        active: menuActive == 5,
                        'max-h-initial':
                          menuActive == 5 && formData.form5.isOpen
                      }"
                      class="sub"
                    >
                      <li>
                        <div>
                          <p class="font-semibold">{{lang['views']['Form']['Dialog']['block_5']['item_title_1']}}</p>
                          <p>
                            {{lang['views']['Form']['Dialog']['block_5']['item_title_1_info']}}
                          </p>

                          <FormInput
                            v-model="formData.form5.url"
                            :title="lang['views']['Form']['Dialog']['block_5']['input_title_1']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_5']['input_title_1_placeholder']"
                            error="is required."
                          />

                          <FormInput
                            v-model="formData.form5.urlText"
                            :title="lang['views']['Form']['Dialog']['block_5']['input_title_2']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_5']['input_title_2_placeholder']"
                            error="is required."
                          />

                          <hr class="mt-6" />

                          <div class="flex mt-6">
                            <div class="flex-grow">
                              <p class="font-semibold">{{lang['views']['Form']['Dialog']['block_5']['item_title_2']}}</p>
                            </div>
                            <div class="flex-none">
                              <InputSwitch
                                v-model="formData.form5.isOpen"
                                class="mr-2"
                              />
                              <span class="align-text-bottom"
                                >{{lang['views']['Form']['Dialog']['block_5']['switch_text']}}</span
                              >
                            </div>
                          </div>

                          <p>
                            {{lang['views']['Form']['Dialog']['block_5']['item_title_2_info']}}
                          </p>

                          <div v-show="formData.form5.isOpen">
                            <FormInput
                              v-model="formData.form5.title"
                              :title="lang['views']['Form']['Dialog']['block_5']['description_title']"
                              formClass="mt-6"
                              :placeholder="lang['views']['Form']['Dialog']['block_5']['description_title_placeholder']"
                              error="is required."
                            />

                            <FormInput
                              v-model="formData.form5.content"
                              :title="lang['views']['Form']['Dialog']['block_5']['description_text']"
                              formClass="mt-6"
                              :placeholder="lang['views']['Form']['Dialog']['block_5']['description_text_placeholder']"
                              error="is required."
                            />

                            <template
                              v-for="(item, i) in formData.form5.agree"
                              :key="i"
                            >
                              <div class="flex">
                                <div class="flex-grow pr-2">
                                  <FormInput
                                    v-model="item.content"
                                    :title="lang['views']['Form']['Dialog']['block_5']['condition_title'] + (i + 1)"
                                    formClass="mt-6"
                                    :placeholder="lang['views']['Form']['Dialog']['block_5']['condition_text']"
                                    error="is required."
                                  />
                                </div>

                                <div class="flex-none">
                                  <div
                                    @click="formData.form5.agree.splice(i, 1)"
                                    class="
                                      p-2
                                      mt-12
                                      bg-gray-300
                                      rounded-md
                                      cursor-pointer
                                    "
                                  >
                                    <img src="/img/clear.5937fadd.svg" />
                                  </div>
                                </div>
                              </div>

                              <Checkbox v-model="item.isAgree" :binary="true" />
                              <label @click="item.isAgree = !item.isAgree">
                                {{lang['views']['Form']['Dialog']['block_5']['condition_checkbox_text']}}
                              </label>
                            </template>

                            <div class="mt-2">
                              <button
                                @click="setForm5Agree"
                                class="relative button border-blue"
                              >
                                <img
                                  class="mr-2 inline-block align-baseline"
                                  src="../../assets/add_blue.svg"
                                />
                                {{lang['views']['Form']['Dialog']['block_5']['add_condition_text']}}
                              </button>
                            </div>
                          </div>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 820 }">
                    <div
                      @click="menuActive = 6"
                      class="py-2 pl-4 text-xl font-semibold"
                      :class="{ 'not-required': selectLang == 'zh-TW', 'not-required_zh_cn': selectLang == 'zh-CN', 'not-required_en_us': selectLang == 'en-US' }"
                    >
                      <img
                        :class="{ active: menuActive == 6 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_6']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 6 }" class="sub">
                      <li>
                        <div>
                          <p>
                            {{lang['views']['Form']['Dialog']['block_6']['title_info']}}
                          </p>
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 821 }">
                    <div
                      @click="menuActive = 7"
                      class="py-2 pl-4 text-xl font-semibold"
                    >
                      <img
                        :class="{ active: menuActive == 7 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_7']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 7 }" class="sub">
                      <li>
                        <div>
                          <p>{{lang['views']['Form']['Dialog']['block_7']['title_info']}}</p>

                          <FormInput
                            v-model="formData.form7.title"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_1']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_1_placeholder']"
                            error="is required."
                          />

                          <p v-show="false">你可以自訂潛在顧客提交表單後看到的畫面</p>

                          <!-- <FormTextarea
                            v-model="formData.form7.main"
                            :isError="false"
                            title="主要文字"
                            formClass="mt-6"
                            placeholder="請輸入主要文字"
                            rows="5"
                            error="Introduction is required."
                          /> -->
                          <FormTextarea
                            v-model="formData.form7.main"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_2']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_2_placeholder']"
                            rows="5"
                          />

                          <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_7']['item_title_3']}}</p>
                          <Dropdown
                            id="dropdown"
                            v-model="formData.form7.web"
                            :options="[{ name: lang['views']['Form']['Dialog']['block_7']['item_title_3_button']['view_website'], code: 'VIEW_WEBSITE' }, { name: lang['views']['Form']['Dialog']['block_7']['item_title_3_button']['downliad'], code: 'DOWNLOAD' }, { name: lang['views']['Form']['Dialog']['block_7']['item_title_3_button']['call_business'], code: 'CALL_BUSINESS' }]"
                            optionLabel="name"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_3_placeholder']"
                          />

                          <div v-if="formData.form7.web.code == 'CALL_BUSINESS'">
                            <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_7']['item_title_3_call_business_phone']['title']}}</p>
                            <div class="flex overflow-hidden text-white">
                              <div class="w-1/4">
                                <Dropdown
                                  id="dropdown"
                                  class="w-full"
                                  v-model="formData.form7.countryCode"
                                  :options="countryCodeListBase"
                                  optionLabel="name"
                                  :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_3_call_business_phone']['country_code_placeholder']"
                                />
                              </div>
                              <div class="w-3/4">
                                <FormInput
                                  v-model="formData.form7.business_phone_number"
                                  :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_3_call_business_phone']['phone_placeholder']"
                                />
                              </div>
                            </div>
                          </div>

                          <!-- <FormInput
                            v-model="formData.form7.btntext"
                            title="按鈕文字"
                            formClass="mt-6"
                            placeholder="請輸入按鈕文字"
                            error="is required."
                          /> -->
                          <FormInput
                            v-model="formData.form7.btntext"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_4']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_4_placeholder']"
                          />

                          <!-- <FormInput
                            v-model="formData.form7.url"
                            title="網站連結"
                            formClass="mt-6"
                            placeholder="請輸入網站連結"
                            error="is required."
                          /> -->
                          <FormInput
                            v-model="formData.form7.url"
                            :title="lang['views']['Form']['Dialog']['block_7']['item_title_5']"
                            formClass="mt-6"
                            :placeholder="lang['views']['Form']['Dialog']['block_7']['item_title_5_placeholder']"
                          />
                        </div>
                      </li>
                    </ul>
                  </li>
                  <!-- 新手教學 -->
                  <li :class="{ 'ring-4 border-blue-400': formGuideStep === 822 }">
                    <div
                      @click="menuActive = 8"
                      class="py-2 pl-4 text-xl font-semibold"
                      :class="{ 'not-required': selectLang == 'zh-TW', 'not-required_zh_cn': selectLang == 'zh-CN', 'not-required_en_us': selectLang == 'en-US' }"
                    >
                      <img
                        :class="{ active: menuActive == 8 }"
                        src="../../assets/arrow.svg"
                      />
                      {{lang['views']['Form']['Dialog']['block_8']['title']}}
                    </div>
                    <ul :class="{ active: menuActive == 8 }" class="sub">
                      <li>
                        <div>
                          <p class="font-semibold">{{lang['views']['Form']['Dialog']['block_8']['item_title_1']}}</p>
                          <Dropdown
                            id="dropdown"
                            v-model="formData.form8.lang"
                            :options="[{ name: 'English(US)', code: 'en_US' }, { name: 'English(UK)', code: 'en_GB' }, { name: '中文 (台灣)', code: 'zh_TW' }, { name: '中文 (香港)', code: 'zh_HK' }, { name: '中文 (简体)', code: 'zh_CN' }]"
                            optionLabel="name"
                            :placeholder="lang['views']['Form']['Dialog']['block_8']['item_title_1_placeholder']"
                            @change="test()"
                          />

                          <p class="mt-6 font-semibold">{{lang['views']['Form']['Dialog']['block_8']['item_title_2']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form8.shareType"
                              value="1"
                              class="mt-6"
                            />
                            {{lang['views']['Form']['Dialog']['block_8']['radio_1_title']}}
                          </label>
                          <br />
                          <p class="ml-6 mb-6 text-gray">{{lang['views']['Form']['Dialog']['block_8']['radio_1_title_info']}}</p>
                          <label>
                            <RadioButton
                              v-model="formData.form8.shareType"
                              value="0"
                            />
                            {{lang['views']['Form']['Dialog']['block_8']['radio_2_title']}}
                          </label>
                          <br />
                          <p class="ml-6 text-gray">{{lang['views']['Form']['Dialog']['block_8']['radio_2_title_info']}}</p>
                        </div>
                      </li>
                    </ul>
                  </li>
                </ul>
              </div>
            </ShadowBox>
          </div>
          <!-- 新手教學 -->
          <div class="flex-none" :class="{ 'ring-4 border-blue-400': formGuideStep === 803 }">
            <ShadowBox :padding="false" class="w-80 h-full">
              <div class="flex flex-col h-full">
                <p class="px-4 py-2 font-semibold border-b">{{lang['views']['Form']['Dialog']['preview']['title']}}</p>
                <div class="flex px-4 py-2 font-semibold border-b">
                  <p class="flex-grow">
                    {{ previewTitle }}
                  </p>
                  <div class="flex-none pr-1">{{ preview }}/4</div>
                  <div class="flex flex-none py-2 bg-gray rounded-full">
                    <div
                      @click="prev"
                      class="flex-none w-6 h-full cursor-pointer"
                    >
                      <svg
                        width="7"
                        height="9"
                        viewBox="0 0 7 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="m-auto"
                      >
                        <path
                          d="M5.59122 0.549561L1.85352 4.15393L5.59122 8.35903"
                          stroke="white"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                    <div
                      @click="next"
                      class="flex-none w-6 h-full cursor-pointer"
                    >
                      <svg
                        width="7"
                        height="9"
                        viewBox="0 0 7 9"
                        fill="none"
                        xmlns="http://www.w3.org/2000/svg"
                        class="m-auto"
                      >
                        <path
                          d="M0.785829 8.35962L5.14648 4.75525L0.785829 0.550147"
                          stroke="white"
                          stroke-width="1.5"
                        />
                      </svg>
                    </div>
                  </div>
                </div>

                <div class="px-4 flex-grow overflow-hidden border-b">
                  <div
                    class="
                      relative
                      flex flex-col
                      h-full
                      scrollbar-y
                      bg-gray-light
                    "
                  >
                    <div class="relative h-40 bg-navy">
                      <div
                        class="
                          absolute
                          w-6
                          h-6
                          top-2
                          left-2
                          bg-black-50
                          rounded-full
                          cursor-pointer
                        "
                      >
                        <i class="ml-1 pi pi-chevron-left text-white"></i>
                      </div>
                      <div
                        class="
                          absolute
                          w-6
                          h-6
                          top-2
                          right-2
                          bg-black-50
                          rounded-full
                          cursor-pointer
                        "
                      >
                        <i class="ml-1 pi pi-times text-white"></i>
                      </div>
                    </div>
                    <div class="flex-grow min-h-56 bg-gray-light"></div>

                    <div class="absolute px-2 top-20 w-full">
                      <div
                        v-show="formData.form2.isOpen"
                        class="
                          absolute
                          ml-4
                          -top-3
                          left-24
                          w-14
                          h-14
                          border border-white
                          bg-gray-900
                          rounded-full
                          z-10
                        "
                      ></div>
                      <ShadowBox
                        v-show="formData.form2.isOpen"
                        :active="menuActive == 2"
                        :class="{ focus: formData.focus == 'form2_title' }"
                        class="pb-0 w-full"
                      >
                        <p class="mt-4 text-sm text-center text-gray">
                          {{lang['views']['Form']['Dialog']['preview']['form2_label']}}
                        </p>
                        <p class="mt-4 text-center font-semibold">
                          {{
                            formData.form2.title ? formData.form2.title : lang['views']['Form']['Dialog']['preview']['form2_title']
                          }}
                        </p>

                        <template v-if="formData.form2.introductionType == 0">
                          <p class="mt-4 text-sm">
                            {{
                              formData.form2.introduction
                                ? formData.form2.introduction
                                : lang['views']['Form']['Dialog']['preview']['form2_introduction']
                            }}
                          </p>
                        </template>
                        <template
                          v-else-if="formData.form2.introductionType == 1"
                        >
                          <ul class="list-disc">
                            <template
                              v-for="(item, i) in formData.form2
                                .introductionItem"
                              :key="i"
                            >
                              <li v-show="item != ''">{{ item }}</li>
                            </template>
                          </ul>
                        </template>
                      </ShadowBox>

                      <ShadowBox
                        v-for="(item, i) in formData.form3.single"
                        :key="i"
                        :active="menuActive == 3"
                        class="pb-0 w-full"
                      >
                        <p class="font-semibold">
                          {{ item.text ? item.text : lang['views']['Form']['Dialog']['preview']['form3_code_01_title'] }}
                        </p>

                        <template v-for="(a, j) in item.answer" :key="j">
                          <p
                            class="
                              p-2
                              mx-2
                              mt-1
                              bg-gray-300
                              rounded-full
                              text-center
                              font-semibold
                            "
                          >
                            {{ a.text ? a.text : lang['views']['Form']['Dialog']['preview']['form3_code_01_text'] }}
                          </p>
                        </template>
                      </ShadowBox>

                      <template
                        v-for="(item, i) in formData.form3.other"
                        :key="i"
                      >
                        <ShadowBox
                          v-show="item.type.code == '02'"
                          :active="menuActive == 3"
                          class="pb-0 w-full"
                        >
                          <p class="font-semibold">
                            {{ item.text ? item.text : lang['views']['Form']['Dialog']['preview']['form3_code_02_title'] }}
                          </p>

                          <p class="mt-4 text-gray-300 border-b text-sm">
                            {{lang['views']['Form']['Dialog']['preview']['form3_code_02_text']}}
                          </p>
                        </ShadowBox>
                      </template>

                      <template
                        v-for="(item, i) in formData.form3.other"
                        :key="i"
                      >
                        <ShadowBox
                          v-show="item.type.code == '03'"
                          class="pb-0 w-full"
                        >
                          <p class="font-semibold">
                            {{ item.text ? item.text : lang['views']['Form']['Dialog']['preview']['form3_code_03_title'] }}
                          </p>

                          <p class="mt-4 text-gray-300 border-b text-sm">
                            <span class="mr-4">{{lang['views']['Form']['Dialog']['preview']['form3_code_03_date_text']}}</span>
                            <span class="mr-4">{{lang['views']['Form']['Dialog']['preview']['form3_code_03_time_text']}}</span>
                          </p>
                        </ShadowBox>
                      </template>

                      <ShadowBox
                        v-show="formData.form4.dataType?.length"
                        :active="menuActive == 4"
                      >
                        <p class="flex font-semibold">
                          {{lang['views']['Form']['Dialog']['preview']['form4_dataType_title']}}
                          <img
                            @click="formData.form4.isOpenInstruction = true"
                            class="ml-2 w-4 cursor-pointer"
                            src="../../assets/info.svg"
                            alt=""
                          />
                        </p>

                        <!-- <p class="mt-4 text-sm text-gray-400">全名</p>
                        <p
                          class="mt-2 text-sm text-gray-300 border-b border-gray-300"
                        >
                          請輸入答案
                        </p>
                        <p class="mt-2 text-sm text-gray-400">性別</p>
                        <p
                          class="mt-2 text-sm text-gray-300 border-b border-gray-300"
                        >
                          請輸入答案
                        </p> -->

                        <template
                          v-for="(item, i) in formData.form4.dataType"
                          :key="i"
                        >
                          <p class="mt-4 text-sm text-gray-400">
                            {{ item.text }}
                          </p>
                          <p
                            class="mt-2 text-sm text-gray-300 border-b border-gray-300"
                          >
                            {{lang['views']['Form']['Dialog']['preview']['form4_dataType_text']}}
                          </p>
                        </template>
                      </ShadowBox>

                      <ShadowBox
                        v-show="formData.form1.type == '1'"
                        :active="menuActive == 1 || menuActive == 6"
                      >
                        <p class="font-semibold">{{lang['views']['Form']['Dialog']['preview']['form1_type_title']}}</p>
                        <p class="mt-4 text-sm text-gray-300">{{lang['views']['Form']['Dialog']['preview']['form1_type_item_1']}}</p>
                        <p class="mt-2 text-sm">{{lang['views']['Form']['Dialog']['preview']['form1_type_item_2']}}</p>
                        <p class="mt-2 text-sm">{{lang['views']['Form']['Dialog']['preview']['form1_type_item_3']}}</p>
                      </ShadowBox>

                      <ShadowBox
                        v-show="
                          formData.form5.isOpen ||
                            formData.form5.url ||
                            formData.form5.urlText
                        "
                      >
                        <p class="mb-4 font-semibold">
                          {{
                            formData.form5.title
                              ? formData.form5.title
                              : formData.form5.isOpen
                              ? lang['views']['Form']['Dialog']['preview']['form5_title_1']
                              : lang['views']['Form']['Dialog']['preview']['form5_title_2']
                          }}
                        </p>

                        <template
                          v-for="(item, i) in formData.form5.agree"
                          :key="i"
                        >
                          <div v-show="formData.form5.isOpen">
                            <Checkbox :binary="true" class="mr-1" />
                            <label>
                              {{ item.content ? item.content : lang['views']['Form']['Dialog']['preview']['form5_agree_title'] }}
                              <span
                                v-show="item.isAgree"
                                class="ml-2 text-gray-300"
                                >{{lang['views']['Form']['Dialog']['preview']['form5_agree_info']}}</span
                              >
                            </label>
                          </div>
                        </template>

                        <hr
                          v-show="
                            formData.form5.agree?.length && formData.form5.isOpen
                          "
                          class="my-4"
                        />

                        <p class="text-sm text-gray-400">
                          {{
                            formData.form5.content && formData.form5.isOpen
                              ? formData.form5.content
                              : lang['views']['Form']['Dialog']['preview']['form5_content']
                          }}
                          <a :href="formData.form5.url" class="underline">{{
                            formData.form5.urlText
                              ? formData.form5.urlText
                              : lang['views']['Form']['Dialog']['preview']['form5_urlText']
                          }}</a>
                        </p>
                      </ShadowBox>

                      <ShadowBox
                        v-show="formData.form7.title || formData.form7.main"
                        :active="menuActive == 7"
                        :class="{ focus: formData.focus == 'form2_title' }"
                        :overflowHidden="false"
                        class="pb-0 mt-8 w-full"
                      >
                        <div
                          class="
                            absolute
                            ml-0
                            -top-6
                            left-24
                            w-14
                            h-14
                            border border-white
                            bg-gray-900
                            rounded-full
                            z-10
                          "
                        ></div>
                        <p class="mt-4 text-sm text-center text-gray">
                          {{lang['views']['Form']['Dialog']['preview']['form2_label']}}
                        </p>
                        <p class="mt-4 text-2xl text-center font-semibold">
                          {{
                            formData.form7.title ? formData.form7.title : lang['views']['Form']['Dialog']['preview']['form7_title']
                          }}
                        </p>
                        <p class="mt-2 text-center font-semibold">
                          {{
                            formData.form7.main
                              ? formData.form7.main
                              : lang['views']['Form']['Dialog']['preview']['form7_main']
                          }}
                        </p>

                        <hr class="my-4" />

                        <p class="text-sm text-center text-gray-400">
                          {{lang['views']['Form']['Dialog']['preview']['form7_main_info']}}
                        </p>
                      </ShadowBox>
                    </div>

                    <div
                      v-show="formData.form4.isOpenInstruction"
                      class="absolute w-full h-full bg-gray-800 opacity-50 z-20"
                    ></div>
                    <div
                      v-show="formData.form4.isOpenInstruction"
                      class="w-full hor-ver-center z-50"
                    >
                      <ShadowBox :padding="false">
                        <div
                          class="relative p-2 w-full font-semibold text-center border-b"
                        >
                          <span
                            @click="formData.form4.isOpenInstruction = false"
                            class=" absolute top-3 left-2 pi pi-times cursor-pointer"
                          ></span>
                          {{lang['views']['Form']['Dialog']['preview']['form4_isOpenInstruction']}}
                        </div>

                        <p class="p-4 text-sm text-gray-400">
                          {{
                            formData.form4.instruction
                              ? formData.form4.instruction
                              : lang['views']['Form']['Dialog']['preview']['form4_instruction']
                          }}
                        </p>
                      </ShadowBox>
                    </div>
                  </div>
                </div>

                <div class="px-4 py-2">
                  <button class="w-full button bg-blue-light">{{lang['views']['Form']['Dialog']['preview']['next']}}</button>
                </div>
              </div>
            </ShadowBox>
          </div>

          <ShadowBox
            v-show="hint"
            class="absolute mb-4 right-4 bottom-0 w-96 z-50"
            shadow="xl border border-gray-200"
          >
            <button
              @click="hint = false"
              class="
                p-dialog-header-icon p-dialog-header-close p-link
                -mt-2
                -mr-4
                mb-2
                ml-auto
              "
              aria-label="close"
              type="button"
              tabindex="-1"
            >
              <span class="p-dialog-header-close-icon pi pi-times"></span>
            </button>

            <div class="flex">
              <div class="flex-none">
                <img class="-ml-2 mr-2 w-6" src="../../assets/light.png" />
              </div>
              <p class="flex-grow text-justify">
                {{lang['views']['Form']['Dialog']['block_info']}}
              </p>
            </div>
          </ShadowBox>
        </div>
      </template>

      <template content="" v-slot:footer>
        <div class="text-right">
          <button class="button bg-yellow" style="margin-right:36px;" @click="form_update()">{{lang['views']['Form']['Dialog']['save_button']}}</button>
        </div>
      </template>
    </ModifyWindows>

  <ModifyWindows v-model:show="showMsgModal" size="xxl" :msgGuideStep="msgGuideStep">
    <template v-slot:header>
      <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['Dialog']['title']}}</span>
      <!-- 新手教學 -->
      <span class="p-input-icon-right w-1/6" :class="{ 'ring-4 border-blue-400': msgGuideStep === 701 }">
        <input
          v-model="messageName"
          ref="titleText"
          class="p-inputtext p-component w-40 underline-box w-11/12"
          type="text"
          :placeholder="lang['views']['Msg']['Dialog']['title_placeholder']"
        />
        <i
          @click="$refs.titleText.focus()"
          class="pi pi-pencil cursor-pointer"
        ></i>
      </span>
    </template>

    <template v-slot:content>
      <div class="relative flex h-full">
        <div class="flex-none">
          <!-- 新手教學 -->
          <ShadowBox :padding="false" class="w-96 h-full" :class="{ 'ring-4 border-blue-400': msgGuideStep === 702 }">
            <div class="flex flex-col h-full scrollbar-y">
              <p class="p-2 border-b font-semibold">{{lang['views']['Msg']['Dialog']['ShadowBox']['title']}}</p>

              <div class="flex-grow">
                <template
                  v-for="(item, i) in getMsgLevelItem(
                    msgBox,
                    msgActive.level
                  )"
                  :key="i"
                >
                  <div
                    v-if="
                      item.id == msgActive.id && item.level == msgActive.level
                    "
                  >
                    <div v-for="(cItem, c) in item.info" :key="c" class="p-2">
                      <div class="relative">
                        <template v-if="cItem.type === 'content'">
                          <div class="relative flex">
                            <div
                              v-on:click="swapMsgInfo(c, c - 1)"
                              class="flex-none pt-2 cursor-pointer"
                            >
                              <img src="../../assets/up.svg" alt="" />
                            </div>
                            <div
                              v-on:click="swapMsgInfo(c, c + 1)"
                              class="flex-none pt-2 pr-1 cursor-pointer"
                            >
                              <img src="../../assets/down.svg" alt="" />
                            </div>
                            <div class="flex-grow">
                              <!-- 新手教學 -->
                              <textarea
                                :class="{ 'ring-4 border-blue-400': msgGuideStep === 708 }"
                                v-if="cItem.editType != 'video'"
                                v-model="cItem.content"
                                @change="bezierRefresh"
                                class="p-4 -mb-1 w-full bg-gray-light rounded-md"
                                rows="2"
                                :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['content']['content_placeholder']"
                              ></textarea>
                              <div
                                v-for="(vItem, v) in cItem.imgVideo"
                                :key="v"
                                class="relative"
                              >
                                <img
                                  v-if="vItem.img"
                                  :src="vItem.img"
                                  class="flex-grow w-full h-auto object-cover"
                                />
                                <img
                                  v-if="vItem.video"
                                  :src="vItem.video"
                                  class="flex-grow w-full h-auto object-cover"
                                />
                                <div class="relative">
                                  <!-- 新手教學 -->
                                  <FormInput
                                    v-if="vItem.img"
                                    v-model="vItem.title"
                                    :on-Change="bezierRefresh"
                                    :inputClass="['text-center',msgGuideStep === 725 ? 'ring-4 border-blue-400' : null ]"
                                    :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['content']['image_title_placeholder']"
                                  />
                                </div>
                              </div>
                              <div
                                v-for="(bItem, b) in cItem.btn"
                                :key="b"
                                class="relative"
                              >
                                <div
                                  v-on:click="swapMsgInfoBtn(b, b - 1, cItem.id)"
                                  class="absolute top-4 left-3 z-10 cursor-pointer"
                                >
                                  <img src="../../assets/up.svg" alt="" />
                                </div>
                                <div
                                  v-on:click="swapMsgInfoBtn(b, b + 1, cItem.id)"
                                  class="absolute top-4 left-6 z-10 cursor-pointer"
                                >
                                <img src="../../assets/down.svg" alt="" />
                                </div>
                                <i
                                  v-if="bItem.type != '1'"
                                  v-on:click="removeBotton(b, bItem.id, c)"
                                  class="pi pi-times absolute top-3 right-8 z-10 cursor-pointer text-gray-400"
                                ></i>
                                <!-- 新手教學 -->
                                <i
                                  v-on:click="
                                    openContentInfoBtn(cItem.id, bItem.id)
                                  "
                                  class="pi pi-pencil absolute top-3 right-2 z-10 cursor-pointer text-gray-400"
                                  :class="{ 'ring-4 border-blue-400': msgGuideStep === 720 }"
                                ></i>

                                <!-- 新手教學 -->
                                <FormInput
                                  v-model="bItem.text"
                                  :on-Change="bezierRefresh"
                                  :inputClass="['text-center',msgGuideStep === 727 ? 'ring-4 border-blue-400' : null ]"
                                  :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['content']['button_text_placeholder']"
                                />
                              </div>

                              <!-- 新手教學 -->
                              <button
                                @click="openContentTypeWindows(cItem.id, cItem.editType, cItem.btn.length)"
                                class="button dashed w-full"
                                :class="{ 'ring-4 border-blue-400': msgGuideStep === 715 || msgGuideStep === 728 }"
                                v-if="msgActive.status != 'fast'"
                              >
                                <!-- cItem.btn.push('') -->
                                <img
                                  class="mr-2 inline-block align-baseline"
                                  src="../../assets/add_gray.svg"
                                />
                                {{lang['views']['Msg']['Dialog']['ShadowBox']['content']['add_button_text']}}
                              </button>
                            </div>
                          </div>
                        </template>
                        <template v-else-if="cItem.type === 'img'">
                          <div class="relative flex">
                            <div
                              v-on:click="swapMsgInfo(c, c - 1)"
                              class="flex-none pt-2 cursor-pointer"
                            >
                              <img src="../../assets/up.svg" alt="" />
                            </div>
                            <div
                              v-on:click="swapMsgInfo(c, c + 1)"
                              class="flex-none pt-2 pr-1 cursor-pointer"
                            >
                              <img src="../../assets/down.svg" alt="" />
                            </div>

                            <div class="flex-grow">
                              <textarea
                                v-if="cItem.editType != 'video'"
                                v-model="cItem.content"
                                @change="bezierRefresh"
                                class="p-4 -mb-1 w-full bg-gray-light rounded-md"
                                rows="2"
                                :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['img']['content_placeholder']"
                              ></textarea>
                              <!-- <img
                                :src="cItem.img"
                                class="flex-grow mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                              /> -->
                              <img
                                :src="cItem.img"
                                class="flex-grow w-full h-auto object-cover rounded-t-xl rounded-b-none"
                              />
                              <div class="relative">
                                <FormInput
                                  v-model="cItem.title"
                                  :on-Change="bezierRefresh"
                                  inputClass="text-center"
                                  :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['img']['image_title_placeholder']"
                                />
                              </div>
                              <div
                                v-for="(bItem, b) in cItem.btn"
                                :key="b"
                                class="relative"
                              >
                                <div
                                  v-on:click="swapMsgInfoBtn(b, b - 1, cItem.id)"
                                  class="absolute top-4 left-3 z-10 cursor-pointer"
                                >
                                  <img src="../../assets/up.svg" alt="" />
                                </div>
                                <div
                                  v-on:click="swapMsgInfoBtn(b, b + 1, cItem.id)"
                                  class="absolute top-4 left-6 z-10 cursor-pointer"
                                >
                                  <img src="../../assets/down.svg" alt="" />
                                </div>
                                <i
                                  v-if="bItem.type != '1'"
                                  v-on:click="removeBotton(b, bItem.id)"
                                  class="pi pi-times absolute top-3 right-8 z-10 cursor-pointer text-gray-400"
                                ></i>
                                <i
                                  v-on:click="
                                    openContentInfoBtn(cItem.id, bItem.id)
                                  "
                                  class="pi pi-pencil absolute top-4 right-2 z-10 cursor-pointer text-gray-400"
                                ></i>

                                <FormInput
                                  v-model="bItem.text"
                                  :on-Change="bezierRefresh"
                                  inputClass="text-center"
                                  :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['img']['button_text_placeholder']"
                                />
                              </div>

                              <button
                                @click="openContentInfoBtn(cItem.id)"
                                class="button dashed w-full"
                              >
                                <!-- cItem.btn.push('') -->
                                <img
                                  class="mr-2 inline-block align-baseline"
                                  src="../../assets/add_gray.svg"
                                />
                                {{lang['views']['Msg']['Dialog']['ShadowBox']['img']['add_button_text']}}
                              </button>
                            </div>
                          </div>
                        </template>
                        <template v-else-if="cItem.type === 'video'">
                          <div class=" relative flex">
                            <div
                              v-on:click="swapMsgInfo(c, c - 1)"
                              class="flex-none pt-2 cursor-pointer"
                            >
                              <img src="../../assets/up.svg" alt="" />
                            </div>
                            <div
                              v-on:click="swapMsgInfo(c, c + 1)"
                              class="flex-none pt-2 pr-1 cursor-pointer"
                            >
                              <img src="../../assets/down.svg" alt="" />
                            </div>

                            <div class="flex-grow">
                              <img
                                v-if="cItem.video"
                                :src="cItem.video"
                                class="flex-grow mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                              />
                              <div
                                v-for="(vItem, v) in cItem.imgVideo"
                                :key="v"
                                class="relative"
                              >
                                <img
                                  v-if="vItem.video"
                                  :src="vItem.video"
                                  class="flex-grow mt-1 w-full h-auto object-cover rounded-t-xl rounded-b-none"
                                />
                              </div>
                              <!-- <div class="relative">
                                <FormInput
                                  v-model="cItem.title"
                                  :on-Change="bezierRefresh"
                                  inputClass="text-center"
                                  placeholder="請輸入影片標題"
                                />
                              </div> -->
                              <div
                                v-for="(bItem, b) in cItem.btn"
                                :key="b"
                                class="relative"
                              >
                                <div
                                  v-on:click="swapMsgInfoBtn(b, b - 1, cItem.id)"
                                  class="absolute top-4 left-3 z-10 cursor-pointer"
                                >
                                  <img src="../../assets/up.svg" alt="" />
                                </div>
                                <div
                                  v-on:click="swapMsgInfoBtn(b, b + 1, cItem.id)"
                                  class="absolute top-4 left-6 z-10 cursor-pointer"
                                >
                                  <img src="../../assets/down.svg" alt="" />
                                </div>
                                <i
                                  v-if="bItem.type != '1'"
                                  v-on:click="removeBotton(b, bItem.id)"
                                  class="pi pi-times absolute top-3 right-8 z-10 cursor-pointer text-gray-400"
                                ></i>
                                <i
                                  v-on:click="
                                    openContentInfoBtn(cItem.id, bItem.id)
                                  "
                                  class="pi pi-pencil absolute top-4 right-2 z-10 cursor-pointer text-gray-400"
                                ></i>
                                <FormInput
                                  v-model="bItem.text"
                                  :on-Change="bezierRefresh"
                                  inputClass="text-center"
                                  :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['video']['button_text_placeholder']"
                                />
                              </div>

                              <button
                                @click="openContentInfoBtn(cItem.id)"
                                class="button dashed w-full"
                              >
                                <!-- cItem.btn.push('') -->
                                <img
                                  class="mr-2 inline-block align-baseline"
                                  src="../../assets/add_gray.svg"
                                />
                                {{lang['views']['Msg']['Dialog']['ShadowBox']['video']['add_button_text']}}
                              </button>
                            </div>
                          </div>
                        </template>

                        <!-- <div v-if="c > 0" class="absolute top-2 right-1"> -->
                        <div class="absolute top-2 right-1">
                          <div
                            @click="removeMsgBoxInfoConfirmed(cItem.id)"
                            class="p-2 bg-gray-300 rounded-md cursor-pointer"
                          >
                            <img src="../../assets/clear.svg" />
                          </div>
                        </div>
                      </div>
                    </div>

                    <div v-if="(item.isFirst != true || item.info.length == 0)" class="flex p-1">
                      <div v-if="msgActive.status != 'fast'" class="flex-grow p-1">
                        <button
                          @click="openMsgBoxImg(null)"
                          class="button dashed w-full"
                        >
                          <img
                            class="mr-2 inline-block align-baseline"
                            src="../../assets/img.svg"
                          />
                          {{lang['views']['Msg']['Dialog']['ShadowBox']['info']['add_image']}}
                        </button>
                      </div>
                      <div v-if="msgActive.status != 'fast'" class="flex-grow p-1">
                        <button
                          @click="openMsgBoxVideo(null)"
                          class="button dashed w-full"
                        >
                          <img
                            class="mr-2 inline-block align-baseline"
                            src="../../assets/video.svg"
                          />{{lang['views']['Msg']['Dialog']['ShadowBox']['info']['add_video']}}
                        </button>
                      </div>
                      <div class="flex-grow p-1">
                        <button
                          @click="setMsgBoxContent"
                          class="button dashed w-full"
                        >
                          <img
                            class="mr-2 inline-block align-baseline"
                            src="../../assets/content.svg"
                          />{{lang['views']['Msg']['Dialog']['ShadowBox']['info']['add_text']}}
                        </button>
                      </div>
                    </div>
                  </div>
                </template>
              </div>
              <div class="p-2 text-right border-b">
                <template
                  v-for="(item, i) in getMsgLevelItem(
                    msgBox,
                    msgActive.level,
                    msgActive.status
                  )"
                  :key="i"
                >
                  <div
                    v-for="(fItem, f) in item.fast"
                    v-if="item.id == msgActive.id && item.level == msgActive.level"
                    :key="f"
                    class="flex mb-2"
                  >
                    <div
                      v-on:click="swapMsgFast(f, f - 1)"
                      class="relative flex-none py-3 pl-1 cursor-pointer"
                    >
                      <img src="../../assets/up.svg" alt="" />
                    </div>
                    <div
                      v-on:click="swapMsgFast(f, f + 1)"
                      class="relative flex-none py-3 pr-1 cursor-pointer"
                    >
                      <img src="../../assets/down.svg" alt="" />
                    </div>
                    <!-- 新手教學 -->
                    <div class="flex-grow" :class="{ 'ring-4 border-blue-400': msgGuideStep === 710 }">
                      <FormInput
                        v-model="fItem.text"
                        :on-Change="bezierRefresh"
                        inputClass="text-center rounded-full"
                        :placeholder="lang['views']['Msg']['Dialog']['ShadowBox']['quickly']['title_placeholder']"
                      />
                    </div>
                    <div class="flex-none p-2">
                      <!-- 新手教學 -->
                      <div
                        :class="{ 'ring-4 border-blue-400': msgGuideStep === 711 }"
                        @click="removeMsgBoxFastConfirmed(fItem.id)"
                        class="p-2 bg-gray-300 rounded-md cursor-pointer"
                      >
                        <img src="../../assets/clear.svg" />
                      </div>
                    </div>
                  </div>
                </template>
                <!-- 新手教學 -->
                <button v-if="msgActive.status != 'general'" @click="setMsgBoxItemFast('','')" :class="{ 'ring-4 border-blue-400': msgGuideStep === 707 || msgGuideStep === 709 }" class="button border-gray">
                  {{lang['views']['Msg']['Dialog']['ShadowBox']['quickly']['add_button_text']}}
                </button>
              </div>
              <div class="p-4 text-right">
                <div
                  class="p-5 border border-gray bg-gray-light rounded-full"
                ></div>
              </div>
            </div>
          </ShadowBox>
        </div>
        <!-- 新手教學 -->
        <div class="relative flex-grow w-full scrollbar-x" :class="{ 'ring-4 border-blue-400': msgGuideStep === 703 }">
          <div class="relative flex w-full h-full scrollbar-y">
            <div id="ropebag"></div>
            <!-- 新手教學 -->
            <MsgBox
              v-for="(item, i) in msgBox.item"
              v-bind:lang="lang"
              :msgGuideStep="msgGuideStep"
              :key="i"
              :msgdata="msgBox"
              :msgactive="msgActive"
              :setMsgActive="setMsgActive"
              :removeMsgBox="removeMsgBoxConfirmed"
            />
          </div>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-right">
        <button class="button bg-blue" style="margin-right:48px;" @click="save()">{{lang['views']['Msg']['Dialog']['ShadowBox']['save_button']}}</button>
        <button v-if="false" class="button bg-yellow">{{lang['views']['Msg']['Dialog']['ShadowBox']['finish_button']}}</button>
      </div>
    </template>
  </ModifyWindows>

  <ModifyWindows v-model:show="showContentWindows" size="xs" :msgGuideStep="msgGuideStep">
    <template v-slot:header>
      <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['info_type_Dialog']['edit_title']}}</span>
      <!-- <span v-if="editPageType" class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['info_type_Dialog']['view_title']}}</span> -->
    </template>

    <template v-slot:content>
      <div class="p-2 w-full h-full">
        <!-- 新手教學 -->
        <FormInput
          v-model="contentInfoBtn.text"
          :inputClass="['mt-2 text-center', msgGuideStep === 718 ? 'ring-4 border-blue-400' : null]"
          :placeholder="lang['views']['Msg']['info_type_Dialog']['button_name_placeholder']"
        />
        <!-- 新手教學 -->
        <FormInput
          v-if="contentInfoBtn.active === 2 || msgGuideStep === 731"
          v-model="contentInfoBtn.url"
          :inputClass="['mt-2 text-center', msgGuideStep === 731 ? 'ring-4 border-blue-400' : null]"
          :placeholder="lang['views']['Msg']['info_type_Dialog']['link_placeholder']"
        />
        <!-- 新手教學 -->
        <FormInput
          v-if="contentInfoBtn.active === 3 || msgGuideStep === 734"
          v-model="contentInfoBtn.phone"
          :inputClass="['mt-2 text-center', msgGuideStep === 734 ? 'ring-4 border-blue-400' : null]"
          oninput="value=value.replace(/[^\d]/g,'')"
          placeholder="ex：0912345678 or 886912345678"
        />

        <p class="mt-4 font-semibold">{{lang['views']['Msg']['info_type_Dialog']['block_info']}}</p>
        <!-- 新手教學 -->
        <button
          @click="setNewNode()"
          :class="{ active: contentInfoBtn.active == 1, 'ring-4 border-blue-400': msgGuideStep === 717 }"
          class="mt-2 button dashed w-full"
        >
          <i class="mr-2 pi pi-align-left"></i>
          {{lang['views']['Msg']['info_type_Dialog']['add_node']}}
        </button>
        <!-- 新手教學 -->
        <button
          @click="contentInfoBtn.active = 2"
          :class="{ active: contentInfoBtn.active == 2 || msgGuideStep === 730 || msgGuideStep === 731, 'ring-4 border-blue-400': msgGuideStep === 731 }"
          class="mt-2 button dashed w-full"
        >
          <i class="mr-2 pi pi-link"></i>
          {{lang['views']['Msg']['info_type_Dialog']['add_link']}}
        </button>
        <!-- 新手教學 -->
        <button
          @click="contentInfoBtn.active = 3"
          :class="{ active: contentInfoBtn.active == 3 || msgGuideStep === 733 || msgGuideStep === 734, 'ring-4 border-blue-400': msgGuideStep === 734 }"
          class="mt-2 button dashed w-full"
        >
          <i class="mr-2 pi pi-phone"></i>
          {{lang['views']['Msg']['info_type_Dialog']['add_phone']}}
        </button>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-right">
        <button @click="showContentWindows = false" class="button bg-yellow">
          {{lang['views']['Msg']['info_type_Dialog']['cancel_button']}}
        </button>
        <!-- 新手教學 -->
        <button @click="setMsgBoxItemBtn()" class="button bg-yellow" :class="{ 'ring-4 border-blue-400': msgGuideStep === 719 }">
          {{lang['views']['Msg']['info_type_Dialog']['yes_button']}}
        </button>
      </div>
    </template>
  </ModifyWindows>

  <ModifyWindows v-model:show="showContentTypeWindows" size="xs" :msgGuideStep="msgGuideStep">
    <template v-slot:header>
      <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['select_info_type_Dialog']['title']}}</span>
    </template>

    <template v-slot:content>
      <div class="p-2 w-full h-full">
        <div class="flex-grow p-1">
          <!-- 新手教學 -->
          <button
            @click="openMsgBoxImg(contentInfoTypeWindowsId, contentInfoTypeWindowsEditType)"
            :class="{ 'ring-4 border-blue-400': msgGuideStep === 724 }"
            class="button dashed w-full"
            :disabled="contentInfoTypeWindowsEditType == 'video' && contentInfoTypeWindowsEditType != 'text'"
          >
            <img
              class="mr-2 inline-block align-baseline"
              src="../../assets/img.svg"
            />
            {{lang['views']['Msg']['select_info_type_Dialog']['add_image']}}
          </button>
        </div>
        <div class="flex-grow p-1">
          <!-- 新手教學 -->
          <button
            :class="{ 'ring-4 border-blue-400': msgGuideStep === 722 }"
            @click="openMsgBoxVideo(contentInfoTypeWindowsId, contentInfoTypeWindowsEditType)"
            class="button dashed w-full"
            :disabled="contentInfoTypeWindowsEditType == 'img' && contentInfoTypeWindowsEditType != 'text'"
          >
            <img
              class="mr-2 inline-block align-baseline"
              src="../../assets/video.svg"
            />{{lang['views']['Msg']['select_info_type_Dialog']['add_video']}}
          </button>
        </div>
        <div class="flex-grow p-1">
          <!-- 新手教學 -->
          <button
            :class="{ 'ring-4 border-blue-400': msgGuideStep === 718 }"
            @click="openContentInfoBtn(contentInfoTypeWindowsId)"
            class="button dashed w-full"
            :disabled="nodeBottonNum >= 3"
          >
            <img
              class="mr-2 inline-block align-baseline"
              src="../../assets/content.svg"
            />{{lang['views']['Msg']['select_info_type_Dialog']['add_button_text']}}
          </button>
        </div>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-right">
        <button
          @click="showContentTypeWindows = false"
          class="button bg-yellow"
        >
          {{lang['views']['Msg']['select_info_type_Dialog']['cancel_button']}}
        </button>
        <button @click="setMsgBoxItemBtn()" class="button bg-yellow">
          {{lang['views']['Msg']['select_info_type_Dialog']['yes_button']}}
        </button>
      </div>
    </template>
  </ModifyWindows>

  <ModifyWindows v-model:show="showImgWindows" :msgGuideStep="msgGuideStep">
    <template v-slot:header>
      <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['image_Dialog']['title']}}</span>
      <button @click="$refs.imgUpload.click()" class="button border-blue">
        <img
          class="mr-2 inline-block align-baseline"
          src="../../assets/upload.svg"
        />{{lang['views']['Msg']['image_Dialog']['upload']}}
      </button>
      <input ref="imgUpload" type="file" class="hidden" @change="onImgUpload($event)" />
      <button @click="imageUpdate()" class="ml-3 button border-blue">
        {{lang['views']['Msg']['image_Dialog']['update']}}
      </button>
    </template>

    <template v-slot:content>
      <div style="height: 325px; position:relative">
        <loading :active="!showImgLoading"
                :can-cancel="true"
                :is-full-page="false"
                :color="'#fff'"
                :background-color="'#000'"
                :opacity="'0.8'">
        </loading>
        <span class="text-grap-700 align-middle">{{lang['views']['Msg']['image_Dialog']['upload_block_title']}}</span>
        <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
          <template
            v-for="(item, i) in img.imgList"
            :key="i">
            <img
              @click="selectImg(i, 'upload')"
              :class="{ 'border-blue-light': img.active == i }"
              :src="img.imgList[i].url"
              class="
                flex-none
                m-2
                mb-4
                w-24
                h-24
                border-4 border-transparent
                object-cover
                rounded-xl
                cursor-pointer
                relative
              "
            />
            <div class="bg-gray-300 rounded-md relative cursor-pointer" :style="'top:12px; left: -28px; height:20px;'" @click="deleteUpload(img.imgList[i].ctm_media, 'image')">
              <img src="../../assets/clear.svg" width="15" />
            </div>
          </template>
        </div>
        <span class="text-grap-700 align-middle">{{lang['views']['Msg']['image_Dialog']['facebook_block_title']}}</span>
        <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
          <img
            v-for="(item, i) in img.imgListApi"
            :key="i"
            @click="selectImg(i, 'api')"
            :class="{ 'border-blue-light': img.activeApi == i }"
            :src="img.imgListApi[i].url"
            class="
              flex-none
              m-2
              mb-4
              w-24
              h-24
              border-4 border-transparent
              object-cover
              rounded-xl
              cursor-pointer
            "
          />
        </div>
        <span v-if="img.imgListApi.length <= 0" class="text-grap-700 align-middle ml-5">{{lang['views']['Msg']['image_Dialog']['empty_block_title']}}</span>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-right">
        <button @click="setMsgBoxImg" class="button bg-yellow" style="margin-right:48px;">{{lang['views']['Msg']['image_Dialog']['yes_button']}}</button>
      </div>
    </template>
  </ModifyWindows>

  <ModifyWindows v-model:show="showMsgVideoWindows" :msgGuideStep="msgGuideStep">
    <template v-slot:header>
      <span class="mr-2 text-2xl font-semibold align-sub">{{lang['views']['Msg']['video_Dialog']['title']}}</span>
      <button @click="$refs.videoUpload.click()" class="button border-blue" v-if="this.msgActive.level != 0">
        <img
          class="mr-2 inline-block align-baseline"
          src="../../assets/upload.svg"
        />{{lang['views']['Msg']['video_Dialog']['upload']}}
      </button>
      <input ref="videoUpload" type="file" class="hidden" @change="onVideoUpload($event)" />
      <button @click="videoUpdate()" class="ml-3 button border-blue">
        {{lang['views']['Msg']['video_Dialog']['update']}}
      </button>
    </template>

    <template v-slot:content>
      <div style="height: 325px; position:relative">
        <loading :active="!showVideoLoading"
                :can-cancel="true"
                :is-full-page="false"
                :color="'#fff'"
                :background-color="'#000'"
                :opacity="'0.8'">
        </loading>
        <span class="text-grap-700 align-middle">{{lang['views']['Msg']['video_Dialog']['upload_block_title']}}</span>
        <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
          <template
            v-for="(item, i) in video.videoList"
            :key="i">
              <img
                @click="selectVideo(i, 'upload')"
                :class="{ 'border-blue-light': video.active == i }"
                :src="video.videoList[i].url"
                class="
                  flex-none
                  m-2
                  mb-4
                  w-24
                  h-24
                  border-4 border-transparent
                  object-cover
                  rounded-xl
                  cursor-pointer
                  relative
                "
              />
              <div class="bg-gray-300 rounded-md relative cursor-pointer" :style="'top:12px; left: -28px; height:20px;'" @click="deleteUpload(video.videoList[i].ctm_media, 'video')">
                <img src="../../assets/clear.svg" width="15" />
              </div>
          </template>
        </div>
        <span class="text-grap-700 align-middle">{{lang['views']['Msg']['video_Dialog']['facebook_block_title']}}</span>
        <div class="flex flex-wrap p-2 w-full h-auto scrollbar-y">
          <img
            v-for="(item, i) in video.videoListApi"
            :key="i"
            @click="selectVideo(i, 'api')"
            :class="{ 'border-blue-light': video.activeApi == i }"
            :src="video.videoListApi[i].url"
            class="
              flex-none
              m-2
              mb-4
              w-24
              h-24
              border-4 border-transparent
              object-cover
              rounded-xl
              cursor-pointer
            "
          />
        </div>
        <span v-if="video.videoListApi.length <= 0" class="text-grap-700 align-middle ml-5">{{lang['views']['Msg']['video_Dialog']['empty_block_title']}}</span>
      </div>
    </template>

    <template v-slot:footer>
      <div class="text-right">
        <button @click="setMsgBoxVideo" class="button bg-yellow" style="margin-right:48px;">{{lang['views']['Msg']['video_Dialog']['yes_button']}}</button>
      </div>
    </template>
  </ModifyWindows>
</template>
<script>
import { ref } from 'vue'
import InputSwitch from 'primevue/inputswitch';
import AddMaterial from "@/components/CustomizeEvent/AddMaterial.vue";
import EditMaterial from "@/components/CustomizeEvent/EditMaterial.vue";
import SelectAdsetAdsDialog from "@/components/Dialog/SelectAdsetAdsDialog.vue";
import SelectCreativeDialog from "@/components/Dialog/SelectCreativeDialog.vue";
import SelectPostDialog from "@/components/Dialog/SelectPostDialog.vue";
import AiPictureMaterialDialog from "@/components/Dialog/AiPictureMaterialDialog.vue";
import Swal from 'sweetalert2/dist/sweetalert2.js'
import 'sweetalert2/dist/sweetalert2.min.css'
import Loading from 'vue3-loading-overlay';
import 'vue3-loading-overlay/dist/vue3-loading-overlay.css';
import "vue3-circle-progress/dist/circle-progress.css";
import Vue3DraggableResizable from 'vue3-draggable-resizable'
import 'vue3-draggable-resizable/dist/Vue3DraggableResizable.css'
import axios from 'axios'
import Qs from 'qs'

import draggable from "vuedraggable";
import TabView from "primevue/tabview";
import TabPanel from "primevue/tabpanel";
import Dropdown from "primevue/dropdown";
import fb1Image from "@/assets/fb_1.png";
import fb2Image from "@/assets/fb_2.png";
import ModifyWindows from "@/components/ModifyWindows.vue";

import RadioButton from "primevue/radiobutton";

import Mask from '@/components/Event/Mask.vue';
import FormGuideTips from '@/components/Tips/FormGuideTips.vue';
import ShadowBox from "@/components/ShadowBox.vue";
import Checkbox from "primevue/checkbox";
import CascadeSelect from "primevue/cascadeselect";
import FormInput from "@/components/Form/Input.vue";
import FormTextarea from "@/components/Form/Textarea.vue";

import MsgGuideTips from '@/components/Tips/MsgGuideTips.vue';
import MsgBox from "@/components/MsgBox.vue";

export default {
  name: "Material",
  components: {
    InputSwitch,
    AddMaterial,
    EditMaterial,
    SelectAdsetAdsDialog,
    SelectCreativeDialog,
    SelectPostDialog,
    AiPictureMaterialDialog,
    Loading,
    draggable,
    TabView,
    TabPanel,
    Dropdown,
    ModifyWindows,
    RadioButton,
    Mask,
    FormGuideTips,
    ShadowBox,
    Checkbox,
    CascadeSelect,
    FormInput,
    FormTextarea,
    MsgGuideTips,
    MsgBox,
  },
  props: {
    // <!-- 新手教學 -->
    showStageMaterial: {
      type: Boolean
    },
    showStageAdvertisingMaterial: {
      type: Boolean
    },
    showStageForm:{
      type: Boolean
    },
    showStageMsg:{
      type: Boolean
    },
    guideStep: {
      type: Number,
      default: -1
    },
    // <!-- 新手教學 -->
    editPage: {
      type: Boolean
    },
    viewDatalist: {
      type: Object
    },
    stageContent:{
      type: Object
    },
    stageContentAll:{
      type: Object
    },
    stageIndex: {
      type: Number
    },
    viewAdMaterialDatalist: {
      type: Object
    },
    pageId: {
      type:String
    },
    goalsObjective:{
      type:String
    },
    campaignId: {
      type:String
    },
    campaign_objective:{
      type:String
    },
    selectStatus: {
      type: Boolean
    },
    lang: {
      type: Object
    },
    youtubeClose: {
      type: Boolean
    },
    changeFormId: {
      type: Number
    },
    changeMessageId: {
      type: Number
    },
    // <!-- 即時表單 -->
    formId: {
      type:String
    },
    firstFormId: {
      type:String
    },
    formStatus: {
      type:String
    },
    useTeachDetail: {
      type: Boolean
    },
    targetAllSkip:{
      type: Number
    },
    formTeachingOver: {
      type: Boolean
    },
    teachingId: {
      type: Number,
      default: -1
    },
    selectLang: {
      type:String,
      default: 'zh-TW'
    },
    // <!-- 訊息範本 -->
    messageId: {
      type:String
    },
    firstMessageId: {
      type:String
    },
    messageStatus: {
      type:String
    },
    targetAllSkip:{
      type: Number
    },
    msgTeachingOver: {
      type: Boolean
    },
    showTargetCR: {
      type: Boolean
    },
    showOtherTargetCR: {
      type: Boolean
    }
  },
  data() {
    return {
      useStatus: false,
      MaterialShowMaterialMyside: true,
      showModal: false,
      showList: false,
      showAdsetAdsModal: false,
      showCreativeModal: false,
      showCreativeDialogMyside: false,
      showAddModal: false,
      showEditModal: false,
      editCreativesData: [],
      postsData: null,
      creativesData: null,
      adaccountCampaignsData: null,
      prviewHtml: [],
      selectObjective:null,
      items: [],
      itemsCount: 0,
      itemsDelete: [],
      itemsDeleteCount: 0,
      creativesItems: [],
      creativesItemsCount: 0,
      creativesItemsDelete: [],
      creativesItemsDeleteCount: 0,
      creativesMessageItems: [],
      creativesMessageItemsCount: 0,
      creativesMessageItemsDelete: [],
      creativesMessageItemsDeleteCount: 0,
      creativesAdsetAdsMessageItems: [],
      creativesAdsetAdsMessageItemsCount: 0,
      creativesAdsetAdsMessageItemsDelete: [],
      creativesAdsetAdsMessageItemsDeleteCount: 0,
      adsetAdsItems: [],
      adsetAdsItemsCount: 0,
      adsetAdsItemsDelete: [],
      adsetAdsItemsDeleteCount: 0,
      allCount: 0,
      prview: [],
      prview_post_list: [],
      prview_creatives: [],
      prview_creatives_list: [],
      prview_creatives_message: [],
      prview_creatives_message_list: [],
      prview_adset_ads_message: [],
      prview_adset_ads_message_list: [],
      prview_adset_ads: [],
      prview_adset_ads_list: [],
      prview_now: null,
      prview_creatives_now: null,
      prview_creatives_message_now: null,
      prview_adset_ads_message_now: null,
      prview_adset_ads_now: null,
      x: 0,
      y: 0,
      h: 200,
      w: 320,
      ai_x: 0,
      ai_y: 0,
      ai_h: 200,
      ai_w: 320,
      active: false,
      src: "https://www.youtube.com/watch?v=3wGiBNSfa8E",
      vars: {
        rel: 0,
        start: 0,
        end: 0,
      },
      view_youtube: false,
      view_ai: false,
      materialStatus: false,
      advertisingMaterialStatus: false,
      isEdit: false,
      useStatus: false,
      showMaterialSingle: true,
      showMaterial: true,
      showVideoLoading: true,
      currentTab: 0,
      fb1Image: fb1Image,
      fb2Image: fb2Image,
      auto: true,
      type: 1,
      activeType: 1,
      activeItem: 0,
      focusType: 0,
      selectedForm: 'image',
      ad_prview_now: null,
      ad_prview_single: null,
      nowItemIndex: 0,
      materials: [
        {
          imgSrc: null,
          title: "",
          description: "",
          website: "",
          isEdit: false
        },
        {
          imgSrc: "http://placehold.it/100x100",
          title: "",
          description: "",
          website: "",
          isEdit: false
        }
      ],
      showPostModal: false,
      call: null,
      moreInput: true,
      adItems: [],
      showVideoWindows: false,
      image: {
        active: null,
        imageList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        imageListSpec: [],
        imageListName: [],
        imageListTitle: []
      },
      video: {
        active: null,
        videoList: [
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg",
          "./video.jpg"
        ],
        videoListSpec: [],
        videoListName: [],
        videoListTitle: []
      },
      imageAfter: '',
      videoAfter: '',
      materialSingle: [
        {
          src: "http://placehold.it/100x100",
          title: "test",
          size: "800*800"
        }
      ],
      callActiveList: [],
      stageMaterialStatus: null,
      stageAdvertisingMaterial: null,
      stageForm: null,
      stageMsg: null,
      // <!-- 新手教學 -->
      formTeaching_id: 0,
      formTeachingOverData: 0,
      formGuideStep: -1,
      formGuide: true,
      // <!-- 新手教學 -->
      showFormList: false,
      showFormModal: false,
      hint: false,
      preview: 1,
      previewTitle: "",
      selectedItem: null,
      immediateList: [],
      editType: 0,
      form3Options:[],
      countryCodeListBase:[
        { name: '阿根廷（+54）', code: 'AR' },
        { name: '澳大利亞（+61）', code: 'AU' },
        { name: '巴西（+55）', code: 'BR' },
        { name: '中國（+86）', code: 'CN' },
        { name: '哥倫比亞（+57）', code: 'CO' },
        { name: '英國（+44）', code: 'GB' },
        { name: '香港（+852）', code: 'HK' },
        { name: '日本（+81）', code: 'JP' },
        { name: '南韓（+82）', code: 'KR' },
        { name: '澳門（+853）', code: 'MO' },
        { name: '墨西哥（+52）', code: 'MX' },
        { name: '馬來西亞（+60）', code: 'MY' },
        { name: '奈及利亞（+234）', code: 'NG' },
        { name: '菲律賓（+63）', code: 'PH' },
        { name: '新加坡（+65）', code: 'SG' },
        { name: '薩爾瓦多（+503）', code: 'SV' },
        { name: '泰國（+66）', code: 'TH' },
        { name: '台灣（+886）', code: 'TW' },
        { name: '美國（+1）', code: 'US' },
        { name: '越南（+84）', code: 'VN' },
        { name: '南非（+27）', code: 'ZA' },
      ],
      menuActive: 1,
      formData: {
        form1: {
          type: "0"
        },
        form2: {
          isOpen: false,
          title: "",
          introductionType: "0",
          introduction: "",
          introductionItem: ["", "", "", "", ""]
        },
        form3: {
          type: "",
          single: [],
          other: []
        },
        form4: {
          type: "",
          instruction: "",
          isOpenInstruction: false,
          isCountries: [],
          countries: [],
          dataType: []
        },
        form5: {
          isOpen: false,
          url: "",
          urlText: "",
          content: "",
          agree: []
        },
        from6: {},
        form7: {
          title: "",
          main: "",
          web: "",
          countryCode:{ name: '台灣（+886）', code: 'TW' },
          business_phone_number: "",
          btntext: "",
          url: ""
        },
        form8: {
          lang: "",
          shareType: "0"
        },
        focus: ""
      },
      // <!-- 新手教學 -->
      msgTeaching_id: 0,
      msgTeachingOverData: 0,
      msgGuideStep: -1,
      msgGuide: true,
      // <!-- 新手教學 -->
      showMsgList: false,
      showMsgModal: false,
      showImgWindows: false,
      showMsgVideoWindows: false,
      showContentWindows: false,
      showContentTypeWindows: false,
      contentInfoTypeWindowsId: null,
      showMsgImgLoading: true,
      showMsgVideoLoading: true,
      nodeBottonNum: 0,
      contentInfoTypeWindowsEditType: 'text',
      nodeId: 3,
      view_type: 'copy',
      contentInfoBtn: {
        text: "",
        url: "",
        phone: "",
        active: 1,
        contentId: null,
        btnId: null
      },
      messageList: [],
      editMsgType: 0,
      selectedMsgItem: null,
      data: [
        {
          checked: false,
          title: "訊息一",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息二",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息三",
          status: "error",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息四",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息五",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息六",
          status: "error",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息七",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息八",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息九",
          status: "error",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息十",
          status: "formal",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息十一",
          status: "draft",
          date: "2021-05-20"
        },
        {
          checked: false,
          title: "訊息十二",
          status: "error",
          date: "2021-05-20"
        }
      ],

      msgActive: {
        id: 0,
        level: 0,
        status: 'first'
      },
      msgBox: {},
      img: {
        active: null,
        activeApi: null,
        imgList: [],
        imgListApi: []
      },
      videoMsg: {
        active: null,
        activeApi: null,
        videoList: [],
        videoListApi: []
      },
      isPostDataUpdating: false,
      isAdMaterialDataUpdating: false,
      aiWord: null,
      aiType: null,
      aiMainIndex: null,
      aiItemIndex: null,
      formTarget: null,
      aiContentProcessing: false,
      itemCheckedIndex: null,
      aiContentReturn: [],
      processText: '產生',
      formActive: 'customize',
      showAiPictureModal: false,
      _useStatus: false,
      showUploadWindows: false,
      useUpload: false,
      selectedFiles: [], // 存储选中的文件
      uploadResults: [], // 存储每张图片的上传结果
      isUploading: false, // 上传状态
    };
  },
  // watch: {
  //     'items': {
  //         handler: function (after, before) {
  //             // Changes detected. Do work...
  //             console.log('after:'+after);
  //             console.log('before:'+before);
  //         },
  //         deep: true
  //     }
  // },
  watch: {
    showStageMaterial(value){
      console.log('stage showStageMaterial');
      console.log(this.showStageMaterial);

      let _tmpShowStageMaterial = this.showStageMaterial.split('_');

      this.stageMaterialStatus = _tmpShowStageMaterial[0];
    },
    showStageAdvertisingMaterial(value){
      console.log('stage showStageAdvertisingMaterial');
      console.log(this.showStageAdvertisingMaterial);

      let _tmpShowStageAdvertisingMaterial = this.showStageAdvertisingMaterial.split('_');

      this.stageAdvertisingMaterial = _tmpShowStageAdvertisingMaterial[0];
    },
    showStageForm(value){
      console.log('stage showStageForm');
      console.log(this.showStageForm);

      let _tmpShowStageForm = this.showStageForm.split('_');

      this.stageForm = _tmpShowStageForm[0];
    },
    showStageMsg(value){
      console.log('stage showStageMsg');
      console.log(this.showStageMsg);

      let _tmpShowStageMsg = this.showStageMsg.split('_');

      this.stageMsg = _tmpShowStageMsg[0];
    },
    lang(value){
      console.log('AdvertisingMaterial value');
      console.log(value);

      this.viewAdMaterialDatalistData.creative_array = [
        {
          title: this.lang['components']['Event']['AdvertisingMaterial']['item_title'],
          isEdit: false,
          type: 1,
          tagType: 0,
          materials: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 0
            },
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              title: null,
              description: null,
              website: null,
              isEdit: false,
              index: 1
            }
          ],
          materialSingle: [
            {
              id: null,
              imgSrc: null,
              object_spec: {
                name: null,
                width: null,
                height: null
              },
              fileName: null,
              title: null,
              description: null,
              website: null,
              size: null,
              index: 0
            }
          ],
          callActive: 'SIGN_UP',
          form_sr_i: null,
          message_sr_i: null
        },
      ];

      this.callActiveList = [
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['apply_now'],
          code: 'APPLY_NOW'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['book_travel'],
          code: 'BOOK_TRAVEL'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['download'],
          code: 'DOWNLOAD'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_offer'],
          code: 'GET_OFFER'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_quote'],
          code: 'GET_QUOTE'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['learn_more'],
          code: 'LEARN_MORE'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['sign_up'],
          code: 'SIGN_UP'
        },
        {
          name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['subscribe'],
          code: 'SUBSCRIBE'
        }
      ];

      this.previewTitle = this.lang['views']['Form']['Dialog']['data']['previewTitle'];

      this.form3Options = [
                            { name: this.lang['views']['Form']['Dialog']['form3Options']['code_01'], code: '01', type: 'CUSTOM' },
                            { name: this.lang['views']['Form']['Dialog']['form3Options']['code_02'], code: '02', type: 'CUSTOM' },
                            { name: this.lang['views']['Form']['Dialog']['form3Options']['code_03'], code: '03', type: 'DATE_TIME' }
                          ];

      this.countryCodeListBase = [
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['AR'], code: 'AR' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['AU'], code: 'AU' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['BR'], code: 'BR' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['CN'], code: 'CN' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['CO'], code: 'CO' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['GB'], code: 'GB' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['HK'], code: 'HK' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['JP'], code: 'JP' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['KR'], code: 'KR' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['MO'], code: 'MO' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['MX'], code: 'MX' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['MY'], code: 'MY' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['NG'], code: 'NG' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['PH'], code: 'PH' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['SG'], code: 'SG' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['SV'], code: 'SV' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['TH'], code: 'TH' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['TW'], code: 'TW' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['US'], code: 'US' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['VN'], code: 'VN' },
        { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['ZA'], code: 'ZA' },
      ];

      this.formData.form7.countryCode = { name: this.lang['views']['Form']['Dialog']['countryCodeListBase']['TW'], code: 'TW' };

      this.msgBox = {
        item: [
          {
            id: 0,
            level: 0,
            isFirst: true,
            status:'first',
            info: [
              {
                id: 2,
                editType: 'text',
                content: this.lang['views']['Msg']['msgBox_item_info_content'],
                btn: [],
                imgVideo: [],
                type: "content"
              }
            ],
            fast: []
          }
        ],
        sub: {}
      };
    },
    'youtubeClose':function(v){
      console.log('marketingmethod youtubeClose');
      console.log(v);

      let _tmpYoutubeType = v.split('_');

      console.log('_tmpYoutubeType');
      console.log(_tmpYoutubeType);

      console.log(typeof this.view_youtube);
      console.log(this.view_youtube);

      if(_tmpYoutubeType[0] != null && _tmpYoutubeType[0] != '' && typeof _tmpYoutubeType[0] != 'undefined'){
        if(_tmpYoutubeType[0] == 'false' || _tmpYoutubeType[1] != 'material'){
          this.view_youtube = false
        }
      }

      console.log(typeof this.view_youtube);
      console.log(this.view_youtube);
    },
    // <!-- 新手教學 -->
    guideStep(val) {
      if (val === 53) {
        this.posts_data();
      }

      if (val === 502) {
        this.adset_ads_data();
      }

      if (val == 57) {
        console.log('guideStep this.stageContenttData.postData.select_article');
        console.log(this.stageContenttData.postData.select_article);
        // this.showModal = false;
      }

      if (val === 67) {
        this.changeType(0, 2);
      }

      if (val === 71) {
        this.viewAdMaterialDatalistData.creative_array[0].materials[0].isEdit = !this.viewAdMaterialDatalistData.creative_array[0].materials[0].isEdit;
      }
    },
    // <!-- 新手教學 -->
    'stageContenttData': function(v){
      console.log('CustomizeEvent PositionAndDevice stageContenttData');
      console.log(v);
      console.log(this.stageIndex);
      console.log(this.stageContentAllData);

      let _beforeIndex = this.stageIndex - 1;
      let _tmpThisMethod = this.stageContentAllData.subCampaignsContent[this.stageIndex].method;
      let _tmpBeforeMethod = '';
      let metaList = ['META_TEST','META_KW','META_LA','META_RT','META_ASC'];
      let tiktokList = ['TIKTOK_KW','TIKTOK_RT'];

      console.log('_beforeIndex');
      console.log(_beforeIndex);
      if(_beforeIndex >= 0){
        _tmpBeforeMethod = this.stageContentAllData.subCampaignsContent[_beforeIndex].method;
      }

      console.log(_tmpThisMethod+' vs '+_tmpBeforeMethod);

      let _thisIsMeta = false;
      let _beforeIsMeta = false;
      let _thisIsTiktok = false;
      let _beforeIsTiktok = false;
      let _allIsMeta = false;
      let _allIsTiktok = false;

      if (metaList.includes(_tmpThisMethod)) {
        _thisIsMeta = true
      }

      if (metaList.includes(_tmpBeforeMethod)) {
        _beforeIsMeta = true
      }

      if (tiktokList.includes(_tmpThisMethod)) {
        _thisIsTiktok = true
      }

      if (tiktokList.includes(_tmpBeforeMethod)) {
        _beforeIsTiktok = true
      }

      if(_thisIsMeta == true && _beforeIsMeta == true){
        _allIsMeta = true;
      }

      if(_thisIsTiktok == true && _beforeIsTiktok == true){
        _allIsTiktok = true;
      }

      if(_allIsMeta == true || _allIsTiktok == true){
        this._useStatus = true;
      } else {
        this._useStatus = false;
      }

      console.log('_thisIsMeta');
      console.log(_thisIsMeta);
      console.log('_beforeIsMeta');
      console.log(_beforeIsMeta);
      console.log('_thisIsTiktok');
      console.log(_thisIsTiktok);
      console.log('_beforeIsTiktok');
      console.log(_beforeIsTiktok);
      console.log('_allIsMeta');
      console.log(_allIsMeta);
      console.log('_allIsTiktok');
      console.log(_allIsTiktok);
      console.log('this._useStatus');
      console.log(this._useStatus);
    },
    'stageContenttData.postData.creative_optimize':function(v){
      console.log('stageContenttData.postData.creative_optimize');
      console.log(v);
      console.log('this.goalsObjectiveData');
      console.log(this.goalsObjectiveData);
      // let select_article_length = this.stageContenttData.postData.select_article.length;
      // let delete_article_length = this.stageContenttData.postData.delete_article.length;
      // let select_creatives_length = this.stageContenttData.postData.select_creatives.length;
      // let delete_creatives_length = this.stageContenttData.postData.delete_creatives.length;
      // let select_creatives_adset_ads_length = this.stageContenttData.postData.select_creatives_adset_ads.length;
      // let delete_creatives_adset_ads_length = this.stageContenttData.postData.delete_creatives_adset_ads.length;

      // this.stageContenttData.postData.creative_optimize = false;

      console.log('this.stageContenttData.postData.creative_optimize');
      console.log(this.stageContenttData.postData.creative_optimize);
    },
    items (value){
      console.log('items value');
      console.log(value);
      // console.log('b select_article');
      // console.log(this.stageContenttData.postData.select_article);
      // console.log('b prview_post_list');
      // console.log(this.prview_post_list);
      // console.log(this.prview);
      // this.stageContenttData.postData.select_article = value
      console.log('do items');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.select_article) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.select_article;

        for (let i = 0; i < this.stageContenttData.postData.select_article.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.select_article[i].content);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          // console.log('i:');
          // console.log(value[i]);
          if(!tmpSelectId.includes(value[i].content)){
            tmpSelectArticle.push(value[i]);
            // console.log('this.prview['+value[i]+']');
            // console.log(this.prview[value[i]]);
            if(typeof this.prview[value[i].content] != 'undefined'){
              this.prview_post_list[value[i].content] = this.prview[value[i].content];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.select_article = tmpSelectArticle;
      // console.log('a select_article');
      // console.log(this.stageContenttData.postData.select_article);
      // console.log('a prview_post_list');
      // console.log(this.prview_post_list);
    },
    itemsDelete (value){
      console.log('value');
      console.log(value);
      // console.log('b delete_article');
      // console.log(this.stageContenttData.postData.delete_article);
      // console.log('b prview_post_list');
      // console.log(this.prview_post_list);
      // console.log(this.prview);
      // this.stageContenttData.postData.delete_article = value
      console.log('do itemsDelete');
      console.log(this.stageContenttData.postData.delete_article);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.delete_article) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.delete_article;

        for (let i = 0; i < this.stageContenttData.postData.delete_article.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.delete_article[i].content);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);
      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          // console.log('i:');
          // console.log(value[i]);
          if(!tmpSelectId.includes(value[i].content)){
            tmpSelectArticle.push(value[i]);
            // console.log('this.prview['+value[i]+']');
            // console.log(this.prview[value[i]]);
            if(typeof this.prview[value[i].content] != 'undefined'){
              this.prview_post_list[value[i].content] = this.prview[value[i].content];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.delete_article = tmpSelectArticle;
      // console.log('a delete_article');
      // console.log(this.stageContenttData.postData.delete_article);
      // console.log('a prview_post_list');
      // console.log(this.prview_post_list);
    },
    creativesItems (value){
      console.log('value');
      console.log(value);
      console.log('b select_creatives');
      console.log(this.stageContenttData.postData.select_creatives);
      console.log('b prview_creatives_list');
      console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.select_creatives = value
      console.log('do creativesItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.select_creatives) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.select_creatives;

        for (let i = 0; i < this.stageContenttData.postData.select_creatives.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.select_creatives[i].item_id);
        }
      }

      console.log('tmpSelectId');
      console.log(tmpSelectId);
      console.log('b tmpSelectArticle');
      console.log(tmpSelectArticle);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives[value[i].item_id] != 'undefined'){
              this.prview_creatives_list[value[i].item_id] = this.prview_creatives[value[i].item_id];
            }
          } else {
            for(let j = 0; j < tmpSelectArticle.length; j++){
              console.log(j, tmpSelectArticle[j]);
              if(tmpSelectArticle[j].item_id == value[i].item_id){
                tmpSelectArticle.splice(j, 1);
              }
            }

            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives[value[i].item_id] != 'undefined'){
              this.prview_creatives_list[value[i].item_id] = this.prview_creatives[value[i].item_id];
            }
          }
        }
      }

      console.log('a tmpSelectArticle');
      console.log(tmpSelectArticle);

      this.stageContenttData.postData.select_creatives = tmpSelectArticle;
      console.log('a select_creatives');
      console.log(this.stageContenttData.postData.select_creatives);
      console.log('a prview_creatives_list');
      console.log(this.prview_creatives_list);
    },
    creativesItemsDelete (value){
      console.log('value');
      console.log(value);
      // console.log('b delete_creatives');
      // console.log(this.stageContenttData.postData.delete_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.delete_creatives = value
      console.log('do creativesItemsDelete');
      console.log(this.stageContenttData.postData.delete_creatives);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.delete_creatives) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.delete_creatives;

        for (let i = 0; i < this.stageContenttData.postData.delete_creatives.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.delete_creatives[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives[value[i].item_id] != 'undefined'){
              this.prview_creatives_list[value[i].item_id] = this.prview_creatives[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.delete_creatives = tmpSelectArticle;
      // console.log('a delete_creatives');
      // console.log(this.stageContenttData.postData.delete_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesMessageItems (value){
      console.log('value');
      console.log(value);
      // console.log('b select_creatives');
      // console.log(this.stageContenttData.postData.select_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.select_creatives = value
      console.log('do creativesMessageItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.select_creatives_message) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.select_creatives_message;

        for (let i = 0; i < this.stageContenttData.postData.select_creatives_message.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.select_creatives_message[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);
      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives_message[value[i].item_id] != 'undefined'){
              this.prview_creatives_message_list[value[i].item_id] = this.prview_creatives_message[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.select_creatives_message = tmpSelectArticle;
      // console.log('a select_creatives');
      // console.log(this.stageContenttData.postData.select_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesMessageItemsDelete (value){
      console.log('value');
      console.log(value);
      // console.log('b delete_creatives');
      // console.log(this.stageContenttData.postData.delete_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.delete_creatives = value
      console.log('do creativesMessageItemsDelete');
      console.log(this.stageContenttData.postData.delete_creatives);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.delete_creatives_message) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.delete_creatives_message;

        for (let i = 0; i < this.stageContenttData.postData.delete_creatives_message.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.delete_creatives_message[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_creatives_message[value[i].item_id] != 'undefined'){
              this.prview_creatives_message_list[value[i].item_id] = this.prview_creatives_message[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.delete_creatives_message = tmpSelectArticle;
      // console.log('a delete_creatives');
      // console.log(this.stageContenttData.postData.delete_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesAdsetAdsMessageItems (value){
      console.log('value');
      console.log(value);
      // console.log('b select_creatives');
      // console.log(this.stageContenttData.postData.select_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.select_creatives = value
      console.log('do creativesAdsetAdsMessageItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.select_creatives_adset_ads_message) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.select_creatives_adset_ads_message;

        for (let i = 0; i < this.stageContenttData.postData.select_creatives_adset_ads_message.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.select_creatives_adset_ads_message[i].item_id);
        }
      }

      console.log('tmpSelectId');
      console.log(tmpSelectId);
      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads_message[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_message_list[value[i].item_id] = this.prview_adset_ads_message[value[i].item_id];
            }
          }
        }
      }

      console.log('tmpSelectArticle');
      console.log(tmpSelectArticle);

      this.stageContenttData.postData.select_creatives_adset_ads_message = tmpSelectArticle;
      // console.log('a select_creatives');
      // console.log(this.stageContenttData.postData.select_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    creativesAdsetAdsMessageItemsDelete (value){
      console.log('value');
      console.log(value);
      // console.log('b delete_creatives');
      // console.log(this.stageContenttData.postData.delete_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.delete_creatives = value
      console.log('do creativesAdsetAdsMessageItemsDelete');
      console.log(this.stageContenttData.postData.delete_adset_ads_message);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.delete_adset_ads_message) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.delete_adset_ads_message;

        for (let i = 0; i < this.stageContenttData.postData.delete_adset_ads_message.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.delete_adset_ads_message[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads_message[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_message_list[value[i].item_id] = this.prview_adset_ads_message[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.delete_adset_ads_message = tmpSelectArticle;
      // console.log('a delete_creatives');
      // console.log(this.stageContenttData.postData.delete_creatives);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    adsetAdsItems (value){
      console.log('value');
      console.log(value);
      // console.log('b select_creatives');
      // console.log(this.stageContenttData.postData.select_creatives);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.select_creatives = value
      console.log('do adsetAdsItems');

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.select_creatives_adset_ads) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.select_creatives_adset_ads;

        for (let i = 0; i < this.stageContenttData.postData.select_creatives_adset_ads.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.select_creatives_adset_ads[i].item_id);
        }
      }

      console.log('tmpSelectId');
      console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_list[value[i].item_id] = this.prview_adset_ads[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.select_creatives_adset_ads = tmpSelectArticle;
      // console.log('a select_creatives_adset_ads');
      // console.log(this.stageContenttData.postData.select_creatives_adset_ads);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    adsetAdsItemsDelete (value){
      console.log('value');
      console.log(value);
      // console.log('b delete_creatives_adset_ads');
      // console.log(this.stageContenttData.postData.delete_creatives_adset_ads);
      // console.log('b prview_creatives_list');
      // console.log(this.prview_creatives_list);
      // console.log(this.prview_creatives);
      // this.stageContenttData.postData.delete_creatives_adset_ads = value
      console.log('do adsetAdsItemsDelete');
      console.log(this.stageContenttData.postData.delete_creatives_adset_ads);

      let tmpSelectArticle = [];
      let tmpSelectId = [];
      if(typeof(this.stageContenttData.postData.delete_creatives_adset_ads) != 'undefined'){
        tmpSelectArticle = this.stageContenttData.postData.delete_creatives_adset_ads;

        for (let i = 0; i < this.stageContenttData.postData.delete_creatives_adset_ads.length; i++) {
          tmpSelectId.push(this.stageContenttData.postData.delete_creatives_adset_ads[i].item_id);
        }
      }

      // console.log('tmpSelectId');
      // console.log(tmpSelectId);

      if(typeof(value) != 'undefined'){
        for (let i = 0; i < value.length; i++) {
          if(!tmpSelectId.includes(value[i].item_id)){
            tmpSelectArticle.push(value[i]);
            if(typeof this.prview_adset_ads[value[i].item_id] != 'undefined'){
              this.prview_adset_ads_list[value[i].item_id] = this.prview_adset_ads[value[i].item_id];
            }
          }
        }
      }

      // console.log('tmpSelectArticle');
      // console.log(tmpSelectArticle);

      this.stageContenttData.postData.delete_creatives_adset_ads = tmpSelectArticle;
      // console.log('a delete_creatives_adset_ads');
      // console.log(this.stageContenttData.postData.delete_creatives_adset_ads);
      // console.log('a prview_creatives_list');
      // console.log(this.prview_creatives_list);
    },
    'pageIdData' : function(v){
      //  console.log('pageIdData:'+v);

      if(this.stageContenttData.postData.page_id != v){
        this.stageContenttData.postData.select_article = [];
        this.stageContenttData.postData.select_creatives = [];
        this.stageContenttData.postData.page_id = v
      }

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_leadgen_forms.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: v
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.immediateList = response.data.return_data
          }
        });

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: v,
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.messageList = response.data.return_data
          }
        });
    },
    'campaignIdData': function(v){
      console.log('campaignIdData:'+v);
    },
    'goalsObjectiveData': function(v){
      console.log('fb goalsObjectiveData:'+v);

      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_now = null;

      if(v == 'LEAD_GENERATION'){
        this.callActiveList = [
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['apply_now'],
            code: 'APPLY_NOW'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['book_travel'],
            code: 'BOOK_TRAVEL'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['download'],
            code: 'DOWNLOAD'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_offer'],
            code: 'GET_OFFER'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['get_quote'],
            code: 'GET_QUOTE'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['learn_more'],
            code: 'LEARN_MORE'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['sign_up'],
            code: 'SIGN_UP'
          },
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['lead_generation']['subscribe'],
            code: 'SUBSCRIBE'
          }
        ]
      }

      if(v == 'MESSAGES'){
        this.callActiveList = [
          {
            name: this.lang['components']['Event']['AdvertisingMaterial']['call_active_list']['messages']['message_page'],
            code: 'MESSAGE_PAGE'
          }
        ]
      }
    },
    'stageContenttData.postData.page_id': function(v){
      // console.log('material stageContenttData.postData.page_id:'+v);
    },
    'stageContenttData.postData.db_select_article': function(v){
      console.log('material stageContenttData.postData.db_select_article:'+v);
      console.log(this.stageContenttData.postData);

      if(v != '' && v != '[]'){
        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_fb_posts_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageIdData,
            special_ad_category: this.stageContenttData.postData.special_ad_category,
            tags: this.stageContenttData.postData.material_post_tags,
            tags_delete: this.stageContenttData.postData.material_post_delete_tags,
            form_da_posts: v
          }))
          .then((response) => {
            console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.items = response.data.return_data
              this.itemsDelete = response.data.return_data_delete
              this.prview_post_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              // console.log('campaign_form_fb_posts_form_db this.prview_post_list');
              // console.log(this.prview_post_list);
            }
          });
      }
    },
    'stageContenttData.postData.db_select_creatives': function(v){
      console.log('material stageContenttData.postData.db_select_creatives:'+v);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_fb_creatives_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageIdData,
            special_ad_category: this.stageContenttData.postData.special_ad_category,
            tags: this.stageContenttData.postData.material_creative_tags,
            tags_delete: this.stageContenttData.postData.material_creative_delete,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.creativesItems = response.data.return_data
              this.creativesItemsDelete = response.data.return_data_delete
              this.prview_creatives_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              for (let i = 0; i < this.creativesItems.length; i++) {
                if (this.creativesItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                    console.log('db_select_creatives');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
    'stageContenttData.postData.db_select_creatives_message': function(v){
      console.log('material stageContenttData.postData.db_select_creatives_message:'+v);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_fb_creatives_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageIdData,
            special_ad_category: this.stageContenttData.postData.special_ad_category,
            tags: this.stageContenttData.postData.material_creative_tags,
            tags_delete: this.stageContenttData.postData.material_creative_delete,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.creativesMessageItems = response.data.return_data
              this.creativesMessageItemsDelete = response.data.return_data_delete
              this.prview_creatives_message_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              for (let i = 0; i < this.creativesMessageItems.length; i++) {
                if (this.creativesMessageItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                    console.log('db_select_creatives_message');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
    'stageContenttData.postData.db_select_creatives_adset_ads_message': function(v){
      console.log('material stageContenttData.postData.db_select_creatives_adset_ads_message :'+v);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_adset_ads_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            tags: this.stageContenttData.postData.material_creative_tags,
            tags_delete: this.stageContenttData.postData.material_creative_delete_adset_ads,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              // console.log('form db selected_click');
              // console.log(response.data.return_data);
              // console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.creativesAdsetAdsMessageItems = response.data.return_data
              this.creativesAdsetAdsMessageItemsDelete = response.data.return_data_delete
              this.prview_adset_ads_message_list = response.data.return_prview
              // this.$emit('update:itemsDatalist', response.data.return_data)
              // this.$emit('update:prviewDatalist', response.data.return_prview)

              for (let i = 0; i < this.creativesAdsetAdsMessageItems.length; i++) {
                if (this.creativesAdsetAdsMessageItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                    console.log('db_select_creatives_adset_ads_message ');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
    'stageContenttData.postData.db_select_creatives_adset_ads': function(v){
      console.log('material stageContenttData.postData.db_select_creatives_adset_ads:'+v);
      console.log(this.stageContenttData.postData);

      if(v != '' && v != '[]' && typeof v != 'undefined'){
        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_adset_ads_form_db.php', Qs.stringify({
            s_code: this.$route.params.id,
            tags: this.stageContenttData.postData.material_creative_tags,
            tags_delete: this.stageContenttData.postData.material_creative_delete_adset_ads,
            form_da_posts: v
          }))
          .then((response) => {
            // console.log(response);
            if(response.data.status == 'success'){
              console.log('form db selected_click');
              console.log(response.data.return_data);
              console.log(response.data.return_prview);
              // this.items = response.data.return_data
              this.adsetAdsItems = response.data.return_data
              this.adsetAdsItemsDelete = response.data.return_data_delete
              this.prview_adset_ads_list = response.data.return_prview

              for (let i = 0; i < this.creativesItems.length; i++) {
                if (this.creativesItems[i].status == 'N') {
                  if(this.campaign_objective != 'LEAD_GENERATION' && this.campaign_objective != 'MESSAGES'){
                    console.log('db_select_creatives');
                    this.$emit('childIsChangeData', true);
                  }
                }
              }

              // console.log('campaign_form_fb_creatives_form_db this.prview_creatives_list');
              // console.log(this.prview_creatives_list);
            }
          });
      }
    },
    'stageContenttData.adMaterialData' (value){
      console.log('advertising stageContenttData.adMaterialData');
      // console.log(this.stageContenttData.adMaterialData);
      console.log(value);

      // console.log(this.viewAdMaterialDatalistData.creative_array);
      if(value.creative_array != "" && value.creative_array != null && typeof value.creative_array != 'undefined'){
        console.log('is creative_array');
        this.viewAdMaterialDatalistData.creative_array = value.creative_array;
      } else {
        console.log('not creative_array');
        if(value.creative_array == "" || value.creative_array == null || typeof value.creative_array == 'undefined'){
          this.viewAdMaterialDatalistData.creative_array = [
            {
              title: this.lang['components']['Event']['AdvertisingMaterial']['item_title'],
              isEdit: false,
              type: 1,
              tagType: 0,
              materials: [
                {
                  id: null,
                  imgSrc: null,
                  object_spec: {
                    name: null,
                    width: null,
                    height: null
                  },
                  title: null,
                  description: null,
                  website: null,
                  isEdit: false,
                  index: 0
                },
                {
                  id: null,
                  imgSrc: null,
                  object_spec: {
                    name: null,
                    width: null,
                    height: null
                  },
                  title: null,
                  description: null,
                  website: null,
                  isEdit: false,
                  index: 1
                }
              ],
              materialSingle: [
                {
                  id: null,
                  imgSrc: null,
                  object_spec: {
                    name: null,
                    width: null,
                    height: null
                  },
                  fileName: null,
                  title: null,
                  description: null,
                  website: null,
                  size: null,
                  index: 0
                }
              ],
              callActive: 'SIGN_UP',
              form_sr_i: null,
              message_sr_i: null
            }
          ];
        } else {
          this.viewAdMaterialDatalistData.creative_array = value;
        }
      }

      console.log('viewDatalist this.viewAdMaterialDatalistData.creative_array');
      console.log(this.viewAdMaterialDatalistData.creative_array);
    },
    viewAdMaterialDatalist(value){
      console.log('stagematerial viewAdMaterialDatalist');
      console.log(value);
    },
    'viewAdMaterialDatalistData.creative_array'(value){
      console.log('viewAdMaterialDatalistData.creative_array');
      console.log(value);
    },
    changeFormId (value){
      console.log('已改變changeFormId');
      console.log(value);

      let get_value = value.split('_');
      // console.log('item index:');
      // console.log(this.nowItemIndex);
      // console.log('b item:');
      // console.log(this.viewAdMaterialDatalistData.creative_array);
      this.viewAdMaterialDatalistData.creative_array[this.nowItemIndex].form_sr_i = parseInt(get_value[0])
      console.log('a item:');
      console.log(this.viewAdMaterialDatalistData.creative_array);

      // this.$emit('baseChangeFormId');
      // console.log('baseChangeFormId');
    },
    changeMessageId (value){
      console.log('已改變changeMessageId');
      console.log(value);

      let get_value = value.split('_');
      // console.log('item index:');
      // console.log(this.nowItemIndex);
      // console.log('b item:');
      // console.log(this.viewAdMaterialDatalistData.creative_array);
      this.viewAdMaterialDatalistData.creative_array[this.nowItemIndex].message_sr_i = parseInt(get_value[0])
      console.log('a item:');
      console.log(this.viewAdMaterialDatalistData.creative_array);
    },
    formTeachingOver(value){
      console.log('b formTeachingOverData');
      console.log(value);
      console.log(this.formTeachingOverData);

      if(value != '' && value != null && typeof value != 'undefined'){
        let get_value = value.split('_');

        console.log(get_value);

        this.formTeachingOverData = parseInt(get_value[0])
      }

      console.log('a formTeachingOverData');
      console.log(this.formTeachingOverData);
    },
    formId(v){
      console.log('formId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);


      if(v != '' && v != null && typeof v != 'undefined'){
        let get_value = v.split('_');

        console.log(get_value);

        this.selectedItem = parseInt(get_value[0])
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    firstFormId(v){
      console.log('firstFormId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);

      if(v != '' && v != null && typeof v != 'undefined'){
        this.selectedItem = v
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    // <!-- 新手教學 -->
    formStatus(v){
      console.log('formStatus');
      console.log(v);
      this.editType = 2
      if(v == 'Y'){
        this.editType = 1
      }
    },
    showFormModal(val) {
      console.log('form showModal');
      console.log(val);

      if (!val) {
        console.log('##1');
        this.formGuideStep = -1;
        this.$router.push({ query: { step: this.formGuideStep, formguide: false }});
      } else {
        this.form3Options = [
                              { name: this.lang['views']['Form']['Dialog']['form3Options']['code_01'], code: '01', type: 'CUSTOM' },
                              { name: this.lang['views']['Form']['Dialog']['form3Options']['code_02'], code: '02', type: 'CUSTOM' },
                              { name: this.lang['views']['Form']['Dialog']['form3Options']['code_03'], code: '03', type: 'DATE_TIME' }
                            ];
        console.log('##2');
        if (this.$route.query.formguide) {
          this.formGuide = this.$route.query.formguide === 'false' ? false : true;
          this.formGuideStep = this.$route.query.formguide === 'false' ? -1 : 701;
          this.$router.push({ query: { step: this.formGuideStep, formguide: false }});
        }
      }
    },
    formGuideStep(val) {
      if (val === 805) {
        this.menuActive = 2;
        this.formData.form2.isOpen = true;
        this.$refs.introContent.scrollTo({
          top: 50,
          behavior: 'smooth'
        });
      } else if (val === 808) {
        this.menuActive = 3;
        this.$refs.introContent.scrollTo({
          top: 80,
          behavior: 'smooth'
        });
      } else if (val === 810) {
        this.formData.form3.single.push({
          id: this.getMaxId(this.formData.form3.single),
          type: this.formData.form3.type,
          text: "",
          answer: [{ text: this.lang['views']['Form']['Dialog']['watch']['formGuideStep']['form3_single_answer'] }],
          answerText: "",
          isOpen: true
        });
      } else if (val === 816) {
        this.menuActive = 4;
        this.$refs.introContent.scrollTo({
          top: 100,
          behavior: 'smooth'
        });
      } else if (val === 819) {
        this.menuActive = 5;
        this.$refs.introContent.scrollTo({
          top: 120,
          behavior: 'smooth'
        });
      } else if (val === 820) {
        this.menuActive = 6;
        this.$refs.introContent.scrollTo({
          top: 130,
          behavior: 'smooth'
        });
      } else if (val === 821) {
        this.menuActive = 7;
        this.$refs.introContent.scrollTo({
          top: 140,
          behavior: 'smooth'
        });
      } else if (val === 822) {
        this.menuActive = 8;
        this.$refs.introContent.scrollTo({
          top: 150,
          behavior: 'smooth'
        });
      }
    },
    // <!-- 新手教學 -->
    msgTeachingOver(value){
      console.log('b msgTeachingOverData');
      console.log(value);
      console.log(this.msgTeachingOverData);

      if(value != '' && value != null && typeof value != 'undefined'){
        let get_value = value.split('_');

        console.log(get_value);

        this.msgTeachingOverData = parseInt(get_value[0])

        console.log('b this.msgGuide');
        console.log(this.msgGuide);
        if(this.msgTeachingOverData == 0){
          this.msgGuide = true
        }
        console.log('a this.msgGuide');
        console.log(this.msgGuide);
      }

      console.log('a msgTeachingOverData');
      console.log(this.msgTeachingOverData);
    },
    showMsgModal(val) {
      if (!val) {
        console.log('!val');
        this.msgGuideStep = -1;
        this.$router.push({ query: { step: this.msgGuideStep, msgguide: false }});

        this.showFormList = true;

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
            s_code: this.$route.params.id,
            page_id: this.pageId,
          }))
          .then((response) => {
            if(response.data.status == 'success'){

              this.messageList = response.data.return_data
              this.showFormList = false;
            }
          });
      } else {
        console.log('val');
        if (this.$route.query.msgguide) {
          this.msgGuide = this.$route.query.msgguide === 'false' ? false : true;
          this.msgGuideStep = this.$route.query.msgguide === 'false' ? -1 : 701;
          this.$router.push({ query: { step: this.msgGuideStep, msgguide: false }});
        }
      }
    },
    msgGuideStep(val) {
      if (val === 707) {
        let text_707_1 = this.lang['views']['Msg']['watch']['msgGuideStep']['707_setMsgBoxItemFast_1'];
        let text_707_2 = this.lang['views']['Msg']['watch']['msgGuideStep']['707_setMsgBoxItemFast_2'];

        this.setMsgBoxItemFast(text_707_1, text_707_2);
      }

      if (val === 708) {
        let itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
        let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
        let content_708 = this.lang['views']['Msg']['watch']['msgGuideStep']['708_content'];

        itemList[index].info[0].content = content_708;
      }

      if (val === 716) {
        this.showContentTypeWindows = true;
      }

      if (val === 717) {
        this.openContentInfoBtn(2);
      }

      if (val === 718) {
        let content_718 = this.lang['views']['Msg']['watch']['msgGuideStep']['718_contentInfoBtn_text'];

        this.contentInfoBtn.text = content_718;
      }

      if (val === 720) {
        this.setMsgBoxItemBtn();
      }

      if (val === 722) {
        this.showContentTypeWindows = true;
      }

      if (val === 723) {
        this.setFakeImage();
        this.showContentTypeWindows = false;
      }

      if (val === 724) {
        this.showContentTypeWindows = true;
      }

      if (val === 725) {
        this.showContentTypeWindows = false;
      }

      if(val === 726){
        let itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
        let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
        itemList[index].info[0].imgVideo = [];
      }

      if (val === 730) {
        this.contentInfoBtn.active = 2;
        this.openContentInfoBtn(2);
      }

      if (val === 731) {
        let content_731 = this.lang['views']['Msg']['watch']['msgGuideStep']['731_contentInfoBtn_text'];

        this.contentInfoBtn.active = 2;
        this.contentInfoBtn.text = content_731;
        this.contentInfoBtn.url = 'https://www.autoturn.net/index.php/index/view';
        console.log(this.contentInfoBtn);
      }

      if (val === 732) {
         this.setMsgBoxItemBtn();
      }

      if (val === 733) {
        this.contentInfoBtn.active = 3;
        this.openContentInfoBtn(2);
      }

      if (val === 734) {
        let content_734 = this.lang['views']['Msg']['watch']['msgGuideStep']['734_contentInfoBtn_text'];

        this.contentInfoBtn.active = 3;
        this.contentInfoBtn.text = content_734;
        this.contentInfoBtn.url = '';
        this.contentInfoBtn.phone = '0912345678';
        console.log(this.contentInfoBtn);
      }

      if (val === 735) {
        this.setMsgBoxItemBtn();
      }
    },
    // <!-- 新手教學 -->
    pageId(v){
      console.log('form pageId');
      console.log(v);
      this.showFormList = true;

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: v,
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            // console.log('b this.messageList');
            // console.log(this.messageList);

            this.messageList = response.data.return_data

            this.showFormList = false;

            // console.log('a this.messageList');
            // console.log(this.messageList);
          }
        });
    },
    messageId(v){
      console.log('messageId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);


      if(v != '' && v != null && typeof v != 'undefined'){
        let get_value = v.split('_');

        console.log(get_value);

        this.selectedItem = parseInt(get_value[0])
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    firstMessageId(v){
      console.log('firstMessageId:'+v);

      // console.log('a selectedItem:'+this.selectedItem);

      if(v != '' && v != null && typeof v != 'undefined'){
        this.selectedItem = v
      } else {
        this.selectedItem = []
      }

      // console.log('b selectedItem:'+this.selectedItem);
    },
    messageStatus(v){
      this.editType = 2

      if(v == 'Y'){
        this.editType = 1
      }
    },
    'stageContenttData.postData.creative_optimize'(value){
      this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData.creative_optimize = value;

      console.log('this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData');
      console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData);
    },
    'stageContenttData.postData.ditto_creative'(value){
      console.log('stageContenttData.postData.ditto_creative');
      console.log(value);
      console.log(typeof value);
      console.log('b this.stageContentAllData');
      console.log(this.stageContentAllData);
      console.log(this.stageContenttData);
      console.log(this.stageIndex);

      if(this.stageIndex > 0){
        if(value == true){
          let _beforIndex = this.stageIndex - parseInt(1);

          // this.stageContentAllData.subCampaignsContent[this.stageIndex].postData = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData));
          // this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].adMaterialData));

          // this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative = value;
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.special_ad_category = this.stageContentAllData.subCampaignsContent[_beforIndex].postData.special_ad_category;
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.creative_optimize = this.stageContentAllData.subCampaignsContent[_beforIndex].postData.creative_optimize;
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_article = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.select_article));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_article = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.db_select_article));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.select_creatives));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.db_select_creatives));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.select_creatives_message));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.db_select_creatives_message));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_adset_ads = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.select_creatives_adset_ads));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_adset_ads = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.db_select_creatives_adset_ads));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_adset_ads_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.select_creatives_adset_ads_message));
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_adset_ads_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].postData.db_select_creatives_adset_ads_message));

          this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData.creative_optimize = this.stageContentAllData.subCampaignsContent[_beforIndex].adMaterialData.creative_optimize;
          this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData.creative_array = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforIndex].adMaterialData.creative_array));

          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative = value;

          console.log('for this.stageContentAllData.subCampaignsContent[this.stageIndex]');
          console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex]);
        }
      }

      let subLength =  this.stageContentAllData.subCampaignsContent.length;
      console.log('this.stageIndex');
      console.log(this.stageIndex);
      for(let i = this.stageIndex; i < subLength; i++){
        let nextIndex = i + parseInt(1);
        console.log(i+' : '+nextIndex+'，this.stageContentAllData.subCampaignsContent[nextIndex]');

        if(this.stageContentAllData.subCampaignsContent[i].method != 'TIKTOK_KW' && this.stageContentAllData.subCampaignsContent[i].method != 'TIKTOK_RT'){
          if(this.stageContentAllData.subCampaignsContent[nextIndex] != null && this.stageContentAllData.subCampaignsContent[nextIndex] != null && typeof this.stageContentAllData.subCampaignsContent[nextIndex] != 'undefined'){
            console.log(this.stageContentAllData.subCampaignsContent[nextIndex]);
            if(this.stageContentAllData.subCampaignsContent[nextIndex].postData.ditto_creative == true){
              console.log(this.stageContentAllData.subCampaignsContent[nextIndex].postData.ditto_creative);
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.special_ad_category = this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.special_ad_category;
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.creative_optimize = this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.creative_optimize;
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_article = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_article));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_article = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_article));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_message));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_message));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives_adset_ads = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_adset_ads));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives_adset_ads = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_adset_ads));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives_adset_ads_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_adset_ads_message));
              this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives_adset_ads_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_adset_ads_message));

              this.stageContentAllData.subCampaignsContent[nextIndex].adMaterialData.creative_optimize = this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData.creative_optimize;
              this.stageContentAllData.subCampaignsContent[nextIndex].adMaterialData.creative_array = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData.creative_array));
              console.log(this.stageContentAllData.subCampaignsContent[nextIndex].postData);
              console.log(this.stageContentAllData.subCampaignsContent[nextIndex].adMaterialData);
            } else {
              console.log('break');
              break;
            }
          }
        }
      }

      console.log('stageContenttData.postData.ditto_creative a this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    'stageContenttData.postData': {
      handler(newValue, oldValue) {
        console.log('postData changed:', newValue);
        console.log('postData olddata:', oldValue);

        if(this.isPostDataUpdating == true){
          return;
        }

        this.isPostDataUpdating = true;

        this.postDataUdate(newValue);

        setTimeout(() => {
          this.isPostDataUpdating = false;
        }, 0);
      },
      deep: true // 深度监控
    },
    'stageContenttData.adMaterialData': {
      handler(newValue, oldValue) {
        console.log('adMaterialData changed:', newValue);
        console.log('adMaterialData olddata:', oldValue);

        if(this.isAdMaterialDataUpdating == true){
          return;
        }

        this.isAdMaterialDataUpdating = true;

        this.adMaterialDataUdate(newValue);

        setTimeout(() => {
          this.isAdMaterialDataUpdating = false;
        }, 0);
      },
      deep: true // 深度监控
    },
    showUploadWindows(value){
      console.log('showUploadWindows');
      console.log(value);

      if(value == false && this.useUpload == true){
        console.log('有上傳圖片');
        this.materialUpdate();

        this.useUpload = false;
      }

      if(value == true){
        console.log('準備上傳圖片');
        this.selectedFiles = [];
        this.uploadResults = [];
        this.isUploading = false;
      }
    },
  },
  created() {
    console.log('this.pageId');
    console.log(this.pageId);

    if(this.pageId != '' && this.pageId != null && typeof this.pageId != 'undefined'){
      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_leadgen_forms.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.immediateList = response.data.return_data
          }
        });

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId,
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            // console.log('b this.messageList');
            // console.log(this.messageList);

            this.messageList = response.data.return_data

            // this.showFormList = false;
            // console.log('a this.messageList');
            // console.log(this.messageList);
          }
        });
    }
  },
  mounted() {
    if (this.$route.query.formguide) {
      this.formGuide = this.$route.query.formguide === 'false' ? false : true;
    }

    $(".element").bezier({ animate: false });
    if (this.$route.query.msgguide) {
      this.msgGuide = this.$route.query.msgguide === 'false' ? false : true;
    }
  },
  methods: {
    onReady() {
      console.log('youtube');
      this.$refs.youtube.playVideo()
      // this.$refs.youtube.pauseVideo()
    },
    onStateChange(e){
      console.log(e);

      if(e.data == 0){
        this.view_youtube = false
      }
    },
    teachVideo(){
      this.$emit('checkClose')
      // let elem = document.getElementById('marketingMethod');
      // let positio = this.getPosition(elem);
      // console.log('x:'+positio.x);
      // console.log('y:'+positio.y);

      // this.x = positio.x + parseInt(80);
      // this.y = positio.y

      var windowWidth = window.innerWidth;
      var windowHeight = window.innerHeight;

      // console.log('windowWidth');
      // console.log(windowWidth);
      // console.log('windowHeight');
      // console.log(windowHeight);

      this.x = windowWidth - parseInt(390);
      this.y = windowHeight - parseInt(350);

      this.view_youtube = true;
      this.$emit('childYoutube', 'true_material')

      this.vars.start = 24
      this.vars.end = 171
    },
    getPosition(element) {
      let x = 0;
      let y = 0;

      while ( element ) {
        x += element.offsetLeft - element.scrollLeft + element.clientLeft;
        y += element.offsetTop - element.scrollLeft + element.clientTop;
        element = element.offsetParent;
      }

      return { x: x, y: y };
    },
    print(val) {
      console.log(val)
    },
    doDragging(){
      console.log('doDragging');
    },
    posts_data () {
      // console.log('pageId:'+this.pageId);
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        // this.MaterialShowMaterialMyside = false;
        this.showPostModal = true

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_fb_posts.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageId,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              // console.log('posts_data');
              // console.log(response.data.return_data);
              this.postsData = response.data.return_data

              // this.$emit('nextStep');
            }

            this.showList = true;
            // this.MaterialShowMaterialMyside = true;
          });
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['posts_data']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['posts_data']['no_pageId_swal_text'],
                  'error'
                )
      }
    },
    creatives_data(){
      // console.log('creatives_data');
      // console.log('pageId:'+this.pageId);
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.showCreativeModal = true
        this.MaterialShowMaterialMyside = false;
        this.showCreativeDialogMyside = false;

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_fb_creatives.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageId,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              // console.log('posts_data');
              // console.log(response.data.return_data);
              this.creativesData = response.data.return_data
            }

            this.MaterialShowMaterialMyside = true;
            this.showCreativeDialogMyside = true;
          });
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['creatives_data']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['creatives_data']['no_pageId_swal_text'],
                  'error'
                )
      }
    },
    adset_ads_data(){
      // console.log('creatives_data');
      // console.log('pageId:'+this.pageId);
      let adaccount_id = this.$route.params.adaccount_id;

      if(adaccount_id != 0 && adaccount_id != "" && adaccount_id != null && typeof adaccount_id != 'undefined'){
        this.MaterialShowMaterialMyside = false;
        this.showAdsetAdsModal = true;

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_adaccount_campaigns.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: adaccount_id,
            objective: this.goalsObjectiveData,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              console.log('adset_ads_data');
              console.log(response.data.return_data.adaccount_campaigns_list);
              this.adaccountCampaignsData = response.data.return_data.adaccount_campaigns_list
            }

            this.MaterialShowMaterialMyside = true;
          });
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['adset_ads_data']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['adset_ads_data']['no_pageId_swal_text'],
                  'error'
                )
      }
    },
    remove_list (index){
      for (let i = 0; i < this.stageContenttData.postData.select_article.length; i++) {
        if (i == index) {
          let _tmpArticleId = this.stageContenttData.postData.page_id+'_'+this.stageContenttData.postData.select_article[index].content;

          console.log('_tmpArticleId');
          console.log(_tmpArticleId);

          console.log('b this.stageContenttData.postData.select_article');
          console.log(this.stageContenttData.postData.select_article);

          this.stageContenttData.postData.select_article.splice(i, 1);

          console.log('a this.stageContenttData.postData.select_article');
          console.log(this.stageContenttData.postData.select_article);

          console.log('b this.stageContenttData.postData.db_select_article');
          console.log(this.stageContenttData.postData.db_select_article);

          let dbIndex = this.stageContenttData.postData.db_select_article.indexOf(_tmpArticleId);

          console.log('dbIndex');
          console.log(dbIndex);

          let _dbDataDbSelectArticle = this.stageContenttData.postData.db_select_article;
          if(dbIndex != -1){
            console.log('刪除'+dbIndex+'個元素');
            _dbDataDbSelectArticle.splice(dbIndex, 1);
          }

          this.stageContenttData.postData.db_select_article = _dbDataDbSelectArticle;

          console.log('a this.stageContenttData.postData.db_select_article');
          console.log(this.stageContenttData.postData.db_select_article);

          console.log('remove_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_list (index){
      for (let i = 0; i < this.stageContenttData.postData.delete_article.length; i++) {
        if (i == index) {
          this.stageContenttData.postData.delete_article.splice(i, 1);

          console.log('remove_delete_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_item(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_article.length; i++) {
        if (i == index) {
          // this.stageContenttData.postData.select_article.splice(i, 1);
          this.stageContenttData.postData.delete_article[i].tagType = 1;

          console.log('back_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_creatives_list(index){
      for (let i = 0; i < this.stageContenttData.postData.select_creatives.length; i++) {
        if (i == index) {
          let _tmpCreativeId = this.stageContenttData.postData.select_creatives[index].item_id;

          console.log('_tmpCreativeId');
          console.log(_tmpCreativeId);

          console.log('b this.stageContenttData.postData.select_creatives');
          console.log(this.stageContenttData.postData.select_creatives);

          this.stageContenttData.postData.select_creatives.splice(i, 1);

          console.log('a this.stageContenttData.postData.select_creatives');
          console.log(this.stageContenttData.postData.select_creatives);

          console.log('b this.stageContenttData.postData.db_select_creatives');
          console.log(this.stageContenttData.postData.db_select_creatives);

          let dbIndex = this.stageContenttData.postData.db_select_creatives.indexOf(_tmpCreativeId);

          console.log('dbIndex');
          console.log(dbIndex);

          if(dbIndex != -1){
            this.stageContenttData.postData.db_select_creatives.splice(dbIndex, 1);
          }

          console.log('a this.stageContenttData.postData.db_select_creatives');
          console.log(this.stageContenttData.postData.db_select_creatives);

          console.log('remove_creatives_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    edit_creatives_list(index){
      console.log('edit_creatives_list');
      console.log(index);
      console.log(this.stageContenttData.postData.select_creatives);
      console.log(this.stageContenttData.postData.select_creatives[index]);

      this.editCreativeId = this.stageContenttData.postData.select_creatives[index].item_id;
      this.showEditModal = true;
    },
    remove_delete_creatives_list(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_creatives.length; i++) {
        if (i == index) {
          this.stageContenttData.postData.delete_creatives.splice(i, 1);

          console.log('remove_delete_creatives_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_creatives_item(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_creatives.length; i++) {
        if (i == index) {
          // this.stageContenttData.postData.select_article.splice(i, 1);
          this.stageContenttData.postData.delete_creatives[i].tagType = 1;

          console.log('back_creatives_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_creatives_message_list(index){
      for (let i = 0; i < this.stageContenttData.postData.select_creatives_message.length; i++) {
        if (i == index) {
          let _tmpCreativeId = this.stageContenttData.postData.select_creatives_message[index].item_id;

          if(!_tmpCreativeId || typeof _tmpCreativeId === 'undefined'){
            _tmpCreativeId = this.stageContenttData.postData.select_creatives_message[index];
          }

          this.stageContenttData.postData.select_creatives_message.splice(i, 1);

          let dbIndex = this.stageContenttData.postData.db_select_creatives_message.indexOf(_tmpCreativeId);

          if(dbIndex != -1){
            this.stageContenttData.postData.db_select_creatives_message.splice(dbIndex, 1);
          }

          console.log('remove_creatives_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_creatives_message_list(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_creatives_message.length; i++) {
        if (i == index) {
          this.stageContenttData.postData.delete_creatives_message.splice(i, 1);

          console.log('remove_delete_creatives_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_creatives_message_item(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_creatives_message.length; i++) {
        if (i == index) {
          // this.stageContenttData.postData.select_article.splice(i, 1);
          this.stageContenttData.postData.delete_creatives_message[i].tagType = 1;

          console.log('back_creatives_message_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_adset_ads_message_list(index){
      for (let i = 0; i < this.stageContenttData.postData.select_creatives_adset_ads_message.length; i++) {
        if (i == index) {
          let _tmpCreativeId = this.stageContenttData.postData.select_creatives_adset_ads_message[index].item_id;

          if(!_tmpCreativeId || typeof _tmpCreativeId === 'undefined'){
            _tmpCreativeId = this.stageContenttData.postData.select_creatives_adset_ads_message[index];
          }

          this.stageContenttData.postData.select_creatives_adset_ads_message.splice(i, 1);

          let dbIndex = this.stageContenttData.postData.db_select_creatives_adset_ads_message.indexOf(_tmpCreativeId);

          if(dbIndex != -1){
            this.stageContenttData.postData.db_select_creatives_adset_ads_message.splice(dbIndex, 1);
          }

          console.log('remove_adset_ads_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_adset_ads_message_list(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_adset_ads_message.length; i++) {
        if (i == index) {
          this.stageContenttData.postData.delete_adset_ads_message.splice(i, 1);

          console.log('remove_delete_adset_ads_message_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_adset_ads_message_item(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_adset_ads_message.length; i++) {
        if (i == index) {
          // this.stageContenttData.postData.select_article.splice(i, 1);
          this.stageContenttData.postData.delete_adset_ads_message[i].tagType = 1;

          console.log('back_creatives_message_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_adset_ads_list(index){
      for (let i = 0; i < this.stageContenttData.postData.select_creatives_adset_ads.length; i++) {
        if (i == index) {
          let _tmpCreativeId = this.stageContenttData.postData.select_creatives_adset_ads[index].item_id;

          if(!_tmpCreativeId || typeof _tmpCreativeId === 'undefined'){
            _tmpCreativeId = this.stageContenttData.postData.select_creatives_adset_ads[index];
          }

          this.stageContenttData.postData.select_creatives_adset_ads.splice(i, 1);

          let dbIndex = this.stageContenttData.postData.db_select_creatives_adset_ads.indexOf(_tmpCreativeId);

          if(dbIndex != -1){
            this.stageContenttData.postData.db_select_creatives_adset_ads.splice(dbIndex, 1);
          }

          console.log('remove_adset_ads_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    remove_delete_adset_ads_list(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_creatives_adset_ads.length; i++) {
        if (i == index) {
          this.stageContenttData.postData.delete_creatives_adset_ads.splice(i, 1);

          console.log('remove_delete_adset_ads_list 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    back_adset_ads_item(index){
      for (let i = 0; i < this.stageContenttData.postData.delete_creatives_adset_ads.length; i++) {
        if (i == index) {
          // this.stageContenttData.postData.select_article.splice(i, 1);
          this.stageContenttData.postData.delete_creatives_adset_ads[i].tagType = 1;

          console.log('back_adset_ads_item 有刪東西');
          this.$emit('childIsChangeData', true);
        }
      }
    },
    prview_focus (index){
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_focus');
      // console.log(index);
      // console.log(this.prview_post_list);
      this.prview_now = this.prview_post_list[index]
    },
    prview_creatives_focus (index){
      this.prview_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_creatives_focus');
      // console.log(index);
      // console.log(this.prview_creatives_list);
      this.prview_creatives_now = this.prview_creatives_list[index]
    },
    prview_creatives_message_focus (index){
      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_adset_ads_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_creatives_focus');
      // console.log(index);
      // console.log(this.prview_creatives_list);
      this.prview_creatives_message_now = this.prview_creatives_message_list[index]
    },
    prview_adset_ads_message_focus (index){
      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_now = null;
      // console.log('prview_creatives_focus');
      // console.log(index);
      // console.log(this.prview_creatives_list);
      this.prview_adset_ads_message_now = this.prview_adset_ads_message_list[index]
    },
    prview_adset_ads_focus (index){
      this.prview_now = null;
      this.prview_creatives_now = null;
      this.prview_creatives_message_now = null;
      this.prview_adset_ads_message_now = null;
      // console.log('prview_adset_ads_focus');
      // console.log(index);
      // console.log(this.prview_adset_ads_list);
      this.prview_adset_ads_now = this.prview_adset_ads_list[index]
    },
    materialGetData(){
      console.log('從組件知道有修改 materialGetData');
      this.$emit('childIsChangeData', true);
    },
    emptyStep(value){
      console.log('組件裡的 emptyStep');
      console.log(value);
      this.$emit('emptyStep', value);
    },
    materialCreativesGetData(){
      console.log('從組件知道有修改 materialCreativesGetData');
      this.$emit('childIsChangeData', true);
    },
    materialAdsetAdsGetData(){
      console.log('從組件知道有修改 materialAdsetAdsGetData');
      this.$emit('childIsChangeData', true);
    },
    add_test(){
      // console.log('add_test');
      // console.log(this.showAddModal);
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.showAddModal = true
      } else {
        Swal.fire(
                  this.lang['components']['Event']['Material']['methods']['add_test']['no_pageId_swal_title'],
                  this.lang['components']['Event']['Material']['methods']['add_test']['no_pageId_swal_text'],
                  'error'
                )
      }
      // console.log(this.showAddModal);
    },
    scroll_messages(){
      console.log('scroll_messages');

      var todayForm = new Date();
      var yearForm = todayForm.getFullYear();
      var dateForm = String(todayForm.getDate()).padStart(2, '0');
      var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      todayForm = yearForm + monthForm + dateForm + timeForm;

      console.log('1_'+todayForm);

      this.$emit('childActiveScroll', '1_'+todayForm);
    },
    unlock(){
      this.isEdit = false
    },
    lock(){
      this.isEdit = true
    },
    changeType(index, value){
      // if(this.editPageType == false){
        this.viewAdMaterialDatalistData.creative_array[index].type = value
        this.focusType = index

        this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);

        // console.log('changeType');
        // console.log('viewAdMaterialDatalistData.creative_array['+index+'].type');
        // console.log(this.viewAdMaterialDatalistData.creative_array[index].type);
        // console.log('focusType');
        // console.log(this.focusType);
      // }
    },
    changeSelectedForm(index, value){
      // if(this.editPageType == false){
        if(value == 'image'){
          this.image.active = index
          this.selectedForm = 'image'
        } else {
          this.video.active = index
          this.selectedForm = 'video'
        }

        this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);
      // }
    },
    addItem() {
      // this.viewAdMaterialDatalistData.creative_array.push({ title: "xxxxxx" });
      // if(this.editPageType == false){
        // this.viewAdMaterialDatalistData.creative_array.push(
        //   {
        //     title: this.lang['components']['Event']['AdvertisingMaterial']['item_title'],
        //     isEdit: false,
        //     type: 1,
        //     tagType: 0,
        //     materials: [
        //       {
        //         id: null,
        //         imgSrc: null,
        //         object_spec: {
        //           name: null,
        //           width: null,
        //           height: null
        //         },
        //         title: null,
        //         description: null,
        //         website: null,
        //         isEdit: false,
        //         index: 0
        //       },
        //       {
        //         id: null,
        //         imgSrc: null,
        //         object_spec: {
        //           name: null,
        //           width: null,
        //           height: null
        //         },
        //         title: null,
        //         description: null,
        //         website: null,
        //         isEdit: false,
        //         index: 1
        //       }
        //     ],
        //     materialSingle: [
        //       {
        //         id: null,
        //         imgSrc: null,
        //         object_spec: {
        //           name: null,
        //           width: null,
        //           height: null
        //         },
        //         fileName: null,
        //         title: null,
        //         description: null,
        //         website: null,
        //         size: null,
        //         index: 0
        //       }
        //     ],
        //     callActive: 'SIGN_UP',
        //     form_sr_i: null,
        //     message_sr_i: null
        //   }
        // );

        // console.log('addItem this.viewAdMaterialDatalistData.creative_array');
        // console.log(this.viewAdMaterialDatalistData.creative_array);

        // this.$emit('childAdIsChangeData', true);
        // this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);
      this.viewAdMaterialDatalistData.creative_array.push(
          {
            title: this.lang['components']['Event']['AdvertisingMaterial']['item_title'],
            isEdit: false,
            type: 1,
            tagType: 0,
            materials: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 0
              },
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                title: null,
                description: null,
                website: null,
                isEdit: false,
                index: 1
              }
            ],
            materialSingle: [
              {
                id: null,
                imgSrc: null,
                object_spec: {
                  name: null,
                  width: null,
                  height: null
                },
                fileName: null,
                title: null,
                description: null,
                website: null,
                size: null,
                index: 0
              }
            ],
            callActive: 'SIGN_UP',
            form_sr_i: null,
            message_sr_i: null
          }
        );

        console.log('addItem this.viewAdMaterialDatalistData.creative_array');
        console.log(this.viewAdMaterialDatalistData.creative_array);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);
      // }
    },
    setMaterial(type) {
      let activeType = this.activeType
      let activeItem = this.activeItem

      // console.log('setMaterial type:'+type);
      // console.log('setMaterial activeType:'+activeType);
      // console.log('setMaterial activeItem:'+activeItem);

      // if(this.editPageType == false){
        if(activeType == 1){
          if(this.selectedForm == 'image'){
            if (
              this.image.active != null &&
              this.image.imageList.length > this.image.active
            ) {
              // this.viewAdMaterialDatalistData.creative_array.materialSingle == []

              // console.log('1 image this.image.active');
              // console.log(this.image.active);
              // console.log('this.image');
              // console.log(this.image);

              this.viewAdMaterialDatalistData.creative_array[type].materialSingle = [{
                id: this.image.imageListSpec[this.image.active].id,
                imgSrc: this.image.imageList[this.image.active],
                object_spec: this.image.imageListSpec[this.image.active],
                fileName: this.image.imageListSpec[this.image.active].name,
                title: this.viewAdMaterialDatalistData.creative_array[type].materialSingle[0].title,
                description: this.viewAdMaterialDatalistData.creative_array[type].materialSingle[0].description,
                website: this.viewAdMaterialDatalistData.creative_array[type].materialSingle[0].website,
                size: this.image.imageListSpec[this.image.active].width+' * '+this.image.imageListSpec[this.image.active].height,
                index: 0
              }];

              this.image.active = null;
              this.showVideoWindows = false;
            }
          } else {
            if (
              this.video.active != null &&
              this.video.videoList.length > this.video.active
            ) {
              // this.viewAdMaterialDatalistData.creative_array.materialSingle == []

              // console.log('1 video this.video.active');
              // console.log(this.video.active);
              // console.log('this.video');
              // console.log(this.video);

              this.viewAdMaterialDatalistData.creative_array[type].materialSingle = [{
                id: this.video.videoListSpec[this.video.active].id,
                imgSrc: this.video.videoList[this.video.active],
                object_spec: this.video.videoListSpec[this.video.active],
                fileName: this.video.videoListSpec[this.video.active].title,
                title: this.viewAdMaterialDatalistData.creative_array[type].materialSingle[0].title,
                description: this.viewAdMaterialDatalistData.creative_array[type].materialSingle[0].description,
                website: this.viewAdMaterialDatalistData.creative_array[type].materialSingle[0].website,
                size: this.video.videoListSpec[this.video.active].width+' * '+this.video.videoListSpec[this.video.active].height,
                index: 0
              }];

              this.video.active = null;
              this.showVideoWindows = false;
            }
          }
        }

        if(activeType == 2){
          let this_length = this.viewAdMaterialDatalistData.creative_array[type].materials.length;
          if(this.selectedForm == 'image'){
            if (
              this.image.active != null &&
              this.image.imageList.length > this.image.active
            ) {
              // this.viewAdMaterialDatalistData.creative_array.materials == []

              // console.log('2 image this.image.active');
              // console.log(this.image.active);
              // console.log(this.image.imageList[this.image.active]);
              // console.log(this.viewAdMaterialDatalistData.creative_array);
              // console.log(this.viewAdMaterialDatalistData.creative_array[activeType]);
              // console.log('this.image');
              // console.log(this.image);

              // this.viewAdMaterialDatalistData.creative_array[activeType].materials.push({
              //   imgSrc: this.image.imageList[this.image.active],
              //   title: "",
              //   size: "800*800"
              // });

              if(typeof this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].index != 'undefined'){
                this_length = this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].index;
              }

              this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem] = {
                id: this.image.imageListSpec[this.image.active].id,
                imgSrc: this.image.imageList[this.image.active],
                object_spec: this.image.imageListSpec[this.image.active],
                title: this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].title,
                description: this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].description,
                website: this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].website,
                size: "",
                isEdit: true,
                index: this_length
              };

              // console.log(this.viewAdMaterialDatalistData.creative_array[type]);

              this.image.active = null;
              this.showVideoWindows = false;
            }
          } else {
            if (
              this.video.active != null &&
              this.video.videoList.length > this.video.active
            ) {
              // this.viewAdMaterialDatalistData.creative_array.materials == []

              // console.log('2 video this.video.active');
              // console.log(this.video.active);
              // console.log('this.video');
              // console.log(this.video);

              // this.viewAdMaterialDatalistData.creative_array[activeType].materials.push({
              //   imgSrc: this.video.videoList[this.video.active],
              //   title: "",
              //   size: "800*800"
              // });

              if(typeof this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].index != 'undefined'){
                this_length = this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].index;
              }

              this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem] = {
                id: this.video.videoListSpec[this.video.active].id,
                imgSrc: this.video.videoList[this.video.active],
                object_spec: this.video.videoListSpec[this.video.active],
                title: this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].title,
                description: this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].description,
                website: this.viewAdMaterialDatalistData.creative_array[type].materials[activeItem].website,
                size: "",
                isEdit: true,
                index: this_length
              };

              this.video.active = null;
              this.showVideoWindows = false;
            }
          }
        }

        // console.log('this.viewAdMaterialDatalistData.creative_array');
        // console.log(this.viewAdMaterialDatalistData.creative_array);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);

        this.adPreview(this.currentTab);
      // }

      // console.log('this.viewAdMaterialDatalistData.creative_array');
      // console.log(this.viewAdMaterialDatalistData.creative_array);
    },
    getImageVideoList(type, index){
      // console.log('getImageVideoList type:'+type);
      // console.log('getImageVideoList index:');
      // console.log(index);

      // if(this.editPageType == false){

        // if(type == 1){
        //   this.showMaterialSingle = false;
        // } else {
        //   this.showMaterial = false;
        // }

        this.showVideoWindows = true;
        this.showVideoLoading = false;

        this.image.imageList = null;
        this.image.imageListSpec = null;
        this.image.imageListName = null;
        this.image.imageListTitle = null;
        this.video.videoList = null;
        this.video.videoListSpec = null;
        this.video.videoListName = null;
        this.video.videoListTitle = null;

        this.activeType = null;
        this.activeItem = null;

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_adimages.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.imageAfter = response.data.after_image

              this.image.imageList = response.data.return_image
              this.image.imageListSpec = response.data.return_image_spec
              this.image.imageListName = response.data.return_image_name
              this.image.imageListTitle = response.data.return_image_title

              // this.activeType = type
              // this.activeItem = index

              // this.showVideoLoading = true;

              axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  this.activeType = type
                  this.activeItem = index

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
            } else {
              axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  this.activeType = type
                  this.activeItem = index

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
            }
          });
      // }
    },
    moreVideo(){
      console.log('moreVideo');

      // let thisVideoList = ['video111.jpg','video222.jpg'];
      // let thisVideoListSpec = ['111','222'];
      // let thisVideoListName = ['video111','video222'];
      // let thisVideoListTitle = ['video111','video222'];

      this.showVideoLoading = false;

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          video_material_code: this.videoAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.video.videoList = response.data.return_video
            // this.video.videoListSpec = response.data.return_video_spec
            // this.video.videoListName = response.data.return_video_name
            // this.video.videoListTitle = response.data.return_video_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.videoAfter = response.data.after_video;

            this.video.videoList = response.data.return_video;
            this.video.videoListSpec = response.data.return_video_spec;
            this.video.videoListName = response.data.return_video_name;
            this.video.videoListTitle = response.data.return_video_title;

            this.showVideoLoading = true;
          // }
        });
    },
    moreImage(){
      console.log('moreImage');

      // let thisImageList = ['image111.jpg','image222.jpg'];
      // let thisImageListSpec = ['111','222'];
      // let thisImageListName = ['image111','image222'];
      // let thisImageListTitle = ['image111','image222'];

      this.showVideoLoading = false;

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_adimages.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          image_material_code: this.imageAfter,
        }))
        .then((response) => {
          // if(response.data.status == 'success'){
            // this.image.imageList = response.data.return_image
            // this.image.imageListSpec = response.data.return_image_spec
            // this.image.imageListName = response.data.return_image_name
            // this.image.imageListTitle = response.data.return_image_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;
            this.imageAfter = response.data.after_image;

            this.image.imageList = response.data.return_image;
            this.image.imageListSpec = response.data.return_image_spec;
            this.image.imageListName = response.data.return_image_name;
            this.image.imageListTitle = response.data.return_image_title;

            this.showVideoLoading = true;
          // }
        });
    },
    adContent(index){
      console.log('adContent');
      console.log(index);
      console.log('this.viewAdMaterialDatalistData.creative_array['+index+'].form_sr_i');
      console.log(this.viewAdMaterialDatalistData.creative_array[index].form_sr_i);
      console.log('this.viewAdMaterialDatalistData.creative_array['+index+'].message_sr_i');
      console.log(this.viewAdMaterialDatalistData.creative_array[index].message_sr_i);

      this.prview_single = null;

      // if(this.editPageType == false){
        this.currentTab = index
        this.ad_prview_now = this.viewAdMaterialDatalistData.creative_array[index].preview

        this.nowItemIndex = index;
        this.$emit('childFormId', this.viewAdMaterialDatalistData.creative_array[index].form_sr_i);
        this.$emit('childMessageId', this.viewAdMaterialDatalistData.creative_array[index].message_sr_i);
      // }
    },
    addMaterials(index){
      // console.log('addMaterials:'+index);
      let this_length = this.viewAdMaterialDatalistData.creative_array[index].materials.length;

      // if(this.editPageType == false){
        if(this_length < 10){
          this.viewAdMaterialDatalistData.creative_array[index].materials.push({
            id: null,
            imgSrc: null,
            object_spec: {
              name: null,
              width: null,
              height: null
            },
            title: null,
            description: null,
            website: null,
            isEdit: false,
            index: this_length
          });

          this.$emit('childAdIsChangeData', true);
          this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);

          this.adPreview(this.currentTab);
        } else {
          Swal.fire(
                    this.lang['components']['Event']['AdvertisingMaterial']['methods']['addMaterials']['not_length_swal_title'],
                    this.lang['components']['Event']['AdvertisingMaterial']['methods']['addMaterials']['not_length_swal_text'],
                    'warning'
                  );
        }
      // }

      // console.log(this.viewAdMaterialDatalistData.creative_array[index].materials);
    },
    removeAd(index){
      // console.log('removeAd index:'+index);

      // if(this.editPageType == false){
        this.viewAdMaterialDatalistData.creative_array.splice(index, 1);

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);
      // }
    },

    backAd(index){
      console.log('backAd index:'+index);
      console.log(this.viewAdMaterialDatalistData.creative_array);

      // if(this.editPageType == false){
        this.viewAdMaterialDatalistData.creative_array[index].tagType = 1;

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);
      // }
    },
    isChangeData(){
      // console.log('isChangeData');
      this.$emit('childAdIsChangeData', true);
      this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);

      this.adPreview(this.currentTab);
    },
    removeItem(type, index){
      // console.log('removeItem type:'+type);
      // console.log('removeItem index:'+index);

      // if(this.editPageType == false){
        // console.log('b this.viewAdMaterialDatalistData.creative_array:');
        // console.log(this.viewAdMaterialDatalistData.creative_array);
        // console.log('this.viewAdMaterialDatalistData.creative_array['+type+'].materials:');
        // console.log(this.viewAdMaterialDatalistData.creative_array[type].materials);
        this.viewAdMaterialDatalistData.creative_array[type].materials.splice(index, 1);

        for(var i = 0; i < this.viewAdMaterialDatalistData.creative_array[type].materials.length; i++){
          this.viewAdMaterialDatalistData.creative_array[type].materials[i].index = i;
        }

        this.$emit('childAdIsChangeData', true);
        this.$emit('childContent', this.viewAdMaterialDatalistData.creative_array);

        // console.log('a this.viewAdMaterialDatalistData.creative_array:');
        // console.log(this.viewAdMaterialDatalistData.creative_array);
      // }
    },
    adPreview(index){
      // console.log(this.items[index]);

      axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_ad_preview.php', Qs.stringify({
            s_code: this.$route.params.id,
            adaccount_id: this.$route.params.adaccount_id,
            page_id: this.pageId,
            items: this.items[index]
          }))
          .then((response) => {
            // console.log(response.data);
            if(response.data.status == 'success'){

              this.ad_prview_now = null;

              this.ad_prview_single = response.data.return_data
              // this.image.imageList = response.data.return_image
              // this.image.imageListSpec = response.data.return_image_spec
              // this.video.videoList = response.data.return_video
              // this.video.videoListSpec = response.data.return_video_spec

              // this.activeType = type
              // this.activeItem = index

              // if(type == 1){
              //   this.showMaterialSingle = true;
              // } else {
              //   this.showMaterial = true;
              // }

              // this.showVideoWindows = true
            }
          });
    },
    materialUpdate(){
      console.log('materialUpdate');
      this.showVideoLoading = false;

      this.image.imageList = null;
      this.image.imageListSpec = null;
      this.image.imageListName = null;
      this.image.imageListTitle = null;
      this.video.videoList = null;
      this.video.videoListSpec = null;
      this.video.videoListName = null;
      this.video.videoListTitle = null;

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_adimages.php', Qs.stringify({
          s_code: this.$route.params.id,
          adaccount_id: this.$route.params.adaccount_id,
          type: 'update'
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.imageAfter = response.data.after_image

            this.image.imageList = response.data.return_image
            this.image.imageListSpec = response.data.return_image_spec
            this.image.imageListName = response.data.return_image_name
            this.image.imageListTitle = response.data.return_image_title

            // if(type == 1){
            //   this.showMaterialSingle = true;
            // } else {
            //   this.showMaterial = true;
            // }

            // this.showVideoWindows = true

            // this.showVideoLoading = true;

            axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'update'
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
          } else {
            axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_advideos.php', Qs.stringify({
                s_code: this.$route.params.id,
                adaccount_id: this.$route.params.adaccount_id,
                type: 'update'
              }))
              .then((response) => {
                // if(response.data.status == 'success'){
                  this.videoAfter = response.data.after_video

                  this.video.videoList = response.data.return_video
                  this.video.videoListSpec = response.data.return_video_spec
                  this.video.videoListName = response.data.return_video_name
                  this.video.videoListTitle = response.data.return_video_title

                  // if(type == 1){
                  //   this.showMaterialSingle = true;
                  // } else {
                  //   this.showMaterial = true;
                  // }

                  // this.showVideoWindows = true

                  this.showVideoLoading = true;
                // }
              });
          }
        });
    },

    // <!-- 新手教學 -->
    nextStep() {
      // if (this.formGuideStep === 823) {
      //   axios
      //     .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
      //       s_code: this.$route.params.id,
      //       id: this.formTeaching_id,
      //       campaign_id: this.campaignId,
      //       campaign_objective: this.goalsObjective,
      //       skip: 1,
      //       step: this.formGuideStep,
      //       active: ''
      //     }))
      //     .then((response) => {
      //       if(response.data.teaching_status == 'Y'){
      //         this.formTeaching_id = 0;
      //         this.formTeachingOverData = 1;
      //         this.$emit('childFormTeachingOver', 1);
      //       }
      //       this.formGuideStep = -1;
      //       this.$router.push({ query: { step: this.formGuideStep, formguide: false }});
      //     });
      // } else {
      //   axios
      //     .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
      //       s_code: this.$route.params.id,
      //       id: this.formTeaching_id,
      //       campaign_id: this.campaignId,
      //       campaign_objective: this.goalsObjective,
      //       skip: 0,
      //       step: this.formGuideStep,
      //       active: ''
      //     }))
      //     .then((response) => {
      //       this.formGuideStep = this.formGuideStep + 1;
      //       this.$router.push({ query: { step: this.formGuideStep }});
      //     });
      // }

      // if (this.msgGuideStep === 735) {
      //   axios
      //     .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
      //       s_code: this.$route.params.id,
      //       id: this.msgTeaching_id,
      //       campaign_id: this.campaignId,
      //       campaign_objective: this.goalsObjective,
      //       skip: 1,
      //       step: this.msgGuideStep,
      //       active: ''
      //     }))
      //     .then((response) => {
      //       if(response.data.teaching_status == 'Y'){
      //         console.log('teaching_status Y');
      //         this.msgTeaching_id = 0;
      //         this.msgTeachingOverData = 1;
      //         this.$emit('childMsgTeachingOver', 1);
      //       }
      //       this.msgGuideStep = -1;
      //       this.$router.push({ query: { step: this.msgGuideStep, msgguide: false }});
      //     });
      // } else {
      //   axios
      //     .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
      //       s_code: this.$route.params.id,
      //       id: this.msgTeaching_id,
      //       campaign_id: this.campaignId,
      //       campaign_objective: this.goalsObjective,
      //       skip: 0,
      //       step: this.msgGuideStep,
      //       active: ''
      //     }))
      //     .then((response) => {
      //       this.msgGuideStep = this.msgGuideStep + 1;
      //       this.$router.push({ query: { step: this.msgGuideStep }});
      //     });
      // }
    },
    closeTips() {
      console.log('closeTips');
      console.log(this.formGuideStep);

      let skip = 0;
      let skip_target = [801, 823];
      for(let i = 0; i < skip_target.length; i++){
        if(this.formGuideStep == skip_target[i]){
          skip = 1;
        }
      }
      // if(this.nowStep == 70){
      //   skip = 1;
      // }

      // axios
      //   .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
      //     s_code: this.$route.params.id,
      //     id: this.formTeaching_id,
      //     campaign_id: this.campaignId,
      //     campaign_objective: this.goalsObjective,
      //     skip: skip,
      //     step: this.formGuideStep,
      //     active: ''
      //   }))
      //   .then((response) => {
      //     if(response.data.teaching_status == 'Y'){
      //       this.formTeaching_id = 0;
      //       this.formTeachingOverData = 1;
      //       this.$emit('childFormTeachingOver', 1);
      //     }

      //     this.formGuideStep = -1;
      //     this.$router.push({ query: { step: this.formGuideStep }});
      //   });
    },
    // <!-- 新手教學 -->
    newForm(){
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.formName = '';
        this.formData = {
          form0: {
            title: ''
          },
          form1: {
            type: "0"
          },
          form2: {
            isOpen: false,
            title: "",
            introductionType: "0",
            introduction: "",
            introductionItem: ["", "", "", "", ""]
          },
          form3: {
            type: "",
            single: [],
            other: []
          },
          form4: {
            type: "",
            instruction: "",
            isOpenInstruction: false,
            isCountries: [],
            countries: [
              {
                name: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                code: "01",
                sub: [
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_email'],
                    code: "EMAIL"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_phone_number'],
                    code: "PHONE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_street_address'],
                    code: "STREET_ADDRESS"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_city'],
                    code: "CITY"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_state'],
                    code: "STATE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_province'],
                    code: "PROVINCE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_country'],
                    code: "COUNTRY"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_post_code'],
                    code: "POST_CODE"
                  },
                  {
                    type: "01",
                    typeName: this.lang['views']['Form']['Dialog']['data']['contact_person_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_zip_code'],
                    code: "ZIP"
                  }
                ]
              },
              {
                name: this.lang['views']['Form']['Dialog']['data']['member_name'],
                code: "02",
                sub: [
                  {
                    type: "02",
                    typeName: this.lang['views']['Form']['Dialog']['data']['member_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_full_name'],
                    code: "FULL_NAME"
                  },
                  {
                    type: "02",
                    typeName: this.lang['views']['Form']['Dialog']['data']['member_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_first_name'],
                    code: "FIRST_NAME"
                  },
                  {
                    type: "02",
                    typeName: this.lang['views']['Form']['Dialog']['data']['member_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_last_name'],
                    code: "LAST_NAME"
                  }
                ]
              },
              {
                name: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                code: "03",
                sub: [
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_date_of_birth'],
                    code: "DOB"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_gender'],
                    code: "GENDER"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_marital_status'],
                    code: "MARITIAL_STATUS"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_relationship_status'],
                    code: "RELATIONSHIP_STATUS"
                  },
                  {
                    type: "03",
                    typeName: this.lang['views']['Form']['Dialog']['data']['statistics_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_military_status'],
                    code: "MILITARY_STATUS"
                  }
                ]
              },
              {
                name: this.lang['views']['Form']['Dialog']['data']['work_name'],
                code: "04",
                sub: [
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_job_title'],
                    code: "JOB_TITLE"
                  },
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_work_phone_number'],
                    code: "WORK_PHONE_NUMBER"
                  },
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_work_email'],
                    code: "WORK_EMAIL"
                  },
                  {
                    type: "04",
                    typeName: this.lang['views']['Form']['Dialog']['data']['work_name'],
                    name: this.lang['views']['Form']['Dialog']['data']['form4_mark_company_name'],
                    code: "COMPANY_NAME"
                  }
                ]
              }
            ],
            dataType: []
          },
          form5: {
            isOpen: false,
            url: "",
            urlText: "",
            content: "",
            agree: []
          },
          from6: {},
          form7: {
            title: "",
            main: "",
            web: "",
            countryCode:{ name: '台灣（+886）', code: 'TW' },
            business_phone_number: "",
            btntext: "",
            url: ""
          },
          form8: {
            lang: "",
            shareType: "0"
          },
          focus: ""
        };

        this.showFormModal = true;
        // <!-- 新手教學 -->
        console.log('this.formTeachingOverData');
        console.log(this.formTeachingOverData);
        if(this.useTeachDetail == true && this.formTeachingOverData == 0 && this.targetAllSkip == 0){
          // axios
          //   .post('https://test.autoturn.net/inside/api/data/teaching_create.php', Qs.stringify({
          //     s_code: this.$route.params.id,
          //     step: 801
          //   }))
          //   .then((response) => {
          //     this.formTeaching_id = response.data.id;
          //     this.formGuideStep = 801;
          //     this.$router.push({ query: { step: this.formGuideStep }});
          //   });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Form']['Dialog']['methods']['newForm']['not_pageId_swal_title'],
                  this.lang['views']['Form']['Dialog']['methods']['newForm']['not_pageId_swal_text'],
                  'error'
                )
      }
      // <!-- 新手教學 -->
    },
    changeSelectFormItem(value){
      this.selectedItem = value;
      console.log('changeSelectFormItem');
      console.log(value);
      // this.$emit('childChangeFormId', null);
      // console.log('1');
      // this.$emit('update:testFormId', value);
      // console.log('2');
      // this.$emit('testFormId', value);
      // console.log('3-1');
      // this.$emit('childChangeFormId', 1);

      this.viewAdMaterialDatalistData.creative_array[this.currentTab].form_sr_i = value

      console.log('this.viewAdMaterialDatalistData.creative_array['+this.currentTab+']');
      console.log(this.viewAdMaterialDatalistData.creative_array[this.currentTab]);

      // var todayForm = new Date();
      // var yearForm = todayForm.getFullYear();
      // var dateForm = String(todayForm.getDate()).padStart(2, '0');
      // var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      // var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      // let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;
      // console.log('3-2');
      // this.$emit('childChangeFormId', get_value);
      // console.log('4');
      // this.$emit('childAdIsChangeData', true);
      for (let i = 0; i < this.immediateList.length; i++) {
        if (this.immediateList[i].id === value) {
          if(this.immediateList[i].status == 'formal'){
            // console.log('正式');
            this.editType = 1
          } else {
            // console.log('草稿');
            this.editType = 2
          }
        }
      }
    },
    activeImmediate(value, type){
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        if(value != ''){
          console.log('activeImmediate type');
          console.log(type);

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_leadgen_forms_view.php', Qs.stringify({
              s_code: this.$route.params.id,
              id: value,
              type: type
            }))
            .then((response) => {
              console.log('response.data.return_data.form');
              console.log(response.data.return_data.form);
              if(response.data.status == 'success'){
                // this.immediateList = response.data.return_data
                this.formData = response.data.return_data.form

                if(type == 1){
                  var todayForm = new Date();
                  var yearForm = todayForm.getFullYear();
                  var dateForm = String(todayForm.getDate()).padStart(2, '0');
                  var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                  var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                  todayForm = yearForm + monthForm + dateForm + timeForm;

                  this.formName = 'title_'+todayForm;
                } else {
                  this.formName = response.data.return_data.name;
                }

                this.showFormModal = true
              }
            });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Form']['Dialog']['methods']['activeImmediate']['not_pageId_swal_title'],
                  this.lang['views']['Form']['Dialog']['methods']['activeImmediate']['not_pageId_swal_text'],
                  'error'
                )
      }
    },
    prev() {
      if (this.preview > 1) this.preview--;
    },
    next() {
      if (this.preview < 4) this.preview++;
    },
    getMaxId(list) {
      let id = 1;
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          if (id < list[i].id) {
            id = list[i].id;
          }
        }

        id += 1;
      }

      return id;
    },
    form3TypeChange() {
      console.log('b single');
      console.log(this.formData.form3.single);
      console.log('b other');
      console.log(this.formData.form3.other);
      console.log('b type');
      console.log(this.formData.form3.type);

      console.log('form3TypeChange #1 this.formData.form3');
      console.log(this.formData.form3);
      // if(this.editPageType == false){
        if (this.formData.form3.type.code == "01") {
          this.formData.form3.single.push({
            id: this.getMaxId(this.formData.form3.single),
            type: this.formData.form3.type,
            text: "",
            answer: [],
            answerText: "",
            isOpen: false
          });
        } else {
          let otherLength = this.formData.form3.other.length
          let haveDate = 0;
          if(otherLength > 0){
            for(let i = 0; i < otherLength; i++){
              if(this.formData.form3.other[i].type.code == "03"){
                haveDate = 1;
              }
            }
          }

          // console.log("haveDate");
          // console.log(haveDate);
          // console.log("this.formData.form3.type");
          // console.log(this.formData.form3.type);

          if(haveDate == 0){
            this.formData.form3.other.push({
              id: this.getMaxId(this.formData.form3.other),
              type: this.formData.form3.type,
              text: "",
              confirm: "",
              isOpen: false
            });
          } else {
            if(this.formData.form3.type.code != "03"){
              this.formData.form3.other.push({
                id: this.getMaxId(this.formData.form3.other),
                type: this.formData.form3.type,
                text: "",
                confirm: "",
                isOpen: false
              });
            }
          }
        }

        this.formData.form3.type = "";

        console.log('a single');
        console.log(this.formData.form3.single);
        console.log('a other');
        console.log(this.formData.form3.other);
        console.log('a type');
        console.log(this.formData.form3.type);

        console.log('form3TypeChange #2 this.formData.form3');
        console.log(this.formData.form3);

        // console.log('a type');
        // console.log(this.formData.form3.type);
      // }
    },
    getForm3Other(id) {
      return (
        this.formData.form3.other.filter(x => x.type.code == id).length > 0
      );
    },
    setForm3Answer(obj) {
      // if(this.editPageType == false){
        if (obj) {
          obj.answer.push({ text: obj.answerText });
        }
        obj.answerText = "";
      // }
    },
    removeForm3Single(id) {
      console.log('b removeForm3Single');
      console.log(id);
      console.log(this.formData.form3);
      // if(this.editPageType == false){
        for (let i = 0; i < this.formData.form3.single.length; i++) {
          if (this.formData.form3.single[i].id == id) {
            this.formData.form3.single.splice(i, 1);
            break;
          }
        }
      // }

      console.log('a removeForm3Single');
      console.log(this.formData.form3);
    },
    removeForm3SingleAnswer(id, index) {
      console.log('b removeForm3SingleAnswer');
      console.log(id+':'+ index);
      console.log(this.formData.form3);
      // if(this.editPageType == false){
        for (let i = 0; i < this.formData.form3.single.length; i++) {
          // if (this.formData.form3.single[i].id == id) {
            this.formData.form3.single[i].answer.splice(index, 1);
            break;
          // }
        }
      // }

      console.log('a removeForm3SingleAnswer');
      console.log(this.formData.form3);
    },
    removeForm3Other(id) {
      console.log('b removeForm3Other');
      console.log(id);
      console.log(this.formData.form3);
      // if(this.editPageType == false){
        for (let i = 0; i < this.formData.form3.other.length; i++) {
          if (this.formData.form3.other[i].id == id) {
            this.formData.form3.other.splice(i, 1);
            break;
          }
        }
      // }

      console.log('a removeForm3Other');
      console.log(this.formData.form3);
    },
    form4TypeChange() {
      // if(this.editPageType == false){
        if (
          this.formData.form4.isCountries.indexOf(
            this.formData.form4.type.code
          ) == -1
        ) {
          this.formData.form4.dataType.push({
            type: this.formData.form4.type,
            text: this.formData.form4.type.name
          });
          this.formData.form4.isCountries.push(this.formData.form4.type.code);
        }

        console.log(this.formData.form4.isCountries);
        console.log(this.formData.form4.type);
        console.log(this.formData.form4.dataType);

        this.formData.form4.type = "";
      // }
    },
    removeForm4Datatype(code) {
      // if(this.editPageType == false){
        if (this.formData.form4.isCountries.indexOf(code) > -1) {
          this.formData.form4.isCountries.splice(
            this.formData.form4.isCountries.indexOf(code),
            1
          );
        }

        for (let i = 0; i < this.formData.form4.dataType.length; i++) {
          if (this.formData.form4.dataType[i].type.code == code) {
            this.formData.form4.dataType.splice(i, 1);
            break;
          }
        }
      // }
    },
    setForm5Agree() {
      // if(this.editPageType == false){
        this.formData.form5.agree.push({ content: "", isAgree: false });
      // }

      // console.log('setForm5Agree');
      // console.log(this.formData.form5.agree);
    },
    test(){
      // console.log(this.formData.form8.lang);
    },
    IsURL(str_url){
      console.log('str_url');
      console.log(str_url);
      // var strRegex = /http(s)?:\/\/([\w-]+\.)+[\w-]+(\/[\w- .\/?%&=]*)?/;
      // // var strRegex = /^(?:http(s)?:\/\/)?[\w.-]+(?:\.[\w\.-]+)+[\w\-\._~:/?#[\]@!\$&'\*\+,;=.]+$/;
      // // var strRegex = /^(http|https):\/\/[\w\-_\u4E00-\u9FA5:/]+(\.[\w\-_\u4E00-\u9FA5]+)+([\u4E00-\u9FA5\w\-.,@?^=%&:/~+#]*[\u4E00-\u9FA5\w\-@?^=%&/~+#])?$/;
      // var re = new RegExp(strRegex);
      // //re.test()
      // if (re.test(str_url)){
      //   console.log('#1');
        return true;
      // } else {
      //   console.log('#2');
      //   return false;
      // }
    },
    form_update(){
      // console.log('this.formTitle');
      // console.log(this.formTitle);
      console.log('this.formData');
      console.log(this.formData);

      console.log('this.formName');
      console.log(this.formName);

      let title = this.formName
      let data = this.formData

      // if(this.editPageType == false){
        let isTrue = 1;
        let swal_title = '';
        let swal_info = '';

        let form7_url = data.form7.url
        if(this.IsURL(form7_url) == false){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['url_format_error_swal_text'];
        }

        if(data.form7.url == '' || data.form7.url == null || data.form7.url == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_url_swal_text'];
        }

        if(data.form7.web.code == 'CALL_BUSINESS'){
          if(data.form7.business_phone_number == '' || data.form7.business_phone_number == null || data.form7.business_phone_number == 'undefined'){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_phone_swal_text'];
          }
        }

        if(data.form7.btntext == '' || data.form7.btntext == null || data.form7.btntext == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_btntext_swal_text'];
        }

        if(data.form7.main == '' || data.form7.main == null || data.form7.main == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_main_swal_text'];
        }

        if(data.form7.title == '' || data.form7.title == null || data.form7.title == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form7']['not_title_swal_text'];
        }

        let form5Agree = data.form5.agree.length;
        for(let i = 0; i < form5Agree; i++){
          let agree_content = data.form5.agree[i].content;
          if(data.form5.isOpen == true && (agree_content?.trim() == '' || agree_content?.trim() == null || agree_content?.trim() == 'undefined')){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_agree_content_swal_text'];
          }
        }

        let form5_content = data.form5.content;
        if(data.form5.isOpen == true && (form5_content?.trim() == '' || form5_content?.trim() == null || form5_content?.trim() == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_content_swal_text'];
        }

        let form5_title = data.form5.title;
        if(data.form5.isOpen == true && (form5_title?.trim() == '' || form5_title?.trim() == null || form5_title?.trim() == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_title_swal_text'];
        }

        let form5_urlText = data.form5.urlText;
        console.log('form5_urlText');
        console.log(form5_urlText);
        if(form5_urlText != '' && form5_urlText != null && form5_urlText != 'undefined'){
          console.log('form5_urlText in');
          if(form5_urlText.length > 70){
            console.log('form5_urlText error');
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['urlText_error_swal_text'];
          }
        }

        let form5_url = data.form5.url?.trim()
        if(this.IsURL(form5_url) == false){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['url_format_error_swal_text'];
        }

        if(form5_url == '' || form5_url == null || form5_url == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form5']['not_url_swal_text'];
        }

        let form4_instruction = data.form4.instruction;
        if(form4_instruction?.trim() == '' || form4_instruction?.trim() == null || form4_instruction?.trim() == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form4']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form4']['swal_text'];
        }

        let form3Other = data.form3.other.length;
        let form3Single = data.form3.single.length;
        if(form3Single > 0){
          for(let i = 0; i < form3Single; i++){
            if(data.form3.single[i].type.code == '01'){
              let answerLength = data.form3.single[i].answer.length;
              if(answerLength > 0){
                if(answerLength == 1){
                  isTrue = 0;
                  swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                  swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['answerLength_number_of_items_swal_text'];
                } else {
                  for(let j = 0; j < answerLength; j++){
                    if(data.form3.single[i].answer[j].text == '' || data.form3.single[i].answer[j].text == null || data.form3.single[i].answer[j].text == 'undefined'){
                      isTrue = 0;
                      swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                      swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['answerLength_not_text_swal_text'];
                    }
                  }
                }
              } else {
                isTrue = 0;
                swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['not_answerLength_swal_text'];
              }

              if(data.form3.single[i].text == '' || data.form3.single[i].text == null || data.form3.single[i].text == 'undefined'){
                isTrue = 0;
                swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['not_text_swal_text'];
              }
            }
          }
        }

        if(form3Other > 0){
            for(let i = 0; i < form3Other; i++){
              if(data.form3.other[i].type.code == '02'){
                if(data.form3.other[i].text == '' || data.form3.other[i].text == null || data.form3.other[i].text == 'undefined'){
                  isTrue = 0;
                  swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                  swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['code_02_not_text_swal_text'];
                }
              }

              if(data.form3.other[i].type.code == '03'){
                if(data.form3.other[i].text == '' || data.form3.other[i].text == null || data.form3.other[i].text == 'undefined'){
                  isTrue = 0;
                  swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['swal_title'];
                  swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form3']['code_03_not_text_swal_text'];
                }
              }
            }
        }

        if(data.form2.isOpen == true && data.form2.introductionType == '1'){
          let introductionItemLength = data.form2.introductionItem.length;
          // console.log('introductionItemLength');
          // console.log(introductionItemLength);
          // console.log('data.form2.introductionItem');
          // console.log(data.form2.introductionItem);

          let itemTrue = 0;
          for(let i = 0; i < introductionItemLength; i++){
            // console.log('data.form2.introductionItem['+i+']');
            // console.log(data.form2.introductionItem[i]);
            // console.log(data.form2.introductionItem[i].trim());
            let introductionItem = data.form2.introductionItem[i]?.trim();
            if(introductionItem != '' && introductionItem != null && typeof introductionItem != 'undefined'){
              // console.log('itemTrue');
              itemTrue = 1;
              break;
            }
          }

          for(let j = 0; j < introductionItemLength; j++){
            let introductionItemContent = data.form2.introductionItem[j].replace(/[^\x00-\xff]/g,"OO").length;
            if(introductionItemContent > 80){
              itemTrue = 2;
            }
          }

          if(itemTrue == 0){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['not_itemTrue_swal_text'];
          }

          if(itemTrue == 2){
            isTrue = 0;
            swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
            swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['under_80_characters_itemTrue_swal_text'];
          }
        }

        if(data.form2.isOpen == true && data.form2.introductionType == '0' && (data.form2.introduction == '' || data.form2.introduction == null || data.form2.introduction == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['not_introductionType_swal_text'];
        }

        if(data.form2.isOpen == true && (data.form2.title == '' || data.form2.title == null || data.form2.title == 'undefined')){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['form2']['not_title_swal_text'];
        }

        if(title == '' || title == null || title == 'undefined'){
          isTrue = 0;
          swal_title = this.lang['views']['Form']['Dialog']['methods']['form_update']['formTitle_swal_title'];
          swal_info = this.lang['views']['Form']['Dialog']['methods']['form_update']['formTitle_swal_text'];
        }

        if(isTrue == 0){
          Swal.fire(
                    swal_title,
                    swal_info,
                    "warning"
                  )
        } else {
          axios
            .post('https://test.autoturn.net/inside/api/customize/data/form_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
              form_title: title,
              form_data: data,
            }))
            .then((response) => {
              // console.log(response.data);
              // if(response.data.status == 'success'){
                // this.immediateList = response.data.return_data
                // this.formData = response.data.return_data.form

                // if(type == 1){
                //   var todayForm = new Date();
                //   var yearForm = todayForm.getFullYear();
                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                //   this.formTitle = 'title_'+todayForm;
                // } else {
                //   this.formTitle = response.data.return_data.name;
                // }

                // this.showModal = true
              // }
              Swal.fire({
                icon: response.data.status,
                title: this.lang['views']['Form']['Dialog']['methods']['form_update']['axios_form_update']['swal_title'],
                text: response.data.info,
                showDenyButton: false,
                showCancelButton: false,
                confirmButtonText: this.lang['views']['Form']['Dialog']['methods']['form_update']['axios_form_update']['confirm_button'],
                // denyButtonText: `Don't save`,
              }).then((result) => {
                if (result.isConfirmed) {
                  this.showFormList = true;
                  this.showFormModal = false
                  // Swal.fire('Saved!', '', 'success')
                  axios
                    .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_leadgen_forms.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      page_id: this.pageId
                    }))
                    .then((response) => {
                      if(response.data.status == 'success'){
                        this.immediateList = response.data.return_data
                      }

                      this.showFormList = false
                    });
                } else if (result.isDenied) {
                  this.showFormList = true;
                  // Swal.fire('Changes are not saved', '', 'info')
                  axios
                    .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_leadgen_forms.php', Qs.stringify({
                      s_code: this.$route.params.id,
                      page_id: this.pageId
                    }))
                    .then((response) => {
                      if(response.data.status == 'success'){
                        this.immediateList = response.data.return_data
                      }

                      this.showFormList = false
                    });
                }
              })
            });
        }
      // }
    },
    // <!-- 訊息範本 -->
    setFakeImage() {

      let itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
      itemList[index].info[0].imgVideo = [];

      // itemList[index].info[0].imgVideo.push({
      //   id: 1,
      //   img: 'https://res.cloudinary.com/dj1uuawxw/image/upload/v1622275197/wdge0wplcjohmvrhtm7z.jpg',
      //   media_id: 47,
      //   title: ""
      // });

      console.log('this.img');
      console.log(this.img);
      console.log(this.img.imgList[0].url);

      let tmpImgUrl = this.img.imgList[0].url;

      if(tmpImgUrl != '' && tmpImgUrl != null && typeof tmpImgUrl != 'undefined'){
        itemList[index].info[0].imgVideo.push({
          id: this.img.imgList[0].id,
          img: this.img.imgList[0].url,
          media_img: this.img.imgList[0].media_img,
          media_id: this.img.imgList[0].ctm_media,
          title: ""
        });

        // itemList[index].info[i].imgVideo.push({
        //   id: this.img.imgList[this.img.active].id,
        //   img: this.img.imgList[this.img.active].url,
        //   media_img: this.img.imgList[this.img.active].media_img,
        //   media_id: this.img.imgList[this.img.active].ctm_media,
        //   title: ""
        // });

        itemList[index].info[0].editType = "img";
      }
    },
    closeMsgTips() {
      console.log('closeTips');
      console.log(this.msgGuideStep);

      let skip = 0;
      let skip_target = [701, 735];
      for(let i = 0; i < skip_target.length; i++){
        if(this.msgGuideStep == skip_target[i]){
          skip = 1;
        }
      }
      // if(this.nowStep == 70){
      //   skip = 1;
      // }

      axios
        // .post('https://test.autoturn.net/inside/api/data/teaching_update.php', Qs.stringify({
        //   s_code: this.$route.params.id,
        //   id: this.msgTeaching_id,
        //   campaign_id: this.campaignId,
        //   campaign_objective: this.goalsObjective,
        //   skip: skip,
        //   step: this.msgGuideStep,
        //   active: ''
        // }))
        // .then((response) => {
        //   if(response.data.teaching_status == 'Y'){
        //     this.msgTeaching_id = 0;
        //     this.msgTeachingOverData = 1;
        //     this.$emit('childMsgTeachingOver', 1);
        //   }

        //   this.msgGuideStep = -1;
        //   this.$router.push({ query: { step: this.msgGuideStep }});
        // });
    },
    // <!-- 新手教學 -->
    selectImg(index, type){
      if(type == 'api'){
        this.img.active = null;
        this.img.activeApi = index;
      } else {
        this.img.active = index;
        this.img.activeApi = null;
      }
    },
    selectVideo(index, type){
      if(type == 'api'){
        this.video.active = null;
        this.video.activeApi = index;
      } else {
        this.video.active = index;
        this.video.activeApi = null;
      }
    },
    changeSelectMsgItem(value){
      this.selectedItem = value;

      this.viewAdMaterialDatalistData.creative_array[this.currentTab].message_sr_i = value

      console.log('this.viewAdMaterialDatalistData.creative_array['+this.currentTab+']');
      console.log(this.viewAdMaterialDatalistData.creative_array[this.currentTab]);

      // var todayForm = new Date();
      // var yearForm = todayForm.getFullYear();
      // var dateForm = String(todayForm.getDate()).padStart(2, '0');
      // var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
      // var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

      // let get_value = value+'_'+yearForm + monthForm + dateForm + timeForm;

      // this.$emit('childChangeMessageId', get_value);
      // this.$emit('childAdIsChangeData', true);
      // console.log('this.messageList');
      // console.log(this.messageList);
      for (let i = 0; i < this.messageList.length; i++) {
        if (this.messageList[i].id === value) {
          console.log(this.messageList[i].status);
          if(this.messageList[i].status == 'formal' || this.messageList[i].status == 'formal_zh_cn'){
            // console.log('正式');
            this.editType = 1
            break;
          } else {
            // console.log('草稿');
            this.editType = 2
            break;
          }
        }
      }

      console.log('this.editType');
      console.log(this.editType);
    },
    activeMsgImmediate(value, type){
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        if(value != ''){

          this.view_type = type

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_view.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
              id: value
            }))
            .then((response) => {
              // console.log(response);
              if(response.data.status == 'success'){
                // this.msgBox = response.data.return_data
                // console.log('b this.msgBox');
                // console.log(this.msgBox);

                console.log('b this.nodeId');
                console.log(this.nodeId);

                this.messageName = response.data.name
                if(type == 'copy'){
                  var today = new Date();
                  var year = today.getFullYear();
                  var month = (today.getMonth()<10 ? '0' : '')+(today.getMonth()+1);
                  var date = (today.getDate()<10 ? '0' : '')+today.getDate();
                  var hour = (today.getHours()<10 ? '0' : '')+today.getHours();
                  var min = (today.getMinutes()<10 ? '0' : '')+today.getMinutes();
                  var sec = (today.getSeconds()<10 ? '0' : '')+today.getSeconds();
                  var currentDateTime = year +'/'+ month +'/'+ date +' '+ hour +':'+ min + ':' + sec;
                  this.messageName = this.lang['views']['Msg']['methods']['activeImmediate']['messageName'] + currentDateTime;
                }

                this.msgBox = response.data.return_data
                this.nodeId = response.data.btn_max_id

                console.log('activeImmediate a this.msgBox');
                console.log(this.msgBox);

                console.log('a this.nodeId');
                console.log(this.nodeId);

                // this.bezierRefresh();
                // var t = this;
                // setTimeout(() => {
                //   t.bezierRefresh();
                // }, 150);

                setTimeout(() => {
                  // 更新貝茲曲線
                  // eslint-disable-next-line no-undef
                  $(".element").bezierRefresh();
                }, 500);

                this.setMsgActive(0, 0, 'first');

                this.showModal = true
              }
            });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Msg']['methods']['activeImmediate']['swal_title'],
                  this.lang['views']['Msg']['methods']['activeImmediate']['swal_text'],
                  'error'
                )
      }
    },
    save(){
      console.log('save');
      console.log(this.msgBox);

      let formData = this.msgBox
      let messageName = this.messageName

      // if(this.editPageType == false){
        if(messageName != '' && messageName != null && typeof messageName != 'undefined'){
          console.log('#1');
          axios
            .post('https://test.autoturn.net/inside/api/customize/data/message_update.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
              name: messageName,
              form_data: formData,
              type: this.view_type
            }))
            .then((response) => {
              console.log(response.data);
              if(response.data.status == 'success'){
                    Swal.fire({
                      icon: response.data.status,
                      title: this.lang['views']['Msg']['methods']['save']['swal_title'],
                      text: response.data.info,
                      showDenyButton: false,
                      showCancelButton: false,
                      confirmButtonText: this.lang['views']['Msg']['methods']['save']['confirm_button'],
                      // denyButtonText: `Don't save`,
                    }).then((result) => {
                      if (result.isConfirmed) {
                        this.showMsgList = true;
                        this.showModal = false
                        // Swal.fire('Saved!', '', 'success')
                        axios
                          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                          }))
                          .then((wmResponse) => {
                            if(wmResponse.data.status == 'success'){
                              // console.log('b this.messageList');
                              // console.log(this.messageList);

                              this.messageList = wmResponse.data.return_data

                              // console.log('a this.messageList');
                              // console.log(this.messageList);
                              this.showMsgList = false
                            }
                          });
                      } else if (result.isDenied) {
                        this.showMsgList = true;
                        this.showModal = false
                        // Swal.fire('Changes are not saved', '', 'info')
                        axios
                          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                          }))
                          .then((wmResponse) => {
                            if(wmResponse.data.status == 'success'){
                              // console.log('b this.messageList');
                              // console.log(this.messageList);

                              this.messageList = wmResponse.data.return_data

                              // console.log('a this.messageList');
                              // console.log(this.messageList);
                              this.showMsgList = false
                            }
                          });
                      }
                    })
                // this.immediateList = response.data.return_data
                // this.formData = response.data.return_data.form

                // if(type == 1){
                //   var todayForm = new Date();
                //   var yearForm = todayForm.getFullYear();
                //   var dateForm = String(todayForm.getDate()).padStart(2, '0');
                //   var monthForm = String(todayForm.getMonth() + 1).padStart(2, '0'); //January is 0!
                //   var timeForm = String(todayForm.getHours()) + String(todayForm.getMinutes()) + String(todayForm.getSeconds());

                //   todayForm = yearForm + monthForm + dateForm + timeForm;

                //   this.formTitle = 'title_'+todayForm;
                // } else {
                //   this.formTitle = response.data.return_data.name;
                // }

                // this.showModal = true
              } else {
                Swal.fire(
                          this.lang['views']['Msg']['methods']['save']['swal_title'],
                          response.data.info,
                          response.data.status
                        )
              }
            });

        } else {
          console.log('#2');
          Swal.fire(
                      this.lang['views']['Msg']['methods']['save']['swal_title'],
                      this.lang['views']['Msg']['methods']['save']['swal_text'],
                      "warning"
                    )
        }
      // }
    },
    openModal() {
      if(this.pageId != 0 && this.pageId != "" && this.pageId != null && typeof this.pageId != 'undefined'){
        this.messageName = '';
        this.msgBox = {
          item: [
            {
              id: 0,
              level: 0,
              isFirst: true,
              status:'first',
              info: [
                {
                  id: 2,
                  editType: 'text',
                  content: this.lang['views']['Msg']['methods']['openModal']['msgBox_item_info_content'],
                  btn: [],
                  imgVideo: [],
                  type: "content"
                }
              ],
              fast: []
            }
          ],
          sub: {}
        };
        this.setMsgActive(0, 0, 'first');
        this.showMsgModal = true;

        var t = this;
        setTimeout(() => {
          t.bezierRefresh();
        }, 150);
        // <!-- 新手教學 -->
        console.log('this.useTeachDetail');
        console.log(this.useTeachDetail);
        console.log('this.msgTeachingOverData');
        console.log(this.msgTeachingOverData);
        console.log('this.msgGuide');
        console.log(this.msgGuide);
        if(this.useTeachDetail == true && this.msgTeachingOverData == 0 && this.targetAllSkip == 0){
          // axios
          //   .post('https://test.autoturn.net/inside/api/data/teaching_create.php', Qs.stringify({
          //     s_code: this.$route.params.id,
          //     step: 701
          //   }))
          //   .then((response) => {
          //     this.msgTeaching_id = response.data.id;
          //     this.msgGuideStep = 701;
          //     this.$router.push({ query: { step: this.msgGuideStep }});
          //   });

          axios
            .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
              s_code: this.$route.params.id,
              page_id: this.pageId,
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                this.img = {
                  imgList: response.data.return_data,
                  imgListApi: response.data.return_data_api
                }
              }
            });
        }
      } else {
        Swal.fire(
                  this.lang['views']['Msg']['methods']['openModal']['swal_title'],
                  this.lang['views']['Msg']['methods']['openModal']['swal_text'],
                  'error'
                )
      }
      // <!-- 新手教學 -->
    },
    setMsgActive(id, level, status) {
      this.msgActive.id = id;
      this.msgActive.level = level;
      this.msgActive.status = status;

      // console.log(this.msgActive.id+':'+this.msgActive.level);
    },
    openContentTypeWindows(id, editType, btnLength) {
      console.log('id:'+id);
      console.log('editType:'+editType);
      console.log('btnLength:'+btnLength);
      console.log('this.msgBox:');
      console.log(this.msgBox);
      this.showContentTypeWindows = true;
      this.contentInfoTypeWindowsId = id;
      this.nodeBottonNum = btnLength
      this.contentInfoTypeWindowsEditType = editType;
    },
    openContentInfoBtn(id, bId) {
      this.showContentTypeWindows = false;
      this.showContentWindows = true;
      this.contentInfoBtn.text = "";
      this.contentInfoBtn.url = "";
      this.contentInfoBtn.phone = "";
      this.contentInfoBtn.active = 1;
      this.contentInfoBtn.contentId = id;
      this.contentInfoBtn.btnId = null;

      console.log('openContentInfoBtn this.contentInfoBtn');
      console.log(this.contentInfoBtn);
      console.log(bId);
      console.log('openContentInfoBtn var this.msgBox');
      console.log(this.msgBox);

      if (bId != null) {
        this.contentInfoBtn.btnId = bId;
        var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
        console.log('openContentInfoBtn this.msgBox');
        console.log(this.msgBox);

        for (let i = 0; i < itemList.length; i++) {
          if (
            itemList[i].id == this.msgActive.id &&
            itemList[i].info.length > 0
          ) {
            for (let j = 0; j < itemList[i].info.length; j++) {
              if (itemList[i].info[j].id == id) {
                for (let b = 0; b < itemList[i].info[j].btn.length; b++) {
                  if (itemList[i].info[j].btn[b].id == bId) {
                    this.contentInfoBtn.text = itemList[i].info[j].btn[b].text;
                    this.contentInfoBtn.url = itemList[i].info[j].btn[b].url;
                    this.contentInfoBtn.phone =
                      itemList[i].info[j].btn[b].phone;
                    this.contentInfoBtn.active =
                      itemList[i].info[j].btn[b].type;

                    break;
                  }
                }
                break;
              }
            }
            break;
          }
        }
      }
    },
    openMsgBoxImg(id, editType) {
      // console.log('openMsgBoxImg');
      // if(this.editPageType == false){
        this.showImgWindows = true;
        this.showImgLoading = false;
        this.img = {
          imgList: [],
          imgListApi: []
        }

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
            s_code: this.$route.params.id,
            page_id: this.pageId,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.img = {
                imgList: response.data.return_data,
                imgListApi: response.data.return_data_api
              }
            }

            this.showContentTypeWindows = false;
            this.showImgLoading = true

            if (id != null) this.contentInfoTypeWindowsId = id;
            else this.contentInfoTypeWindowsId = null;

            if (editType != null) this.contentInfoTypeWindowsEditType = editType;
            else this.contentInfoTypeWindowsEditType = null;
          });
      // }
    },
    openMsgBoxVideo(id, editType) {
      // console.log('openMsgBoxVideo');
      // if(this.editPageType == false){
        this.showMsgVideoWindows = true;
        this.showVideoLoading = false;
        this.video = {
          videoList: [],
          videoListApi: []
        }

        axios
          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
            s_code: this.$route.params.id,
            page_id: this.pageId,
          }))
          .then((response) => {
            if(response.data.status == 'success'){
              this.video = {
                videoList: response.data.return_data,
                videoListApi: response.data.return_data_api
              }
            }

            this.showContentTypeWindows = false;
            this.showVideoLoading = true

            if (id != null) this.contentInfoTypeWindowsId = id;
            else this.contentInfoTypeWindowsId = null;

            if (editType != null) this.contentInfoTypeWindowsEditType = editType;
            else this.contentInfoTypeWindowsEditType = null;
          });
      // }
    },
    getMsgLevelItem(msgBox, level) {
      // console.log('getMsgLevelItem:'+level);
      if (level > 0) {
        // console.log('level > 0');
        if (msgBox.sub) {
          // console.log(this.getMsgLevelItem(msgBox.sub, level - 1));
          return this.getMsgLevelItem(msgBox.sub, level - 1);
        } else {
          // console.log('null');
          return null;
        }
      } else {
        // console.log('level == 0');
        // console.log(msgBox.item);
        return msgBox.item;
      }
    },
    getMsgLevelMsgBox(msgBox, level) {
      if (level > 0) {
        if (msgBox.sub) {
          return this.getMsgLevelMsgBox(msgBox.sub, level - 1);
        } else {
          return null;
        }
      } else {
        return msgBox;
      }
    },
    getMsgBoxItemIndex(itemList, id) {
      let index = null;
      for (let i = 0; i < itemList.length; i++) {
        if (itemList[i].id == id) {
          index = i;

          break;
        }
      }

      return index;
    },
    getMsgBoxMaxId(list) {
      // let id = 0;
      let id = this.nodeId;
      if (list && list.length > 0) {
        for (let i = 0; i < list.length; i++) {
          if (id < list[i].id) {
            id = list[i].id;
          }
        }

        id += 1;

        this.nodeId = id
      }

      return id;
    },
    setNewNode(){
      // let msgBox = this.msgBox
      this.contentInfoBtn.active = 1;

      console.log('setNewNode b this.msgBox');
      console.log(this.msgBox);
      // console.log('setNewNode b msgBox');
      // console.log(msgBox);
      console.log('setNewNode b this.msgActive');
      console.log(this.msgActive);

      this.setMsgBoxItemBtn(this.msgBox);
    },
    setMsgBoxItemBtn(msgBox) {
      //btnId 重複
      let id = this.contentInfoBtn.contentId;
      let bId = this.contentInfoBtn.btnId;
      let url_safe = 1;
      console.log('setMsgBoxItemBtn let b this.msgBox');
      console.log(this.msgBox);
      console.log('setMsgBoxItemBtn let b this.msgActive');
      console.log(this.msgActive);

      console.log('setMsgBoxItemBtn b this.msgBox');
      console.log(this.msgBox);

      console.log('setMsgBoxItemBtn b msgBox');
      console.log(msgBox);

      let tmp_msgBox = this.msgBox
      if(msgBox != '' && msgBox != null && typeof msgBox != 'undefined'){
        tmp_msgBox = msgBox
      }

      var msgBox = this.getMsgLevelMsgBox(tmp_msgBox, this.msgActive.level);
      var itemList = this.getMsgLevelItem(tmp_msgBox, this.msgActive.level);

      console.log('setMsgBoxItemBtn b msgBox');
      console.log(msgBox);
      console.log('setMsgBoxItemBtn b itemList');
      console.log(itemList);

      console.log('this.contentInfoBtn');
      console.log(this.contentInfoBtn);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList.length; i++) {
          if (
            itemList[i].id == this.msgActive.id &&
            itemList[i].info.length > 0
          ) {
            for (let j = 0; j < itemList[i].info.length; j++) {
              if (itemList[i].info[j].id == id) {
                if (bId == null) {
                  // let btnId = this.getMsgBoxMaxId(itemList[i].info[j].btn);
                  let btnId = this.nodeId;
                  if(itemList[i].info[j].btn.length < 3){
                    let node_url = this.contentInfoBtn.url
                    if(node_url != '' && node_url != null && typeof node_url != 'undefined'){
                      if(this.IsURL(node_url) == false){
                        Swal.fire(
                          this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_title'],
                          this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_text'],
                          "error"
                        )

                        url_safe = 0;

                        break;
                      }
                    }

                    itemList[i].info[j].btn.push({
                      id: btnId,
                      text: this.contentInfoBtn.text,
                      url: this.contentInfoBtn.url,
                      phone: this.contentInfoBtn.phone,
                      type: this.contentInfoBtn.active
                    });

                    let randInt = Math.floor((Math.random() * (110-100)) +100);

                    this.nodeId = parseInt(btnId) + parseInt(randInt);
                    console.log('setMsgBoxItemBtn nodeId');
                    console.log(this.nodeId);
                    console.log('setMsgBoxItemBtn btnId');
                    console.log(btnId);

                    if (!msgBox.sub || !msgBox.sub.item || !msgBox.sub.sub) {
                      msgBox.sub = {
                        item: [],
                        sub: {}
                      };
                    }

                    let insertIndex = 0;
                    for (
                      insertIndex;
                      insertIndex < msgBox.sub.item.length;
                      insertIndex++
                    ) {
                      if (msgBox.sub.item[insertIndex].parentFast != null) {
                        break;
                      }
                    }

                    if(this.contentInfoBtn.active == 1){
                      let infoId = this.nodeId
                      msgBox.sub.item.splice(insertIndex, 0, {
                        id: this.getMsgBoxMaxId(msgBox.sub.item),
                        level: this.msgActive.level + 1,
                        parent: this.msgActive.id,
                        parentInfo: id,
                        parentInfoBtn: btnId,
                        status:'general',
                        info: [
                          {
                            id: infoId,
                            editType: 'text',
                            content: this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['msgBox_item_info_content'],
                            btn: [],
                            imgVideo: [],
                            type: "content"
                          }
                        ],
                        fast: []
                      });
                    }
                  }
                } else {
                  for (let b = 0; b < itemList[i].info[j].btn.length; b++) {
                    if (itemList[i].info[j].btn[b].id == bId) {
                      let node_url = this.contentInfoBtn.url
                      if(node_url != '' && node_url != null && typeof node_url != 'undefined'){
                        if(this.IsURL(node_url) == false){
                          Swal.fire(
                            this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_title'],
                            this.lang['views']['Msg']['methods']['setMsgBoxItemBtn']['url_format_error_swal_text'],
                            "error"
                          )

                          url_safe = 0;

                          break;
                        }
                      }

                      itemList[i].info[j].btn[b].text = this.contentInfoBtn.text;
                      itemList[i].info[j].btn[b].url = this.contentInfoBtn.url;
                      itemList[i].info[j].btn[
                        b
                      ].phone = this.contentInfoBtn.phone;
                      itemList[i].info[j].btn[
                        b
                      ].type = this.contentInfoBtn.active;

                      break;
                    }
                  }
                }
              }
            }
            break;
          }
        }
        // console.log('itemList');3
        if(url_safe == 1){
          this.showContentWindows = false;
        }
      // }

      console.log('setMsgBoxItemBtn a this.msgBox');
      console.log(this.msgBox);
      console.log('setMsgBoxItemBtn a msgBox');
      console.log(msgBox);
      console.log('setMsgBoxItemBtn a itemList');
      console.log(itemList);

      this.bezierRefresh();
    },
    setMsgBoxItemFast(tmp_text, tmp_content) {
      var msgBox = this.getMsgLevelMsgBox(this.msgBox, this.msgActive.level);
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);

      console.log('tmp_text');
      console.log(tmp_text);

      let textLabel = '';
      if(tmp_text != '' && tmp_text != null && typeof tmp_text != 'undefined'){
        textLabel = tmp_text;
      }

      console.log('textLabel');
      console.log(textLabel);

      console.log('tmp_content');
      console.log(tmp_content);

      let contentLabel = this.lang['views']['Msg']['methods']['setMsgBoxItemFast']['msgBox_item_info_content'];
      if(tmp_content != '' && tmp_content != null && typeof tmp_content != 'undefined'){
        contentLabel = tmp_content;
      }

      console.log('contentLabel');
      console.log(contentLabel);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList.length; i++) {
          if (itemList[i].id == this.msgActive.id) {
            // let fastId = this.getMsgBoxMaxId(itemList[i].fast);
            let fastId = this.nodeId;
            itemList[i].fast.push({
              id: fastId,
              text: textLabel
            });

            this.nodeId = parseInt(fastId) + parseInt(1);

            if (!msgBox.sub || !msgBox.sub.item || !msgBox.sub.sub) {
              msgBox.sub = {
                item: [],
                sub: {}
              };
            }

            let itemId = this.nodeId
            msgBox.sub.item.push({
              id: this.getMsgBoxMaxId(msgBox.sub.item),
              level: this.msgActive.level + 1,
              parent: this.msgActive.id,
              parentFast: fastId,
              status:'fast',
              info: [
                {
                  id: itemId,
                  editType: "text",
                  content: contentLabel,
                  btn: [],
                  imgVideo: [],
                  type: "content"
                }
              ],
              fast: []
            });

            break;
          }
        }
      // }

      this.bezierRefresh();
    },
    setMsgBoxContent() {
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);
      // if(this.editPageType == false){
        itemList[index].info.push({
          id: this.getMsgBoxMaxId(itemList[index].info),
          content: "",
          btn: [],
          imgVideo: [],
          editType: "text",
          type: "content"
        });
      // }
    },
    setMsgBoxImg() {
      // if(this.editPageType == false){
        if (
          this.img.active != null &&
          this.img.imgList.length > this.img.active
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.img.imgList[this.img.active].id,
                  img: this.img.imgList[this.img.active].url,
                  media_img: this.img.imgList[this.img.active].media_img,
                  media_id: this.img.imgList[this.img.active].ctm_media,
                  title: ""
                });

                itemList[index].info[i].editType = "img";
                break;
              }
            }
          } else {
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              img_id: this.img.imgList[this.img.active].id,
              img: this.img.imgList[this.img.active].url,
              media_img: this.img.imgList[this.img.active].media_img,
              media_id: this.img.imgList[this.img.active].ctm_media,
              type: "img",
              editType: "img",
              title: "",
              btn: []
            });
          }
        }

        if (
          this.img.activeApi != null &&
          this.img.imgListApi.length > this.img.activeApi
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.img.imgListApi[this.img.activeApi].id,
                  img: this.img.imgListApi[this.img.activeApi].url,
                  media_img: this.img.imgListApi[this.img.activeApi].media_img,
                  media_id: this.img.imgListApi[this.img.activeApi].ctm_media,
                  title: ""
                });

                itemList[index].info[i].editType = "img";
                break;
              }
            }
          } else {
            console.log('this.img');
            console.log(this.img);
            console.log('this.img.activeApi');
            console.log(this.img.activeApi);
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              img_id: this.img.imgListApi[this.img.activeApi].id,
              img: this.img.imgListApi[this.img.activeApi].url,
              media_img: this.img.imgListApi[this.img.activeApi].media_img,
              media_id: this.img.imgListApi[this.img.activeApi].ctm_media,
              type: "img",
              editType: "img",
              title: "",
              btn: []
            });
          }
        }

        // console.log('setMsgBoxImg itemList');
        // console.log(itemList);

        this.img.active = null;
        this.img.activeApi = null;
        this.showImgWindows = false;
      // }

      this.bezierRefresh();
    },
    setMsgBoxVideo() {
      console.log('setMsgBoxVideo');
      // if(this.editPageType == false){
        if (
          this.video.active != null &&
          this.video.videoList.length > this.video.active
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.video.videoList[this.video.active].id,
                  video: this.video.videoList[this.video.active].url,
                  media: this.video.videoList[this.video.active].media,
                  media_id: this.video.videoList[this.video.active].ctm_media,
                  title: ""
                });

                itemList[index].info[i].content = "";
                itemList[index].info[i].editType = "video";
                break;
              }
            }
          } else {
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              video_id: this.video.videoList[this.video.active].id,
              video: this.video.videoList[this.video.active].url,
              media: this.video.videoList[this.video.active].media,
              media_id: this.video.videoList[this.video.active].ctm_media,
              type: "video",
              editType: "video",
              title: "",
              btn: []
            });
          }
        }

        if (
          this.video.activeApi != null &&
          this.video.videoListApi.length > this.video.activeApi
        ) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

          if (this.contentInfoTypeWindowsId != null) {
            for (let i = 0; i < itemList[index].info.length; i++) {
              if (itemList[index].info[i].id === this.contentInfoTypeWindowsId) {
                itemList[index].info[i].imgVideo = [];

                itemList[index].info[i].imgVideo.push({
                  id: this.video.videoListApi[this.video.activeApi].id,
                  video: this.video.videoListApi[this.video.activeApi].url,
                  media: this.video.videoListApi[this.video.activeApi].media,
                  media_id: this.video.videoListApi[this.video.activeApi].ctm_media,
                  title: ""
                });

                itemList[index].info[i].content = "";
                itemList[index].info[i].editType = "video";
                break;
              }
            }
          } else {
            itemList[index].info.push({
              id: this.getMsgBoxMaxId(itemList[index].info),
              video_id: this.video.videoListApi[this.video.activeApi].id,
              video: this.video.videoListApi[this.video.activeApi].url,
              media: this.video.videoListApi[this.video.activeApi].media,
              media_id: this.video.videoListApi[this.video.activeApi].ctm_media,
              type: "video",
              editType: "video",
              title: "",
              btn: []
            });
          }
        }

        console.log('setMsgBoxVideo itemList');
        console.log(itemList);

        this.video.active = null;
        this.video.activeApi = null;
        this.showMsgVideoWindows = false;
      // }

      this.bezierRefresh();
    },
    removeMsgBoxConfirmed(id, level) {
      var t = this;

      // if(this.editPageType == false){
        this.$swal
          .fire({
            text: this.lang['views']['Msg']['methods']['removeMsgBoxConfirmed']['swal_title'],
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#1D619F",
            confirmButtonText: this.lang['views']['Msg']['methods']['removeMsgBoxConfirmed']['confirm_button']
          })
          .then(result => {
            if (result.isConfirmed) {
              t.removeMsgBox(id, level);
            }
          });
        // }
    },
    removeMsgBox(id, level) {
      var itemList = this.getMsgLevelItem(this.msgBox, level);
      let index = this.getMsgBoxItemIndex(itemList, id);

      // if(this.editPageType == false){
        this.removeMsgBoxParent(level - 1, {
          id: itemList[index].parent,
          info: itemList[index].parentInfo,
          infoBtn: itemList[index].parentInfoBtn,
          fast: itemList[index].parentFast
        });

        console.log('itemList['+index+'].info');
        console.log(itemList[index].info);
        console.log('itemList['+index+'].fast');
        console.log(itemList[index].fast);

        if(itemList[index].info != '' && itemList[index].info != null && typeof itemList[index].info != 'undefined'){
          for (let i = 0; i < itemList[index].info.length; i++) {
            if(itemList[index].info[i].btn != '' && itemList[index].info[i].btn != null && typeof itemList[index].info[i].btn != 'undefined'){
              for (let j = 0; j < itemList[index].info[i].btn.length; j++) {
                this.removeMsgBoxSub(level + 1, {
                  id: id,
                  info: itemList[index].info[i].id,
                  infoBtn: itemList[index].info[i].btn[j].id
                });
              }
            }
          }
        }

        if(itemList[index].fast != '' && itemList[index].fast != null && typeof itemList[index].fast != 'undefined'){
          for (let i = 0; i < itemList[index].fast.length; i++) {
            this.removeMsgBoxSub(level + 1, {
              id: id,
              fast: itemList[index].fast[i].id
            });
          }
        }

        if (index != null) {
          itemList.splice(index, 1);
          this.setMsgActive(0, 0, 'first');
        }
      // }

      this.bezierRefresh();
    },
    removeMsgBoxParent(level, parent) {
      var itemList = this.getMsgLevelItem(this.msgBox, level);
      let index = this.getMsgBoxItemIndex(itemList, parent.id);

      // if(this.editPageType == false){
        if (
          itemList[index].info.length > 0 &&
          parent.info != undefined &&
          parent.infoBtn != undefined
        ) {
          for (let i = 0; i < itemList[index].info.length; i++) {
            if (itemList[index].info[i].id == parent.info) {
              for (let j = 0; j < itemList[index].info[i].btn.length; j++) {
                if (itemList[index].info[i].btn[j].id == parent.infoBtn) {
                  itemList[index].info[i].btn.splice(j, 1);

                  break;
                }
              }
              break;
            }
          }
        } else if (itemList[index].fast.length > 0 && parent.fast != undefined) {
          for (let i = 0; i < itemList[index].fast.length; i++) {
            if (itemList[index].fast[i].id == parent.fast) {
              itemList[index].fast.splice(i, 1);

              break;
            }
          }
        }
      // }
    },
    removeMsgBoxSub(level, parent) {
      var itemList = this.getMsgLevelItem(this.msgBox, level);
      let removeList = [];

      // if(this.editPageType == false){
        if (itemList != null) {
          for (let i = 0; i < itemList.length; i++) {
            if (itemList[i].parent == parent.id) {
              if (
                parent.info != undefined &&
                parent.infoBtn != undefined &&
                itemList[i].parentInfo == parent.info &&
                itemList[i].parentInfoBtn == parent.infoBtn
              ) {
                removeList.push(i);
              } else if (
                parent.fast != undefined &&
                itemList[i].parentFast == parent.fast
              ) {
                removeList.push(i);
              }
            }
          }

          for (let r = removeList.length - 1; r >= 0; r--) {
            if(itemList[removeList[r]].info != '' && itemList[removeList[r]].info != null && typeof itemList[removeList[r]].info != 'undefined'){
              for (let i = 0; i < itemList[removeList[r]].info.length; i++) {
                if(itemList[removeList[r]].info[i].btn != '' && itemList[removeList[r]].info[i].btn != null && typeof itemList[removeList[r]].info[i].btn != 'undefined'){
                  for (
                    let j = 0;
                    j < itemList[removeList[r]].info[i].btn.length;
                    j++
                  ) {
                    this.removeMsgBoxSub(level + 1, {
                      id: itemList[removeList[r]].id,
                      info: itemList[removeList[r]].info[i].id,
                      infoBtn: itemList[removeList[r]].info[i].btn[j].id
                    });
                  }
                }
              }
            }

            if(itemList[removeList[r]].fast != '' && itemList[removeList[r]].fast != null && typeof itemList[removeList[r]].fast != 'undefined'){
              for (let i = 0; i < itemList[removeList[r]].fast.length; i++) {
                this.removeMsgBoxSub(level + 1, {
                  id: itemList[removeList[r]].id,
                  fast: itemList[removeList[r]].fast[i].id
                });
              }
            }

            itemList.splice(removeList[r], 1);
          }
        }
      // }
    },
    removeMsgBoxInfoConfirmed(id) {
      var t = this;

      // if(this.editPageType == false){
        this.$swal
          .fire({
            text: this.lang['views']['Msg']['methods']['removeMsgBoxInfoConfirmed']['swal_title'],
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#1D619F",
            confirmButtonText: this.lang['views']['Msg']['methods']['removeMsgBoxInfoConfirmed']['confirm_button']
          })
          .then(result => {
            if (result.isConfirmed) {
              t.removeMsgBoxInfo(id);
            }
          });
      // }
    },
    removeMsgBoxInfo(id) {
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList[index].info.length; i++) {
          if (itemList[index].info[i].id == id) {
            if (itemList[index].info[i].img != undefined) {
              itemList[index].info.splice(i, 1);
            } else if (itemList[index].info[i].video != undefined) {
              itemList[index].info.splice(i, 1);
            } else {
              for (let j = 0; j < itemList[index].info[i].btn.length; j++) {
                this.removeMsgBoxSub(this.msgActive.level + 1, {
                  id: itemList[index].id,
                  info: itemList[index].info[i].id,
                  infoBtn: itemList[index].info[i].btn[j].id
                });
              }
              itemList[index].info.splice(i, 1);
            }

            break;
          }
        }
      // }

      this.bezierRefresh();
    },
    removeMsgBoxFastConfirmed(id) {
      var t = this;

      // if(this.editPageType == false){
        this.$swal
          .fire({
            text: this.lang['views']['Msg']['methods']['removeMsgBoxFastConfirmed']['swal_title'],
            icon: "warning",
            showCancelButton: false,
            confirmButtonColor: "#1D619F",
            confirmButtonText: this.lang['views']['Msg']['methods']['removeMsgBoxFastConfirmed']['confirm_button']
          })
          .then(result => {
            if (result.isConfirmed) {
              t.removeMsgBoxFast(id);
            }
          });
      // }
    },
    removeMsgBoxFast(id) {
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

      // if(this.editPageType == false){
        for (let i = 0; i < itemList[index].fast.length; i++) {
          if (itemList[index].fast[i].id == id) {
            this.removeMsgBoxSub(this.msgActive.level + 1, {
              id: itemList[index].id,
              fast: itemList[index].fast[i].id
            });

            itemList[index].fast.splice(i, 1);

            break;
          }
        }
      // }

      this.bezierRefresh();
    },
    removeBotton(c_index, id, p_index){
      var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
      let index = this.getMsgBoxItemIndex(itemList, this.msgActive.id);

      console.log('btn index:'+c_index);
      console.log('info index:'+p_index);
      console.log('id:'+id);
      console.log('msgBox:');
      console.log(this.msgBox.item);
      console.log('itemList:');
      console.log(itemList);
      console.log('index:');
      console.log(index);

      let btn_text = itemList[index].info[p_index].btn[c_index].text

      this.$swal
        .fire({
          text: this.lang['views']['Msg']['methods']['removeBotton']['swal_title_a']+btn_text+this.lang['views']['Msg']['methods']['removeBotton']['swal_title_b'],
          icon: "warning",
          showCancelButton: false,
          confirmButtonColor: "#1D619F",
          confirmButtonText: this.lang['views']['Msg']['methods']['removeBotton']['confirm_button']
        })
        .then(result => {
          if (result.isConfirmed) {
            itemList[index].info[p_index].btn.splice(c_index, 1);
          }
        });
    },
    swapMsgInfo(index1, index2) {
      // if(this.editPageType == false){
        if (index2 >= 0) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          for (let i = 0; i < itemList.length; i++) {
            if (
              itemList[i].id == this.msgActive.id &&
              index2 < itemList[i].info.length
            ) {
              itemList[i].info = this.swapItems(itemList[i].info, index1, index2);
              break;
            }
          }
        }
      // }

      this.bezierRefresh();
    },
    swapMsgInfoBtn(index1, index2, btn_id) {
      // if(this.editPageType == false){
        console.log('swapMsgInfoBtn');
        console.log('index1:'+index1);
        console.log('index2:'+index2);

        console.log('btn_id');
        console.log(btn_id);

        console.log('swapMsgInfoBtn this.contentInfoBtn');
        console.log(this.contentInfoBtn);

        if (index2 >= 0) {
          let id = btn_id;//this.contentInfoBtn.contentId;
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);

          console.log('b id');
          console.log(id);
          console.log('itemList');
          console.log(itemList);

          // if(id == '' || id == null || typeof id == 'undefined'){
          //   id = btn_id;
          //   this.contentInfoBtn.contentId = btn_id
          // }

          console.log('a id');
          console.log(id);

          console.log('this.msgActive');
          console.log(this.msgActive);

          for (let i = 0; i < itemList.length; i++) {
            console.log('itemList['+i+'].id');
            console.log(itemList[i].id);
            console.log('itemList['+i+'].info');
            console.log(itemList[i].info);

            if (
              itemList[i].id == this.msgActive.id &&
              itemList[i].info.length > 0
            ) {
              console.log('#1');

              console.log('itemList['+i+'].id');
              console.log(itemList[i].id);
              for (let j = 0; j < itemList[i].info.length; j++) {
                console.log('itemList['+i+'].info['+j+'].id');
                console.log(itemList[i].info[j].id);

                console.log('itemList['+i+'].info['+j+'].btn.length');
                console.log(itemList[i].info[j].btn.length);
                console.log(itemList[i].info[j].id +'=='+ id +'&&'+ index2 +'<'+ itemList[i].info[j].btn.length);

                if (
                  itemList[i].info[j].id == id &&
                  index2 < itemList[i].info[j].btn.length
                ) {
                  console.log('#2');
                  console.log('b itemList['+i+'].info['+j+'].id');
                  console.log(itemList[i].info[j].id);
                  console.log('b itemList['+i+'].info['+j+'].btn');
                  console.log(itemList[i].info[j].btn);

                  itemList[i].info[j].btn = this.swapItems(
                    itemList[i].info[j].btn,
                    index1,
                    index2
                  );

                  console.log('a itemList['+i+'].info['+j+'].btn');
                  console.log(itemList[i].info[j].btn);

                  break;
                }
              }
              break;
            }
          }
        }
      // }

      this.bezierRefresh();
    },
    swapMsgFast(index1, index2) {
      // if(this.editPageType == false){
        if (index2 >= 0) {
          var itemList = this.getMsgLevelItem(this.msgBox, this.msgActive.level);
          for (let i = 0; i < itemList.length; i++) {
            if (
              itemList[i].id == this.msgActive.id &&
              index2 < itemList[i].fast.length
            ) {
              itemList[i].fast = this.swapItems(itemList[i].fast, index1, index2);
              break;
            }
          }
        }
      // }

      this.bezierRefresh();
    },
    swapItems(arr, index1, index2) {
      // if(this.editPageType == false){
        arr[index1] = arr.splice(index2, 1, arr[index1])[0];
        return arr;
      // }
    },
    bezierRefresh() {
      setTimeout(() => {
        // 更新貝茲曲線
        // eslint-disable-next-line no-undef
        $(".element").bezierRefresh();
      }, 0);
    },
    onImgUpload(event) {
      console.log('onImgUpload');
      console.log('event');
      console.log(event);
      console.log('event.target');
      console.log(event.target);
      console.log('event.target.files');
      console.log(event.target.files);
      console.log('event.target.files[0]');
      console.log(event.target.files[0]);
      // this.$emit('update:modelValue', event.target.files[0]);
      if(event.target.files[0] != '' && event.target.files[0] != null && typeof event.target.files[0] != 'undefined'){
        const permit_file = ['jpg','jpeg','gif','png','bmp','svg','webp','wmf','tiff','tif','svg'];

        var view_file_data = event.target.files[0];
        let file_name = event.target.files[0].name;
        let _tmp_file_extension = file_name.split('.');
        let file_extension = _tmp_file_extension[1].toLowerCase();

        let this_file_size = event.target.files[0].size;
        let file_size_limit = 25*1024*1024;

        let form_data = new FormData();
        form_data.append('s_code', this.$route.params.id);
        form_data.append('data_type', 'image');
        form_data.append('file', view_file_data);

        console.log(this_file_size +'<'+ file_size_limit);

        if(permit_file.indexOf(file_extension) != -1){
          if(this_file_size < file_size_limit){
            axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_messages_upload.php', form_data,{
                headers: {
                  "Content-Type": 'multipart/form-data'
                }
              })
              .then((response) => {
                console.log(response);
                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['views']['Msg']['methods']['onImgUpload']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      axios
                        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.img = {
                              imgList: response.data.return_data,
                              imgListApi: response.data.return_data_api
                            }

                            // this.showImgWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    } else if (result.isDenied) {
                      axios
                        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.img = {
                              imgList: response.data.return_data,
                              imgListApi: response.data.return_data_api
                            }

                            // this.showImgWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    }
                  })
                } else {
                  Swal.fire(
                              this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                              response.data.info,
                              response.data.status
                            )
                }
              });
          } else {
            Swal.fire(
                        this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                        this.lang['views']['Msg']['methods']['onImgUpload']['upload_size_error_swal_text'],
                        "error"
                      )
          }
        } else {
          Swal.fire(
                      this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                      this.lang['views']['Msg']['methods']['onImgUpload']['upload_type_error_swal_text'],
                      "error"
                    )
        }
      } else {
        Swal.fire(
                    this.lang['views']['Msg']['methods']['onImgUpload']['swal_title'],
                    this.lang['views']['Msg']['methods']['onImgUpload']['upload_select_error_swal_text'],
                    "warning"
                  )
      }
    },

    onVideoUpload(event) {
      console.log('onVideoUpload');
      console.log('event');
      console.log(event);
      console.log('event.target');
      console.log(event.target);
      console.log('event.target.files');
      console.log(event.target.files);
      console.log('event.target.files[0]');
      console.log(event.target.files[0]);
      // this.$emit('update:modelValue', event.target.files[0]);

      if(event.target.files[0] != '' && event.target.files[0] != null && typeof event.target.files[0] != 'undefined'){
        const permit_file = ['mp4','avi','flv','wmv','mov','mkv','rm','rmvb','mpg','mpeg','3gp'];

        var view_file_data = event.target.files[0];
        let file_name = event.target.files[0].name;
        let _tmp_file_extension = file_name.split('.');
        let file_extension = _tmp_file_extension[1].toLowerCase();

        let this_file_size = event.target.files[0].size;
        let file_size_limit = 25*1024*1024;

        let form_data = new FormData();
        form_data.append('s_code', this.$route.params.id);
        form_data.append('data_type', 'image');
        form_data.append('file', view_file_data);

        if(permit_file.indexOf(file_extension) != -1){
          if(this_file_size < file_size_limit){
            axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_messages_upload.php', form_data,{
                headers: {
                  "Content-Type": 'multipart/form-data'
                }
              })
              .then((response) => {
                console.log(response);
                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['views']['Msg']['methods']['onVideoUpload']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      axios
                        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.video = {
                              videoList: response.data.return_data,
                              videoListApi: response.data.return_data_api
                            }

                            // this.showVideoWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    } else if (result.isDenied) {
                      axios
                        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                          s_code: this.$route.params.id,
                          page_id: this.pageId,
                          type: 'update'
                        }))
                        .then((response) => {
                          if(response.data.status == 'success'){
                            this.video = {
                              videoList: response.data.return_data,
                              videoListApi: response.data.return_data_api
                            }

                            // this.showVideoWindows = true;
                            // this.showContentTypeWindows = false;

                            // if (id != null) this.contentInfoTypeWindowsId = id;
                            // else this.contentInfoTypeWindowsId = null;

                            // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                            // else this.contentInfoTypeWindowsEditType = null;
                          }
                        });
                    }
                  })
                } else {
                  Swal.fire(
                              this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                              response.data.info,
                              response.data.status
                            )
                }
              });
          } else {
            Swal.fire(
                        this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                        this.lang['views']['Msg']['methods']['onVideoUpload']['upload_size_error_swal_text'],
                        "error"
                      )
          }
        } else {
          Swal.fire(
                      this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                      this.lang['views']['Msg']['methods']['onVideoUpload']['upload_type_error_swal_text'],
                      "error"
                    )
        }
      } else {
        Swal.fire(
                    this.lang['views']['Msg']['methods']['onVideoUpload']['swal_title'],
                    this.lang['views']['Msg']['methods']['onVideoUpload']['upload_select_error_swal_text'],
                    "warning"
                  )
      }
    },
    deleteUpload(id, type){
      console.log('deleteUpload');
      console.log('id:'+id+'，type:'+type);

      if(id != '' && id != null && typeof id != 'undefined'){
        Swal.fire({
          title: this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
          html: this.lang['views']['Msg']['methods']['deleteUpload']['id_swal_text'],
          icon: 'warning',
          showCancelButton: true,
          confirmButtonColor: '#3085d6',
          cancelButtonColor: '#d33',
          confirmButtonText: this.lang['views']['Msg']['methods']['deleteUpload']['yes_button'],
          cancelButtonText: this.lang['views']['Msg']['methods']['deleteUpload']['cancel_button'],
        }).then((result) => {
          if (result.isConfirmed) {
            console.log('yes');

            axios
              .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_messages_upload_delete.php', Qs.stringify({
                s_code: this.$route.params.id,
                media: id,
              }))
              .then((response) => {
                console.log(response.data);
                if(response.data.status == 'success'){
                  Swal.fire({
                    icon: response.data.status,
                    title: this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
                    text: response.data.info,
                    showDenyButton: false,
                    showCancelButton: false,
                    confirmButtonText: this.lang['views']['Msg']['methods']['deleteUpload']['confirm_button'],
                    // denyButtonText: `Don't save`,
                  }).then((result) => {
                    if (result.isConfirmed) {
                      if(type == 'image'){
                        axios
                          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.img = {
                                imgList: response.data.return_data,
                                imgListApi: response.data.return_data_api
                              }

                              // this.showImgWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      } else {
                        axios
                          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.video = {
                                videoList: response.data.return_data,
                                videoListApi: response.data.return_data_api
                              }

                              // this.showVideoWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      }
                    } else if (result.isDenied) {
                      if(type == 'image'){
                        axios
                          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.img = {
                                imgList: response.data.return_data,
                                imgListApi: response.data.return_data_api
                              }

                              // this.showImgWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      } else {
                        axios
                          .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
                            s_code: this.$route.params.id,
                            page_id: this.pageId,
                            type: 'update'
                          }))
                          .then((response) => {
                            if(response.data.status == 'success'){
                              this.video = {
                                videoList: response.data.return_data,
                                videoListApi: response.data.return_data_api
                              }

                              // this.showVideoWindows = true;
                              // this.showContentTypeWindows = false;

                              // if (id != null) this.contentInfoTypeWindowsId = id;
                              // else this.contentInfoTypeWindowsId = null;

                              // if (editType != null) this.contentInfoTypeWindowsEditType = editType;
                              // else this.contentInfoTypeWindowsEditType = null;
                            }
                          });
                      }
                    }
                  })
                } else {
                  Swal.fire(
                              this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
                              response.data.info,
                              response.data.status
                            )
                }
              });
          }
        });
      } else {
        Swal.fire(
                    this.lang['views']['Msg']['methods']['deleteUpload']['swal_title'],
                    this.lang['views']['Msg']['methods']['deleteUpload']['not_id_swal_text'],
                    "warning"
                  )
      }
    },
    creativesId(value){
      console.log('creativesId');
      console.log(value);

      let _tmpPostDataSelectCreatives = this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives;

      console.log('_tmpPostDataSelectCreatives');
      console.log(_tmpPostDataSelectCreatives);

      // let combinedArray = [...new Set([..._tmpPostDataSelectCreatives, ...value])];

      // this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives = combinedArray;

      console.log('fin creativesId');
      console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex]);
    },
    imageUpdate(){
      console.log('imageUpdate');
      this.showImgWindows = true;
      this.showImgLoading = false;
      this.img = {
        imgList: [],
        imgListApi: []
      }

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_photo.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId,
          type: 'update'
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.img = {
              imgList: response.data.return_data,
              imgListApi: response.data.return_data_api
            }
          }

          this.showImgLoading = true;
        });
    },
    videoUpdate(){
      console.log('videoUpdate');
      this.showMsgVideoWindows = true;
      this.showVideoLoading = false;
      this.video = {
        videoList: [],
        videoListApi: []
      }

      axios
        .post('https://test.autoturn.net/inside/api/customize/campaign/campaign_form_welcome_messages_video.php', Qs.stringify({
          s_code: this.$route.params.id,
          page_id: this.pageId,
          type: 'update'
        }))
        .then((response) => {
          if(response.data.status == 'success'){
            this.video = {
              videoList: response.data.return_data,
              videoListApi: response.data.return_data_api
            }
          }

          this.showVideoLoading = true;
        });
    },
    postDataUdate(newValue){
      console.log(this.stageIndex);

      console.log('postDataUdate stageContenttData.postData');
      console.log(this.stageContentAllData);

      if(this.stageIndex > 0){
        let _beforeIndex = this.stageIndex - parseInt(1);

        console.log(this.stageContentAllData.subCampaignsContent);
        console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex]);
        console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData);
        let _newDataSpecialAdCategory = newValue.special_ad_category;
        let _newDataCreativeOptimize = newValue.creative_optimize;
        let _newDataSelectArticle = JSON.stringify(newValue.select_article);
        let _newDataDbSelectArticle = JSON.stringify(newValue.db_select_article);

        let _newDataSelectCreatives = JSON.stringify(newValue.select_creatives);/////////////
        console.log('b _newDataSelectCreatives');
        console.log(_newDataSelectCreatives);
        if(_newDataSelectCreatives.length > 0){
          _newDataSelectCreatives.forEach(item => delete item.imgSrc);
        }
        console.log('a _newDataSelectCreatives');
        console.log(_newDataSelectCreatives);

        let _newDataDbSelectCreatives = JSON.stringify(newValue.db_select_creatives);
        let _newDataSelectCreativesMessage = JSON.stringify(newValue.select_creatives_message);
        let _newDataDbSelectCreativesMessage = JSON.stringify(newValue.db_select_creatives_message);
        let _newDataSelectCreativesAdsetAds = JSON.stringify(newValue.select_creatives_adset_ads);
        let _newDataDbSelectCreativesAdsetAds = JSON.stringify(newValue.db_select_creatives_adset_ads);
        let _newDataSelectCreativesAdsetAdsMessage = JSON.stringify(newValue.select_creatives_adset_ads_message);
        let _newDataDbSelectCreativesAdsetAdsMessage = JSON.stringify(newValue.db_select_creatives_adset_ads_message);

        let _oldDataSpecialAdCategory = this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.special_ad_category;
        let _oldDataCreativeOptimize = this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.creative_optimize;
        let _oldDataSelectArticle = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.select_article);
        let _oldDataDbSelectArticle = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.db_select_article);

        let _oldDataSelectCreatives = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.select_creatives);/////////////
        console.log('b _oldDataSelectCreatives');
        console.log(_oldDataSelectCreatives);
        if(_oldDataSelectCreatives.length > 0){
          _oldDataSelectCreatives.forEach(item => delete item.imgSrc);
        }
        console.log('a _oldDataSelectCreatives');
        console.log(_oldDataSelectCreatives);

        let _oldDataDbSelectCreatives = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.db_select_creatives);
        let _oldDataSelectCreativesMessage = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.select_creatives_message);
        let _oldDataDbSelectCreativesMessage = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.db_select_creatives_message);
        let _oldDataSelectCreativesAdsetAds = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.select_creatives_adset_ads);
        let _oldDataAbSelectCreativesAdsetAds = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.db_select_creatives_adset_ads);
        let _oldDataSelectCreativesAdsetAdsMessage = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.select_creatives_adset_ads_message);
        let _oldDataDbSelectCreativesAdsetAdsMessage = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].postData.db_select_creatives_adset_ads_message);

        //思考自訂素材如何檢測

        console.log('_newDataSpecialAdCategory',_newDataSpecialAdCategory);
        console.log('_oldDataSpecialAdCategory', _oldDataSpecialAdCategory);
        console.log('_newDataCreativeOptimize', _newDataCreativeOptimize);
        console.log('_oldDataCreativeOptimize', _oldDataCreativeOptimize);
        console.log('_newDataSelectArticle', _newDataSelectArticle);
        console.log('_oldDataSelectArticle', _oldDataSelectArticle);
        console.log('_newDataDbSelectArticle', _newDataDbSelectArticle);
        console.log('_oldDataDbSelectArticle', _oldDataDbSelectArticle);
        console.log('_newDataSelectCreatives', _newDataSelectCreatives);
        console.log('_oldDataSelectCreatives', _oldDataSelectCreatives);
        console.log('_newDataDbSelectCreatives', _newDataDbSelectCreatives);
        console.log('_oldDataDbSelectCreatives', _oldDataDbSelectCreatives);
        console.log('_newDataSelectCreativesMessage', _newDataSelectCreativesMessage);
        console.log('_oldDataSelectCreativesMessage', _oldDataSelectCreativesMessage);
        console.log('_newDataDbSelectCreativesMessage', _newDataDbSelectCreativesMessage);
        console.log('_oldDataDbSelectCreativesMessage', _oldDataDbSelectCreativesMessage);
        console.log('_newDataSelectCreativesAdsetAds', _newDataSelectCreativesAdsetAds);
        console.log('_oldDataSelectCreativesAdsetAds', _oldDataSelectCreativesAdsetAds);
        console.log('_newDataDbSelectCreativesAdsetAds', _newDataDbSelectCreativesAdsetAds);
        console.log('_oldDataAbSelectCreativesAdsetAds', _oldDataAbSelectCreativesAdsetAds);
        console.log('_newDataSelectCreativesAdsetAdsMessage', _newDataSelectCreativesAdsetAdsMessage);
        console.log('_oldDataSelectCreativesAdsetAdsMessage', _oldDataSelectCreativesAdsetAdsMessage);
        console.log('_newDataDbSelectCreativesAdsetAdsMessage', _newDataDbSelectCreativesAdsetAdsMessage);
        console.log('_oldDataDbSelectCreativesAdsetAdsMessage', _oldDataDbSelectCreativesAdsetAdsMessage);
        console.log('newValue.ditto_creative', newValue.ditto_creative);

        if((_newDataSpecialAdCategory == _oldDataSpecialAdCategory) && (_newDataCreativeOptimize == _oldDataCreativeOptimize) && (_newDataSelectArticle == _oldDataSelectArticle) && (_newDataDbSelectArticle == _oldDataDbSelectArticle) && (_newDataSelectCreatives == _oldDataSelectCreatives) && (_newDataDbSelectCreatives == _oldDataDbSelectCreatives) && (_newDataSelectCreativesMessage == _oldDataSelectCreativesMessage) && (_newDataDbSelectCreativesMessage == _oldDataDbSelectCreativesMessage) && (_newDataSelectCreativesAdsetAds == _oldDataSelectCreativesAdsetAds) && (_newDataDbSelectCreativesAdsetAds == _oldDataAbSelectCreativesAdsetAds) && (_newDataSelectCreativesAdsetAdsMessage == _oldDataSelectCreativesAdsetAdsMessage) && (_newDataDbSelectCreativesAdsetAdsMessage == _oldDataDbSelectCreativesAdsetAdsMessage) && newValue.ditto_creative == true){
          console.log('#1一樣');
          console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative);
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative = true;
          console.log('#1一樣');
          console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative);
        } else {
          console.log('#2不一樣');
          console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative);
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative = false;
          console.log('#2不一樣');
          console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative);
        }
      }

      let subLength =  this.stageContentAllData.subCampaignsContent.length;
      console.log('this.stageIndex');
      console.log(this.stageIndex);
      for(let i = this.stageIndex; i < subLength; i++){
        let nextIndex = i + parseInt(1);
        console.log(i+' : '+nextIndex+'，this.stageContentAllData.subCampaignsContent[nextIndex]');
        if(this.stageContentAllData.subCampaignsContent[nextIndex] != null && this.stageContentAllData.subCampaignsContent[nextIndex] != null && typeof this.stageContentAllData.subCampaignsContent[nextIndex] != 'undefined'){
          console.log(this.stageContentAllData.subCampaignsContent[nextIndex]);
          if(this.stageContentAllData.subCampaignsContent[nextIndex].postData.ditto_creative == true || this.stageContentAllData.haveTest == true){
            console.log(this.stageContentAllData.subCampaignsContent[nextIndex].postData.ditto_creative);
            console.log(this.stageContentAllData.haveTest);
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.special_ad_category = this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.special_ad_category;
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.creative_optimize = this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.creative_optimize;
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_article = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_article));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_article = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_article));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_message));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_message));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives_adset_ads = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_adset_ads));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives_adset_ads = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_adset_ads));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.select_creatives_adset_ads_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.select_creatives_adset_ads_message));
            this.stageContentAllData.subCampaignsContent[nextIndex].postData.db_select_creatives_adset_ads_message = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.db_select_creatives_adset_ads_message));

            console.log(this.stageContentAllData.subCampaignsContent[nextIndex].postData);
          } else {
            console.log('break');
            break;
          }
        }
      }

      console.log('stageContenttData.postData b this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    adMaterialDataUdate(newValue){
      console.log(this.stageIndex);

      console.log('stageContenttData.adMaterialData');
      console.log(this.stageContentAllData);

      if(this.stageIndex > 0){
        let _beforeIndex = this.stageIndex - parseInt(1);

        console.log(this.stageContentAllData.subCampaignsContent);
        console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex]);
        console.log(this.stageContentAllData.subCampaignsContent[_beforeIndex].adMaterialData);
        let _newDataCreativeOptimize = newValue.creative_optimize;
        let _newDataCreativeArray = JSON.stringify(newValue.creative_array);

        let _oldDataCreativeOptimize = this.stageContentAllData.subCampaignsContent[_beforeIndex].adMaterialData.creative_optimize;
        let _oldDataCreativeArray = JSON.stringify(this.stageContentAllData.subCampaignsContent[_beforeIndex].adMaterialData.creative_array);


        //思考自訂素材如何檢測

        console.log('_newDataCreativeOptimize');
        console.log(_newDataCreativeOptimize);
        console.log('_oldDataCreativeOptimize');
        console.log(_oldDataCreativeOptimize);
        console.log('_newDataCreativeArray');
        console.log(_newDataCreativeArray);
        console.log('_oldDataCreativeArray');
        console.log(_oldDataCreativeArray);
        console.log('this.stageContentAllData.subCampaignsContent['+this.stageIndex+'].postData.ditto_creative');
        console.log(this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative);
        // console.log(newValue.ditto_local);

        if((_newDataCreativeOptimize == _oldDataCreativeOptimize) && (_newDataCreativeArray == _oldDataCreativeArray) && this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative == true){
          console.log('#一樣');
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative = true;
        } else {
          console.log('#不一樣');
          this.stageContentAllData.subCampaignsContent[this.stageIndex].postData.ditto_creative = false;
        }
      }

      let subLength =  this.stageContentAllData.subCampaignsContent.length;
      console.log('0');
      console.log(this.stageIndex);
      for(let i = this.stageIndex; i < subLength; i++){
        let nextIndex = i + parseInt(1);
        console.log(i+' : '+nextIndex+'，this.stageContentAllData.subCampaignsContent[nextIndex]');
        if(this.stageContentAllData.subCampaignsContent[nextIndex] != null && this.stageContentAllData.subCampaignsContent[nextIndex] != null && typeof this.stageContentAllData.subCampaignsContent[nextIndex] != 'undefined'){
          console.log(this.stageContentAllData.subCampaignsContent[nextIndex]);
          if(this.stageContentAllData.subCampaignsContent[nextIndex].postData.ditto_creative == true){
            console.log(this.stageContentAllData.subCampaignsContent[nextIndex].postData.ditto_creative);
            this.stageContentAllData.subCampaignsContent[nextIndex].adMaterialData.creative_optimize = this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData.creative_optimize;
            this.stageContentAllData.subCampaignsContent[nextIndex].adMaterialData.creative_array = JSON.parse(JSON.stringify(this.stageContentAllData.subCampaignsContent[this.stageIndex].adMaterialData.creative_array));
            console.log(this.stageContentAllData.subCampaignsContent[nextIndex].adMaterialData);
          } else {
            console.log('break');
            break;
          }
        }
      }

      console.log('stageContenttData.adMaterialData b this.stageContentAllData');
      console.log(this.stageContentAllData);
    },
    useAi(event, type, main_index, item_index){
      console.log('useAi');
      console.log(event);
      console.log(type);
      console.log(main_index);
      console.log(item_index);

      this.aiWord = null;
      this.aiType = type;
      this.aiMainIndex = main_index;
      this.aiItemIndex = item_index;
      this.aiContentProcessing = false;

      const element = event.currentTarget;

      // if (element) {
        const rect = element.getBoundingClientRect();
        console.log('元素位置信息：', rect);
        console.log('元素顶部位置：', rect.top);
        console.log('元素左侧位置：', rect.left);
        // 可以根据需求进一步处理位置信息
        this.ai_x = parseInt(rect.left) + parseInt(100);
        this.ai_y = parseInt(rect.top);
      // } else {
      //   console.error('未找到具有指定类名的元素');
      // }

      // let aiWindowWidth = window.innerWidth;
      // let aiWindowHeight = window.innerHeight;

      // console.log('aiWindowWidth');
      // console.log(aiWindowWidth);
      // console.log('aiWindowHeight');
      // console.log(aiWindowHeight);

      // this.ai_x = aiWindowWidth - parseInt(550);
      // this.ai_y = aiWindowHeight - parseInt(400);
      let labelMainIndex = main_index + parseInt(1);
      let labelItemIndex = item_index + parseInt(1);

      switch(type){
        case 'single_message':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組的『主要文字』';
          break;
        case 'single_title':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組的『標題』';
          break;
        case 'single_description':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組的『說明』';
          break;
        case 'carousel_title':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組，第 '+labelItemIndex+' 張輪播卡片的『標題』';
          break;
        case 'carousel_description':
          this.formTarget = '針對第 '+labelMainIndex+' 則廣告組，第 '+labelItemIndex+' 張輪播卡片的『說明』';
          break;
      }

      console.log('ai_x');
      console.log(this.ai_x);
      console.log('ai_y');
      console.log(this.ai_y);

      this.itemCheckedIndex = null;
      this.aiContentReturn = [];
      this.view_ai = true;
    },
    generateCopy(){
      console.log('generateCopy');
      console.log(this.aiWord);

      let aiContent = this.aiWord;

      if(this.aiContentProcessing == false){
        if(aiContent != null && aiContent != '' && typeof aiContent != 'undefined'){
          this.processText = '生成中...';
          this.aiContentProcessing = true;
          let _tmpAiContent = aiContent.trim();

          axios
            .post('https://test.autoturn.net/inside/api/ai/ai_material_copywriting_dev_02.php', Qs.stringify({
              s_code: this.$route.params.id,
              type: this.aiType,
              content: _tmpAiContent
            }))
            .then((response) => {
              if(response.data.status == 'success'){
                // switch(this.aiType){
                //   case 'single_message':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].message = response.data.return_data;
                //     break;
                //   case 'single_title':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].title = response.data.return_data;
                //     break;
                //   case 'single_description':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].description = response.data.return_data;
                //     break;
                //   case 'carousel_title':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].title = response.data.return_data;
                //     break;
                //   case 'carousel_description':
                //     this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].description = response.data.return_data;
                //     break;
                // }

                this.aiContentReturn = response.data.return_data;
              }

              this.processText = '產生';
              this.aiContentProcessing = false;

              console.log('this.viewAdMaterialDatalistData.creative_array');
              console.log(this.viewAdMaterialDatalistData.creative_array);

              // this.view_ai = false;
            });
        } else {
          Swal.fire(
            '生成文案',
            '請輸入要產生的文案大綱。',
            "warning"
          );
        }
      } else {
        Swal.fire(
          '生成文案',
          '文案生成中，請稍等。',
          "warning"
        );
      }
    },
    setAiContent(){
      console.log('setAiContent');
      console.log(this.aiWord);
      console.log('this.aiContentReturn');
      console.log(this.aiContentReturn);
      console.log('this.itemCheckedIndex');
      console.log(this.itemCheckedIndex);

      // let aiContent = this.aiWord;

      let aiContentReturnLength = this.aiContentReturn.length;

      if(aiContentReturnLength > 0){
        if(this.aiContentReturn[this.itemCheckedIndex].content != null && this.aiContentReturn[this.itemCheckedIndex].content != '' && typeof this.aiContentReturn[this.itemCheckedIndex].content != 'undefined'){
          switch(this.aiType){
            case 'single_message':
              this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].message = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'single_title':
              this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].title = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'single_description':
              this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].description = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'carousel_title':
              this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].title = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
            case 'carousel_description':
              this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].description = this.aiContentReturn[this.itemCheckedIndex].content;
              break;
          }

          this.view_ai = false;
        }

        if(this.itemCheckedIndex == null){
          Swal.fire(
            '生成文案',
            '請選擇要使用的文案',
            "warning"
          );
        }

        // if(this.aiContentProcessing == false){
        //   if(aiContent != null && aiContent != '' && typeof aiContent != 'undefined'){
        //     this.processText = '生成中...';
        //     this.aiContentProcessing = true;
        //     let _tmpAiContent = aiContent.trim();

        //     axios
        //       .post('https://test.autoturn.net/inside/api/ai/ai_material_copywriting.php', Qs.stringify({
        //         s_code: this.$route.params.id,
        //         type: this.aiType,
        //         content: _tmpAiContent
        //       }))
        //       .then((response) => {
        //         if(response.data.status == 'success'){
        //           switch(this.aiType){
        //             case 'single_message':
        //               this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].message = response.data.return_data;
        //               break;
        //             case 'single_title':
        //               this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].title = response.data.return_data;
        //               break;
        //             case 'single_description':
        //               this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materialSingle[0].description = response.data.return_data;
        //               break;
        //             case 'carousel_title':
        //               this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].title = response.data.return_data;
        //               break;
        //             case 'carousel_description':
        //               this.viewAdMaterialDatalistData.creative_array[this.aiMainIndex].materials[this.aiItemIndex].description = response.data.return_data;
        //               break;
        //           }
        //         }

        //         this.processText = '產生';
        //         this.aiContentProcessing = false;

        //         console.log('this.viewAdMaterialDatalistData.creative_array');
        //         console.log(this.viewAdMaterialDatalistData.creative_array);

        //         this.view_ai = false;
        //       });
        //   } else {
        //     Swal.fire(
        //       '生成文案',
        //       '請輸入要產生的文案大綱。',
        //       "warning"
        //     );
        //   }
        // } else {
        //   Swal.fire(
        //     '生成文案',
        //     '文案生成中，請稍等。',
        //     "warning"
        //   );
        // }
      } else {
        Swal.fire(
          '生成文案',
          '請先產生文案。',
          "warning"
        );
      }
    },
    editAiPicture(){
      this.showAiPictureModal = true;
    },
    triggerFileInput() {
      this.$refs.fileInput.click();
    },
    onFilesSelected(event) {
      const newFiles = Array.from(event.target.files);

      newFiles.forEach((file) => {
        const exists = this.selectedFiles.some((f) => f.name === file.name);

        if (!exists) {
          const previewUrl = URL.createObjectURL(file);
          this.selectedFiles.push({ file, name: file.name, previewUrl });
        }
      });

      event.target.value = null;
    },
    removeFile(index) {
      const file = this.selectedFiles[index];
      URL.revokeObjectURL(file.previewUrl);
      this.selectedFiles.splice(index, 1);
    },
    async uploadImages() {
      if (this.selectedFiles.length === 0) {
        Swal.fire(
          '多圖上傳至廣告帳戶',
          '請選擇要上傳的圖片。',
          "info"
        );
        return;
      }

      this.isUploading = true;
      this.uploadResults = [];

      // for (const fileObj of this.selectedFiles) {
      for (let i = 0; i < this.selectedFiles.length; i++) {
        const fileObj = this.selectedFiles[i];

        try {
          const formData = new FormData();
          formData.append("image", fileObj.file);
          formData.append('adaccount_id', this.$route.params.adaccount_id);
          formData.append('s_code', this.$route.params.id);

          const response = await axios.post("https://test.autoturn.net/inside/api/customize/campaign/adimage_update.php", formData, {
            headers: { "Content-Type": "multipart/form-data" },
          });

          this.uploadResults.push({
            fileName: fileObj.name,
            previewUrl: fileObj.previewUrl,
            success: response.data.status === "success",
          });
        } catch (error) {
          console.error("上傳失敗：", error);
          this.uploadResults.push({
            fileName: fileObj.name,
            previewUrl: fileObj.previewUrl,
            success: false,
          });
        }

        this.selectedFiles.splice(i, 1);
        i--;
      }

      this.selectedFiles = [];
      this.isUploading = false;
      this.useUpload = true;
    },
  },
  computed: {
    editPageType: {
      get: function () {
        return this.editPage
      },
      set: function (value) {
        this.$emit('update:editPageType', value)
      },
    },
    viewDatalistData: {
      get: function () {
        return this.viewDatalist
      },
      set: function (value) {
        this.$emit('update:viewDatalistData', value)
      },
    },
    stageContenttData:{
      get: function () {
        return this.stageContent
      },
      set: function (value) {
        this.$emit('update:stageContenttData', value)
      },
    },
    stageContentAllData:{
      get: function () {
        return this.stageContentAll
      },
      set: function (value) {
        this.$emit('update:stageContentAllData', value)
      },
    },
    viewAdMaterialDatalistData: {
      get: function () {
        return this.viewAdMaterialDatalist
      },
      set: function (value) {
        this.$emit('update:viewAdMaterialDatalistData', value)
      },
    },
    pageIdData: {
      get: function () {
        return this.pageId
      },
      set: function (value) {
        this.$emit('update:pageIdData', value)
      },
    },
    campaignIdData: {
      get: function () {
        return this.campaignId
      },
      set: function (value) {
        this.$emit('update:campaignIdData', value)
      },
    },
    goalsObjectiveData: {
      get: function () {
        return this.goalsObjective
      },
      set: function (value) {
        this.$emit('update:goalsObjectiveData', value)
      },
    }
  }
};
</script>

<style lang="scss" scoped>
  .status-n {
    background-color:#E6F7DD;
  }

  ::v-deep(.tab) {
    .p-tabview .p-tabview-nav {
      display: none;
    }

    .p-tabview .p-tabview-panels {
      padding: 0px;
    }
  }


  .upload-multiple-container {
    /*max-width: 500px;*/
    margin: 0 auto;
    padding: 20px;
    border: 1px solid #ddd;
    border-radius: 5px;
    background-color: #f9f9f9;
  }

  .title {
    text-align: center;
    font-size: 1.5em;
    margin-bottom: 20px;
  }

  .actions {
    display: flex;
    gap: 10px;
    justify-content: center;
    margin-bottom: 20px;
  }

  .custom-upload-btn,
  .upload-btn {
    padding: 10px 20px;
    font-size: 1em;
    border-radius: 5px;
    border: none;
    cursor: pointer;
  }

  .custom-upload-btn {
    background-color: #007bff;
    color: white;
  }

  .upload-btn {
    background-color: #28a745;
    color: white;
  }

  .hidden {
    display: none;
  }

  .preview-list {
    margin-top: 20px;
  }

  .preview-image {
    max-width: 100px;
    max-height: 100px;
    object-fit: cover;
    margin-right: 10px;
  }

  .file-item {
    display: flex;
    align-items: center;
    margin-bottom: 10px;
  }

  .file-info {
    display: flex;
    align-items: center;
    gap: 10px;
  }

  .file-name {
    flex: 1;
    word-wrap: break-word;
  }

  .remove-btn {
    background-color: #dc3545;
    color: white;
    padding: 5px 10px;
    border: none;
    border-radius: 3px;
    cursor: pointer;
  }

  .upload-results {
    margin-top: 20px;
  }
</style>